webpackJsonp([22676092666560,60335399758886],{

/***/ 100:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(166);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(100);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(10), __webpack_require__(21));
		else if(typeof define === 'function' && define.amd)
			define(["mobx", "mobx-state-tree"], factory);
		else if(typeof exports === 'object')
			exports["mobxDevtoolsMST"] = factory(require("mobx"), require("mobx-state-tree"));
		else
			root["mobxDevtoolsMST"] = factory(root["mobx"], root["mobxStateTree"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_69__, __WEBPACK_EXTERNAL_MODULE_70__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 36);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__(3);
	var createDesc = __webpack_require__(10);
	module.exports = __webpack_require__(4) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(7);
	var IE8_DOM_DEFINE = __webpack_require__(28);
	var toPrimitive = __webpack_require__(16);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(9)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(47);
	var defined = __webpack_require__(13);
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var store = __webpack_require__(20)('wks');
	var uid = __webpack_require__(11);
	var Symbol = __webpack_require__(0).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(8);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = true;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(8);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = {};
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(32);
	var enumBugKeys = __webpack_require__(21);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var shared = __webpack_require__(20)('keys');
	var uid = __webpack_require__(11);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var def = __webpack_require__(3).f;
	var has = __webpack_require__(1);
	var TAG = __webpack_require__(6)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	exports.f = __webpack_require__(6);
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var core = __webpack_require__(15);
	var LIBRARY = __webpack_require__(14);
	var wksExt = __webpack_require__(23);
	var defineProperty = __webpack_require__(3).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
	exports.f = {}.propertyIsEnumerable;
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var LIBRARY = __webpack_require__(14);
	var $export = __webpack_require__(27);
	var redefine = __webpack_require__(30);
	var hide = __webpack_require__(2);
	var has = __webpack_require__(1);
	var Iterators = __webpack_require__(17);
	var $iterCreate = __webpack_require__(45);
	var setToStringTag = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(52);
	var ITERATOR = __webpack_require__(6)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(0);
	var core = __webpack_require__(15);
	var ctx = __webpack_require__(43);
	var hide = __webpack_require__(2);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = !__webpack_require__(4) && !__webpack_require__(9)(function () {
	  return Object.defineProperty(__webpack_require__(29)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(8);
	var document = __webpack_require__(0).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(2);
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(7);
	var dPs = __webpack_require__(46);
	var enumBugKeys = __webpack_require__(21);
	var IE_PROTO = __webpack_require__(19)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(29)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(51).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var has = __webpack_require__(1);
	var toIObject = __webpack_require__(5);
	var arrayIndexOf = __webpack_require__(48)(false);
	var IE_PROTO = __webpack_require__(19)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {
	
	exports.f = Object.getOwnPropertySymbols;
	
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(32);
	var hiddenKeys = __webpack_require__(21).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _mobx = __webpack_require__(69);
	
	var mobx = _interopRequireWildcard(_mobx);
	
	var _mobxStateTree = __webpack_require__(70);
	
	var libmst = _interopRequireWildcard(_mobxStateTree);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-line
	
	var track = function track(root) {
	  var hook = global.__MOBX_DEVTOOLS_GLOBAL_HOOK__; // eslint-disable-line no-underscore-dangle
	  if (hook && hook.inject) hook.inject({ mobx: mobx, mst: libmst });
	
	  if (!hook) return;
	
	  var _loop = function _loop(mobxid) {
	    if (Object.prototype.hasOwnProperty.call(hook.collections, mobxid)) {
	      var mst = hook.collections[mobxid].mst;
	
	      if (mst && mst.isStateTreeNode(root) && mst.isRoot(root)) {
	        hook.emit('mst-root', { root: root, mobxid: mobxid });
	        var disposer = hook.sub('get-mst-roots', function () {
	          return hook.emit('mst-root', { root: root, mobxid: mobxid });
	        });
	        mst.addDisposer(root, disposer);
	        return {
	          v: void 0
	        };
	      }
	    }
	  };
	
	  for (var mobxid in hook.collections) {
	    var _ret = _loop(mobxid);
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	  }
	}; // eslint-disable-line
	
	exports.default = function (root) {
	  track(root);
	  return root;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(39);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(58);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(40), __esModule: true };
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(41);
	__webpack_require__(54);
	module.exports = __webpack_require__(23).f('iterator');
	
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $at = __webpack_require__(42)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(26)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});
	
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(12);
	var defined = __webpack_require__(13);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// optional / simple context binding
	var aFunction = __webpack_require__(44);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var create = __webpack_require__(31);
	var descriptor = __webpack_require__(10);
	var setToStringTag = __webpack_require__(22);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(2)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__(3);
	var anObject = __webpack_require__(7);
	var getKeys = __webpack_require__(18);
	
	module.exports = __webpack_require__(4) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(33);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(5);
	var toLength = __webpack_require__(49);
	var toAbsoluteIndex = __webpack_require__(50);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(12);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(12);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var document = __webpack_require__(0).document;
	module.exports = document && document.documentElement;
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(1);
	var toObject = __webpack_require__(53);
	var IE_PROTO = __webpack_require__(19)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(13);
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(55);
	var global = __webpack_require__(0);
	var hide = __webpack_require__(2);
	var Iterators = __webpack_require__(17);
	var TO_STRING_TAG = __webpack_require__(6)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var addToUnscopables = __webpack_require__(56);
	var step = __webpack_require__(57);
	var Iterators = __webpack_require__(17);
	var toIObject = __webpack_require__(5);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(26)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports) {
	
	module.exports = function () { /* empty */ };
	
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports) {
	
	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};
	
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(59), __esModule: true };
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(60);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	module.exports = __webpack_require__(15).Symbol;
	
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(0);
	var has = __webpack_require__(1);
	var DESCRIPTORS = __webpack_require__(4);
	var $export = __webpack_require__(27);
	var redefine = __webpack_require__(30);
	var META = __webpack_require__(61).KEY;
	var $fails = __webpack_require__(9);
	var shared = __webpack_require__(20);
	var setToStringTag = __webpack_require__(22);
	var uid = __webpack_require__(11);
	var wks = __webpack_require__(6);
	var wksExt = __webpack_require__(23);
	var wksDefine = __webpack_require__(24);
	var enumKeys = __webpack_require__(62);
	var isArray = __webpack_require__(63);
	var anObject = __webpack_require__(7);
	var toIObject = __webpack_require__(5);
	var toPrimitive = __webpack_require__(16);
	var createDesc = __webpack_require__(10);
	var _create = __webpack_require__(31);
	var gOPNExt = __webpack_require__(64);
	var $GOPD = __webpack_require__(65);
	var $DP = __webpack_require__(3);
	var $keys = __webpack_require__(18);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(35).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(25).f = $propertyIsEnumerable;
	  __webpack_require__(34).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(14)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(2)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);
	
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var META = __webpack_require__(11)('meta');
	var isObject = __webpack_require__(8);
	var has = __webpack_require__(1);
	var setDesc = __webpack_require__(3).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(9)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(18);
	var gOPS = __webpack_require__(34);
	var pIE = __webpack_require__(25);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};
	
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(33);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};
	
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(5);
	var gOPN = __webpack_require__(35).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};
	
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pIE = __webpack_require__(25);
	var createDesc = __webpack_require__(10);
	var toIObject = __webpack_require__(5);
	var toPrimitive = __webpack_require__(16);
	var has = __webpack_require__(1);
	var IE8_DOM_DEFINE = __webpack_require__(28);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(4) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports) {
	
	
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(24)('asyncIterator');
	
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(24)('observable');
	
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_69__;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_70__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? factory(exports, __webpack_require__(10), __webpack_require__(1), __webpack_require__(13)) :
		typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
		(factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
	}(this, (function (exports,mobx,React,reactDom) { 'use strict';
	
	var React__default = 'default' in React ? React['default'] : React;
	
	// These functions can be stubbed out in specific environments
	var unstable_batchedUpdates$1 = undefined;
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	    module.exports = factory();
	}(commonjsGlobal, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var EventEmitter = function () {
	    function EventEmitter() {
	        classCallCheck(this, EventEmitter);
	        this.listeners = [];
	    }
	
	    createClass(EventEmitter, [{
	        key: "on",
	        value: function on(cb) {
	            var _this = this;
	
	            this.listeners.push(cb);
	            return function () {
	                var index = _this.listeners.indexOf(cb);
	                if (index !== -1) _this.listeners.splice(index, 1);
	            };
	        }
	    }, {
	        key: "emit",
	        value: function emit(data) {
	            this.listeners.forEach(function (fn) {
	                return fn(data);
	            });
	        }
	    }]);
	    return EventEmitter;
	}();
	
	// Copied from React.PropTypes
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	            rest[_key - 6] = arguments[_key];
	        }
	
	        return mobx.untracked(function () {
	            componentName = componentName || "<<anonymous>>";
	            propFullName = propFullName || propName;
	            if (props[propName] == null) {
	                if (isRequired) {
	                    var actual = props[propName] === null ? "null" : "undefined";
	                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	                }
	                return null;
	            } else {
	                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	            }
	        });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	
	// Copied from React.PropTypes
	function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	        return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue["@@toStringTag"] === "Symbol") {
	        return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	        return true;
	    }
	
	    return false;
	}
	
	// Copied from React.PropTypes
	function getPropType(propValue) {
	    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	        return "array";
	    }
	    if (propValue instanceof RegExp) {
	        // Old webkits (at least until Android 4.0) return 'function' rather than
	        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	        // passes PropTypes.object.
	        return "object";
	    }
	    if (isSymbol(propType, propValue)) {
	        return "symbol";
	    }
	    return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// Copied from React.PropTypes
	function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === "object") {
	        if (propValue instanceof Date) {
	            return "date";
	        } else if (propValue instanceof RegExp) {
	            return "regexp";
	        }
	    }
	    return propType;
	}
	
	function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        return mobx.untracked(function () {
	            if (allowNativeType) {
	                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	            }
	            var mobxChecker = void 0;
	            switch (mobxType) {
	                case "Array":
	                    mobxChecker = mobx.isObservableArray;
	                    break;
	                case "Object":
	                    mobxChecker = mobx.isObservableObject;
	                    break;
	                case "Map":
	                    mobxChecker = mobx.isObservableMap;
	                    break;
	                default:
	                    throw new Error("Unexpected mobxType: " + mobxType);
	            }
	            var propValue = props[propName];
	            if (!mobxChecker(propValue)) {
	                var preciseType = getPreciseType(propValue);
	                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	            }
	            return null;
	        });
	    });
	}
	
	function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	            rest[_key2 - 5] = arguments[_key2];
	        }
	
	        return mobx.untracked(function () {
	            if (typeof typeChecker !== "function") {
	                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	            }
	            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	            if (error instanceof Error) return error;
	            var propValue = props[propName];
	            for (var i = 0; i < propValue.length; i++) {
	                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	                if (error instanceof Error) return error;
	            }
	            return null;
	        });
	    });
	}
	
	var observableArray = createObservableTypeCheckerCreator(false, "Array");
	var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	var observableMap = createObservableTypeCheckerCreator(false, "Map");
	var observableObject = createObservableTypeCheckerCreator(false, "Object");
	var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	
	
	var propTypes = Object.freeze({
		observableArray: observableArray,
		observableArrayOf: observableArrayOf,
		observableMap: observableMap,
		observableObject: observableObject,
		arrayOrObservableArray: arrayOrObservableArray,
		arrayOrObservableArrayOf: arrayOrObservableArrayOf,
		objectOrObservableObject: objectOrObservableObject
	});
	
	function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	}
	
	var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	};
	Object.seal(injectorContextTypes);
	
	var proxiedInjectorProps = {
	    contextTypes: {
	        get: function get$$1() {
	            return injectorContextTypes;
	        },
	        set: function set$$1(_) {
	            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	        },
	        configurable: true,
	        enumerable: false
	    },
	    isMobxInjector: {
	        value: true,
	        writable: true,
	        configurable: true,
	        enumerable: true
	    }
	
	    /**
	     * Store Injection
	     */
	};function createStoreInjector(grabStoresFn, component, injectNames) {
	    var _class, _temp2;
	
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector = (_temp2 = _class = function (_Component) {
	        inherits(Injector, _Component);
	
	        function Injector() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            classCallCheck(this, Injector);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
	                _this.wrappedInstance = instance;
	            }, _temp), possibleConstructorReturn(_this, _ret);
	        }
	
	        createClass(Injector, [{
	            key: "render",
	            value: function render() {
	                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	                // See this test: 'using a custom injector is not too reactive' in inject.js
	                var newProps = {};
	                for (var key in this.props) {
	                    if (this.props.hasOwnProperty(key)) {
	                        newProps[key] = this.props[key];
	                    }
	                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	                for (var _key2 in additionalProps) {
	                    newProps[_key2] = additionalProps[_key2];
	                }
	
	                if (!isStateless(component)) {
	                    newProps.ref = this.storeRef;
	                }
	
	                return React.createElement(component, newProps);
	            }
	        }]);
	        return Injector;
	    }(React.Component), _class.displayName = displayName, _temp2);
	
	    // Static fields from component should be visible on the generated Injector
	
	    hoistNonReactStatics(Injector, component);
	
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	
	    return Injector;
	}
	
	function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	        storeNames.forEach(function (storeName) {
	            if (storeName in nextProps // prefer props over stores
	            ) return;
	            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	            nextProps[storeName] = baseStores[storeName];
	        });
	        return nextProps;
	    };
	}
	
	/**
	 * higher order component that injects stores to a child.
	 * takes either a varargs list of strings, which are stores read from the context,
	 * or a function that manually maps the available stores from the context to props:
	 * storesToProps(mobxStores, props, context) => newProps
	 */
	function inject() /* fn(stores, nextProps) or ...storeNames */{
	    var grabStoresFn = void 0;
	    if (typeof arguments[0] === "function") {
	        grabStoresFn = arguments[0];
	        return function (componentClass) {
	            var injected = createStoreInjector(grabStoresFn, componentClass);
	            injected.isMobxInjector = false; // supress warning
	            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	            // see #111
	            injected = observer(injected);
	            injected.isMobxInjector = true; // restore warning
	            return injected;
	        };
	    } else {
	        var storeNames = [];
	        for (var i = 0; i < arguments.length; i++) {
	            storeNames[i] = arguments[i];
	        }grabStoresFn = grabStoresByName(storeNames);
	        return function (componentClass) {
	            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	        };
	    }
	}
	
	/**
	 * dev tool support
	 */
	var isDevtoolsEnabled = false;
	
	var isUsingStaticRendering = false;
	
	var warnedAboutObserverInjectDeprecation = false;
	
	// WeakMap<Node, Object>;
	var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	var renderReporter = new EventEmitter();
	
	function findDOMNode$2(component) {
	    if (reactDom.findDOMNode) {
	        try {
	            return reactDom.findDOMNode(component);
	        } catch (e) {
	            // findDOMNode will throw in react-test-renderer, see:
	            // See https://github.com/mobxjs/mobx-react/issues/216
	            // Is there a better heuristic?
	            return null;
	        }
	    }
	    return null;
	}
	
	function reportRendering(component) {
	    var node = findDOMNode$2(component);
	    if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
	
	    renderReporter.emit({
	        event: "render",
	        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	        totalTime: Date.now() - component.__$mobRenderStart,
	        component: component,
	        node: node
	    });
	}
	
	function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	}
	
	function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	}
	
	/**
	 * Errors reporter
	 */
	
	var errorsReporter = new EventEmitter();
	
	/**
	 * Utilities
	 */
	
	function patch(target, funcName) {
	    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var base = target[funcName];
	    var mixinFunc = reactiveMixin[funcName];
	    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
	        mixinFunc.apply(this, arguments);
	        base.apply(this, arguments);
	    } : function () {
	        base.apply(this, arguments);
	        mixinFunc.apply(this, arguments);
	    };
	
	    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
	    // ...but that breaks react-hot-loader, see #231...
	    target[funcName] = f;
	}
	
	function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
	        return false;
	    }
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	    for (var i = 0; i < keysA.length; i++) {
	        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	        return x !== 0 || 1 / x === 1 / y;
	    } else {
	        return x !== x && y !== y;
	    }
	}
	
	function makeComponentReactive(render) {
	    var _this2 = this;
	
	    if (isUsingStaticRendering === true) return render.call(this);
	
	    function makePropertyObservableReference(propName) {
	        var valueHolder = this[propName];
	        var atom = mobx.createAtom("reactive " + propName);
	        Object.defineProperty(this, propName, {
	            configurable: true,
	            enumerable: true,
	            get: function get$$1() {
	                atom.reportObserved();
	                return valueHolder;
	            },
	            set: function set$$1(v) {
	                if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
	                    valueHolder = v;
	                    skipRender = true;
	                    atom.reportChanged();
	                    skipRender = false;
	                } else {
	                    valueHolder = v;
	                }
	            }
	        });
	    }
	
	    function reactiveRender() {
	        var _this = this;
	
	        isRenderingPending = false;
	        var exception = undefined;
	        var rendering = undefined;
	        reaction.track(function () {
	            if (isDevtoolsEnabled) {
	                _this.__$mobRenderStart = Date.now();
	            }
	            try {
	                rendering = mobx._allowStateChanges(false, baseRender);
	            } catch (e) {
	                exception = e;
	            }
	            if (isDevtoolsEnabled) {
	                _this.__$mobRenderEnd = Date.now();
	            }
	        });
	        if (exception) {
	            errorsReporter.emit(exception);
	            throw exception;
	        }
	        return rendering;
	    }
	
	    // Generate friendly name for debugging
	    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	    /**
	     * If props are shallowly modified, react will render anyway,
	     * so atom.reportChanged() should not result in yet another re-render
	     */
	    var skipRender = false;
	    /**
	     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	     * so detect these changes
	     */
	    var isForcingUpdate = false;
	
	    // make this.props an observable reference, see #124
	    makePropertyObservableReference.call(this, "props");
	    // make state an observable reference
	    makePropertyObservableReference.call(this, "state");
	
	    // wire up reactive render
	    var baseRender = render.bind(this);
	    var isRenderingPending = false;
	
	    var reaction = new mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
	        if (!isRenderingPending) {
	            // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	            // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	            // See #85 / Pull #44
	            isRenderingPending = true;
	            if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?
	            if (_this2.__$mobxIsUnmounted !== true) {
	                // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	                // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	                // However, people also claim this migth happen during unit tests..
	                var hasError = true;
	                try {
	                    isForcingUpdate = true;
	                    if (!skipRender) React.Component.prototype.forceUpdate.call(_this2);
	                    hasError = false;
	                } finally {
	                    isForcingUpdate = false;
	                    if (hasError) reaction.dispose();
	                }
	            }
	        }
	    });
	    reaction.reactComponent = this;
	    reactiveRender.$mobx = reaction;
	    this.render = reactiveRender;
	    return reactiveRender.call(this);
	}
	
	/**
	 * ReactiveMixin
	 */
	var reactiveMixin = {
	    componentWillUnmount: function componentWillUnmount() {
	        if (isUsingStaticRendering === true) return;
	        this.render.$mobx && this.render.$mobx.dispose();
	        this.__$mobxIsUnmounted = true;
	        if (isDevtoolsEnabled) {
	            var node = findDOMNode$2(this);
	            if (node && componentByNodeRegistry) {
	                componentByNodeRegistry.delete(node);
	            }
	            renderReporter.emit({
	                event: "destroy",
	                component: this,
	                node: node
	            });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (isUsingStaticRendering) {
	            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	        }
	        // update on any state changes (as is the default)
	        if (this.state !== nextState) {
	            return true;
	        }
	        // update if props are shallowly not equal, inspired by PureRenderMixin
	        // we could return just 'false' here, and avoid the `skipRender` checks etc
	        // however, it is nicer if lifecycle events are triggered like usually,
	        // so we return true here if props are shallowly modified.
	        return !shallowEqual(this.props, nextProps);
	    }
	
	    /**
	     * Observer function / decorator
	     */
	};function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	        throw new Error("Store names should be provided as array");
	    }
	    if (Array.isArray(arg1)) {
	        // TODO: remove in next major
	        // component needs stores
	        if (!warnedAboutObserverInjectDeprecation) {
	            warnedAboutObserverInjectDeprecation = true;
	            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	        }
	        if (!arg2) {
	            // invoked as decorator
	            return function (componentClass) {
	                return observer(arg1, componentClass);
	            };
	        } else {
	            return inject.apply(null, arg1)(observer(arg2));
	        }
	    }
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	    if (componentClass.__proto__ === React.PureComponent) {
	        console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
	    }
	
	    // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
	        var _class, _temp;
	
	        var observerComponent = observer((_temp = _class = function (_Component) {
	            inherits(_class, _Component);
	
	            function _class() {
	                classCallCheck(this, _class);
	                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            createClass(_class, [{
	                key: "render",
	                value: function render() {
	                    return componentClass.call(this, this.props, this.context);
	                }
	            }]);
	            return _class;
	        }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	        hoistNonReactStatics(observerComponent, componentClass);
	        return observerComponent;
	    }
	
	    if (!componentClass) {
	        throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    var baseRender = target.render;
	    target.render = function () {
	        return makeComponentReactive.call(this, baseRender);
	    };
	    return componentClass;
	}
	
	function mixinLifecycleEvents(target) {
	    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	        patch(target, funcName);
	    });
	    if (!target.shouldComponentUpdate) {
	        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    } else {
	        // TODO: make throw in next major
	        console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
	    }
	}
	
	var Observer = observer(function (_ref) {
	    var children = _ref.children,
	        observerInject = _ref.inject,
	        render = _ref.render;
	
	    var component = children || render;
	    if (typeof component === "undefined") {
	        return null;
	    }
	    if (!observerInject) {
	        return component();
	    }
	    // TODO: remove in next major
	    console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
	    var InjectComponent = inject(observerInject)(component);
	    return React__default.createElement(InjectComponent, null);
	});
	
	Observer.displayName = "Observer";
	
	var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	        return;
	    }
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	};
	
	Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(nextProps, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component$$1) {
	  var prototype = Component$$1.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component$$1;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component$$1.displayName || Component$$1.name;
	    var newApiName =
	      typeof Component$$1.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component$$1;
	}
	
	var _class;
	var _temp;
	
	var specialReactKeys = { children: true, key: true, ref: true };
	
	var Provider = (_temp = _class = function (_Component) {
	    inherits(Provider, _Component);
	
	    function Provider(props, context) {
	        classCallCheck(this, Provider);
	
	        var _this = possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));
	
	        _this.state = props || {};
	        return _this;
	    }
	
	    createClass(Provider, [{
	        key: "render",
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }, {
	        key: "getChildContext",
	        value: function getChildContext() {
	            var stores = {};
	            // inherit stores
	            var baseStores = this.context.mobxStores;
	            if (baseStores) for (var key in baseStores) {
	                stores[key] = baseStores[key];
	            }
	            // add own stores
	            for (var _key in this.state) {
	                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
	            }return {
	                mobxStores: stores
	            };
	        }
	    }], [{
	        key: "getDerivedStateFromProps",
	        value: function getDerivedStateFromProps(nextProps, prevState) {
	            if (!nextProps) return null;
	            if (!prevState) return nextProps;
	
	            // Maybe this warning is too aggressive?
	            if (Object.keys(nextProps).length !== Object.keys(prevState).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	                if (!specialReactKeys[key] && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	            }return nextProps;
	        }
	    }]);
	    return Provider;
	}(React.Component), _class.contextTypes = {
	    mobxStores: objectOrObservableObject
	}, _class.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	}, _temp);
	
	// TODO: kill in next major
	
	polyfill(Provider);
	
	if (!React.Component) throw new Error("mobx-react requires React to be available");
	if (!mobx.spy) throw new Error("mobx-react requires mobx to be available");
	
	if (typeof reactDom.unstable_batchedUpdates === "function") mobx.configure({ reactionScheduler: reactDom.unstable_batchedUpdates });else if (typeof unstable_batchedUpdates$1 === "function") mobx.configure({ reactionScheduler: unstable_batchedUpdates$1 });
	
	var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	};
	
	/* DevTool support */
	// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js
	
	if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = { spy: mobx.spy, extras: { getDebugName: mobx.getDebugName } };
	    var mobxReact = {
	        renderReporter: renderReporter,
	        componentByNodeRegistry: componentByNodeRegistry,
	        componentByNodeRegistery: componentByNodeRegistry,
	        trackComponents: trackComponents
	    };
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	}
	
	exports.propTypes = propTypes;
	exports.PropTypes = propTypes;
	exports.onError = onError;
	exports.observer = observer;
	exports.Observer = Observer;
	exports.renderReporter = renderReporter;
	exports.componentByNodeRegistery = componentByNodeRegistry;
	exports.componentByNodeRegistry = componentByNodeRegistry;
	exports.trackComponents = trackComponents;
	exports.useStaticRendering = useStaticRendering;
	exports.Provider = Provider;
	exports.inject = inject;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var mobx = __webpack_require__(10);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	}
	
	function __decorate(decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	}
	
	/**
	 * Returns the _actual_ type of the given tree node. (Or throws)
	 *
	 * @export
	 * @param {IStateTreeNode} object
	 * @returns {IType<S, T>}
	 */
	function getType$$1(object) {
	    return getStateTreeNode$$1(object).type;
	}
	/**
	 * Returns the _declared_ type of the given sub property of an object, array or map.
	 *
	 * @example
	 * const Box = types.model({ x: 0, y: 0 })
	 * const box = Box.create()
	 *
	 * console.log(getChildType(box, "x").name) // 'number'
	 *
	 * @export
	 * @param {IStateTreeNode} object
	 * @param {string} child
	 * @returns {IType<any, any>}
	 */
	function getChildType$$1(object, child) {
	    return getStateTreeNode$$1(object).getChildType(child);
	}
	/**
	 * Registers a function that will be invoked for each mutation that is applied to the provided model instance, or to any of its children.
	 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details. onPatch events are emitted immediately and will not await the end of a transaction.
	 * Patches can be used to deep observe a model tree.
	 *
	 * @export
	 * @param {Object} target the model instance from which to receive patches
	 * @param {(patch: IJsonPatch, reversePatch) => void} callback the callback that is invoked for each patch. The reversePatch is a patch that would actually undo the emitted patch
	 * @param {includeOldValue} boolean if oldValue is included in the patches, they can be inverted. However patches will become much bigger and might not be suitable for efficient transport
	 * @returns {IDisposer} function to remove the listener
	 */
	function onPatch$$1(target, callback) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof callback !== "function")
	            fail("expected second argument to be a function, got " + callback + " instead");
	    }
	    return getStateTreeNode$$1(target).onPatch(callback);
	}
	/**
	 * Registers a function that is invoked whenever a new snapshot for the given model instance is available.
	 * The listener will only be fire at the and of the current MobX (trans)action.
	 * See [snapshots](https://github.com/mobxjs/mobx-state-tree#snapshots) for more details.
	 *
	 * @export
	 * @param {Object} target
	 * @param {(snapshot: any) => void} callback
	 * @returns {IDisposer}
	 */
	function onSnapshot$$1(target, callback) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof callback !== "function")
	            fail("expected second argument to be a function, got " + callback + " instead");
	    }
	    return getStateTreeNode$$1(target).onSnapshot(callback);
	}
	/**
	 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
	 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
	 *
	 * Can apply a single past, or an array of patches.
	 *
	 * @export
	 * @param {Object} target
	 * @param {IJsonPatch} patch
	 * @returns
	 */
	function applyPatch$$1(target, patch) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof patch !== "object")
	            fail("expected second argument to be an object or array, got " + patch + " instead");
	    }
	    getStateTreeNode$$1(target).applyPatches(asArray(patch));
	}
	/**
	 * Small abstraction around `onPatch` and `applyPatch`, attaches a patch listener to a tree and records all the patches.
	 * Returns an recorder object with the following signature:
	 *
	 * @example
	 * export interface IPatchRecorder {
	 *      // the recorded patches
	 *      patches: IJsonPatch[]
	 *      // the inverse of the recorded patches
	 *      inversePatches: IJsonPatch[]
	 *      // stop recording patches
	 *      stop(target?: IStateTreeNode): any
	 *      // resume recording patches
	 *      resume()
	 *      // apply all the recorded patches on the given target (the original subject if omitted)
	 *      replay(target?: IStateTreeNode): any
	 *      // reverse apply the recorded patches on the given target  (the original subject if omitted)
	 *      // stops the recorder if not already stopped
	 *      undo(): void
	 * }
	 *
	 * @export
	 * @param {IStateTreeNode} subject
	 * @returns {IPatchRecorder}
	 */
	function recordPatches$$1(subject) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(subject))
	            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
	    }
	    var disposer = null;
	    function resume() {
	        if (disposer)
	            return;
	        disposer = onPatch$$1(subject, function (patch, inversePatch) {
	            recorder.rawPatches.push([patch, inversePatch]);
	        });
	    }
	    var recorder = {
	        rawPatches: [],
	        get patches() {
	            return this.rawPatches.map(function (_a) {
	                var a = _a[0];
	                return a;
	            });
	        },
	        get inversePatches() {
	            return this.rawPatches.map(function (_a) {
	                var _ = _a[0], b = _a[1];
	                return b;
	            });
	        },
	        stop: function () {
	            if (disposer)
	                disposer();
	            disposer = null;
	        },
	        resume: resume,
	        replay: function (target) {
	            applyPatch$$1(target || subject, recorder.patches);
	        },
	        undo: function (target) {
	            applyPatch$$1(target || subject, recorder.inversePatches.slice().reverse());
	        }
	    };
	    resume();
	    return recorder;
	}
	/**
	 * The inverse of `unprotect`
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 *
	 */
	function protect$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    if (!node.isRoot)
	        fail("`protect` can only be invoked on root nodes");
	    node.isProtectionEnabled = true;
	}
	/**
	 * By default it is not allowed to directly modify a model. Models can only be modified through actions.
	 * However, in some cases you don't care about the advantages (like replayability, traceability, etc) this yields.
	 * For example because you are building a PoC or don't have any middleware attached to your tree.
	 *
	 * In that case you can disable this protection by calling `unprotect` on the root of your tree.
	 *
	 * @example
	 * const Todo = types.model({
	 *     done: false
	 * }).actions(self => ({
	 *     toggle() {
	 *         self.done = !self.done
	 *     }
	 * }))
	 *
	 * const todo = Todo.create()
	 * todo.done = true // throws!
	 * todo.toggle() // OK
	 * unprotect(todo)
	 * todo.done = false // OK
	 */
	function unprotect$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    if (!node.isRoot)
	        fail("`unprotect` can only be invoked on root nodes");
	    node.isProtectionEnabled = false;
	}
	/**
	 * Returns true if the object is in protected mode, @see protect
	 */
	function isProtected$$1(target) {
	    return getStateTreeNode$$1(target).isProtected;
	}
	/**
	 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
	 *
	 * @export
	 * @param {Object} target
	 * @param {Object} snapshot
	 * @returns
	 */
	function applySnapshot$$1(target, snapshot) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).applySnapshot(snapshot);
	}
	/**
	 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
	 * structural sharing where possible. Doesn't require MobX transactions to be completed.
	 *
	 * @export
	 * @param {Object} target
	 * @returns {*}
	 */
	function getSnapshot$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).snapshot;
	}
	/**
	 * Given a model instance, returns `true` if the object has a parent, that is, is part of another object, map or array
	 *
	 * @export
	 * @param {Object} target
	 * @param {number} depth = 1, how far should we look upward?
	 * @returns {boolean}
	 */
	function hasParent$$1(target, depth) {
	    if (depth === void 0) { depth = 1; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof depth !== "number")
	            fail("expected second argument to be a number, got " + depth + " instead");
	        if (depth < 0)
	            fail("Invalid depth: " + depth + ", should be >= 1");
	    }
	    var parent = getStateTreeNode$$1(target).parent;
	    while (parent) {
	        if (--depth === 0)
	            return true;
	        parent = parent.parent;
	    }
	    return false;
	}
	/**
	 * Returns the immediate parent of this object, or null.
	 *
	 * Note that the immediate parent can be either an object, map or array, and
	 * doesn't necessarily refer to the parent model
	 *
	 * @export
	 * @param {Object} target
	 * @param {number} depth = 1, how far should we look upward?
	 * @returns {*}
	 */
	function getParent$$1(target, depth) {
	    if (depth === void 0) { depth = 1; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof depth !== "number")
	            fail("expected second argument to be a number, got " + depth + " instead");
	        if (depth < 0)
	            fail("Invalid depth: " + depth + ", should be >= 1");
	    }
	    var d = depth;
	    var parent = getStateTreeNode$$1(target).parent;
	    while (parent) {
	        if (--d === 0)
	            return parent.storedValue;
	        parent = parent.parent;
	    }
	    return fail("Failed to find the parent of " + getStateTreeNode$$1(target) + " at depth " + depth);
	}
	/**
	 * Given an object in a model tree, returns the root object of that tree
	 *
	 * @export
	 * @param {Object} target
	 * @returns {*}
	 */
	function getRoot$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).root.storedValue;
	}
	/**
	 * Returns the path of the given object in the model tree
	 *
	 * @export
	 * @param {Object} target
	 * @returns {string}
	 */
	function getPath$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).path;
	}
	/**
	 * Returns the path of the given object as unescaped string array
	 *
	 * @export
	 * @param {Object} target
	 * @returns {string[]}
	 */
	function getPathParts$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return splitJsonPath$$1(getStateTreeNode$$1(target).path);
	}
	/**
	 * Returns true if the given object is the root of a model tree
	 *
	 * @export
	 * @param {Object} target
	 * @returns {boolean}
	 */
	function isRoot$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).isRoot;
	}
	/**
	 * Resolves a path relatively to a given object.
	 * Returns undefined if no value can be found.
	 *
	 * @export
	 * @param {Object} target
	 * @param {string} path - escaped json path
	 * @returns {*}
	 */
	function resolvePath$$1(target, path) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof path !== "string")
	            fail("expected second argument to be a number, got " + path + " instead");
	    }
	    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path);
	    return node ? node.value : undefined;
	}
	/**
	 * Resolves a model instance given a root target, the type and the identifier you are searching for.
	 * Returns undefined if no value can be found.
	 *
	 * @export
	 * @param {IType<any, any>} type
	 * @param {IStateTreeNode} target
	 * @param {(string | number)} identifier
	 * @returns {*}
	 */
	function resolveIdentifier$$1(type, target, identifier$$1) {
	    // check all arguments
	    if (false) {
	        if (!isType$$1(type))
	            fail("expected first argument to be a mobx-state-tree type, got " + type + " instead");
	        if (!isStateTreeNode$$1(target))
	            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
	        if (!(typeof identifier$$1 === "string" || typeof identifier$$1 === "number"))
	            fail("expected third argument to be a string or number, got " + identifier$$1 + " instead");
	    }
	    var node = getStateTreeNode$$1(target).root.identifierCache.resolve(type, "" + identifier$$1);
	    return node ? node.value : undefined;
	}
	/**
	 * Returns the identifier of the target node.
	 *
	 * @export
	 * @param {IStateTreeNode} target
	  * @returns {(string | null)}
	 */
	function getIdentifier$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).identifier;
	}
	/**
	 *
	 *
	 * @export
	 * @param {Object} target
	 * @param {string} path
	 * @returns {*}
	 */
	function tryResolve$$1(target, path) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof path !== "string")
	            fail("expected second argument to be a string, got " + path + " instead");
	    }
	    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path, false);
	    if (node === undefined)
	        return undefined;
	    try {
	        return node.value;
	    }
	    catch (e) {
	        // For what ever reason not resolvable (e.g. totally not existing path, or value that cannot be fetched)
	        // see test / issue: 'try resolve doesn't work #686'
	        return undefined;
	    }
	}
	/**
	 * Given two state tree nodes that are part of the same tree,
	 * returns the shortest jsonpath needed to navigate from the one to the other
	 *
	 * @export
	 * @param {IStateTreeNode} base
	 * @param {IStateTreeNode} target
	 * @returns {string}
	 */
	function getRelativePath$$1(base, target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
	        if (!isStateTreeNode$$1(base))
	            fail("expected first argument to be a mobx-state-tree node, got " + base + " instead");
	    }
	    return getRelativePathBetweenNodes$$1(getStateTreeNode$$1(base), getStateTreeNode$$1(target));
	}
	/**
	 * Returns a deep copy of the given state tree node as new tree.
	 * Short hand for `snapshot(x) = getType(x).create(getSnapshot(x))`
	 *
	 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
	 *
	 * @export
	 * @template T
	 * @param {T} source
	 * @param {boolean | any} keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
	 * @returns {T}
	 */
	function clone$$1(source, keepEnvironment) {
	    if (keepEnvironment === void 0) { keepEnvironment = true; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(source))
	            fail("expected first argument to be a mobx-state-tree node, got " + source + " instead");
	    }
	    var node = getStateTreeNode$$1(source);
	    return node.type.create(node.snapshot, keepEnvironment === true
	        ? node.root._environment
	        : keepEnvironment === false ? undefined : keepEnvironment); // it's an object or something else
	}
	/**
	 * Removes a model element from the state tree, and let it live on as a new state tree
	 */
	function detach$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    getStateTreeNode$$1(target).detach();
	    return target;
	}
	/**
	 * Removes a model element from the state tree, and mark it as end-of-life; the element should not be used anymore
	 */
	function destroy$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    if (node.isRoot)
	        node.die();
	    else
	        node.parent.removeChild(node.subpath);
	}
	/**
	 * Returns true if the given state tree node is not killed yet.
	 * This means that the node is still a part of a tree, and that `destroy`
	 * has not been called. If a node is not alive anymore, the only thing one can do with it
	 * is requesting it's last path and snapshot
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @returns {boolean}
	 */
	function isAlive$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).isAlive;
	}
	/**
	 * Use this utility to register a function that should be called whenever the
	 * targeted state tree node is destroyed. This is a useful alternative to managing
	 * cleanup methods yourself using the `beforeDestroy` hook.
	 *
	 * @example
	 * const Todo = types.model({
	 *   title: types.string
	 * }).actions(self => ({
	 *   afterCreate() {
	 *     const autoSaveDisposer = reaction(
	 *       () => getSnapshot(self),
	 *       snapshot => sendSnapshotToServerSomehow(snapshot)
	 *     )
	 *     // stop sending updates to server if this
	 *     // instance is destroyed
	 *     addDisposer(self, autoSaveDisposer)
	 *   }
	 * }))
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @param {() => void} disposer
	 */
	function addDisposer$$1(target, disposer) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof disposer !== "function")
	            fail("expected second argument to be a function, got " + disposer + " instead");
	    }
	    getStateTreeNode$$1(target).addDisposer(disposer);
	}
	/**
	 * Returns the environment of the current state tree. For more info on environments,
	 * see [Dependency injection](https://github.com/mobxjs/mobx-state-tree#dependency-injection)
	 *
	 * Returns an empty environment if the tree wasn't initialized with an environment
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @returns {*}
	 */
	function getEnv$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    var env = node.root._environment;
	    if (!!!env)
	        return EMPTY_OBJECT;
	    return env;
	}
	/**
	 * Performs a depth first walk through a tree
	 */
	function walk$$1(target, processor) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof processor !== "function")
	            fail("expected second argument to be a function, got " + processor + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    // tslint:disable-next-line:no_unused-variable
	    node.getChildren().forEach(function (child) {
	        if (isStateTreeNode$$1(child.storedValue))
	            walk$$1(child.storedValue, processor);
	    });
	    processor(node.storedValue);
	}
	/**
	 * Returns a reflection of the node
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @returns {IModelReflectionData}
	 */
	function getMembers$$1(target) {
	    // check all arguments
	    if (false) {
	        var node_1 = getStateTreeNode$$1(target);
	        if (!(node_1.type instanceof ModelType$$1))
	            fail("expected the node's type to be of the type: model" +
	                target +
	                " instead. It's likely you passed an array or a map.");
	    }
	    var node = getStateTreeNode$$1(target);
	    var type = node.type;
	    var props = Object.getOwnPropertyNames(target);
	    var reflected = {
	        name: type.name,
	        properties: __assign({}, type.properties),
	        actions: [],
	        volatile: [],
	        views: []
	    };
	    props.forEach(function (key) {
	        if (key in reflected.properties)
	            return;
	        var descriptor = Object.getOwnPropertyDescriptor(target, key);
	        if (descriptor.get) {
	            if (mobx.isComputedProp(target, key))
	                reflected.views.push(key);
	            else
	                reflected.volatile.push(key);
	            return;
	        }
	        if (descriptor.value._isMSTAction === true)
	            reflected.actions.push(key);
	        else if (mobx.isObservableProp(target, key))
	            reflected.volatile.push(key);
	        else
	            reflected.views.push(key);
	    });
	    return reflected;
	}
	
	var ScalarNode$$1 = /** @class */ (function () {
	    function ScalarNode$$1(type, parent, subpath, environment, initialValue, storedValue, canAttachTreeNode, finalizeNewInstance) {
	        if (finalizeNewInstance === void 0) { finalizeNewInstance = noop; }
	        this.subpath = "";
	        this._environment = undefined;
	        this._autoUnbox = true; // unboxing is disabled when reading child nodes
	        this.state = NodeLifeCycle$$1.INITIALIZING;
	        this.type = type;
	        this.storedValue = storedValue;
	        this._parent = parent;
	        this.subpath = subpath;
	        this.storedValue = storedValue;
	        this._environment = environment;
	        this.unbox = this.unbox.bind(this);
	        if (canAttachTreeNode)
	            addHiddenFinalProp(this.storedValue, "$treenode", this);
	        var sawException = true;
	        try {
	            if (canAttachTreeNode)
	                addHiddenFinalProp(this.storedValue, "toJSON", toJSON$$1);
	            finalizeNewInstance(this, initialValue);
	            this.state = NodeLifeCycle$$1.CREATED;
	            sawException = false;
	        }
	        finally {
	            if (sawException) {
	                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
	                this.state = NodeLifeCycle$$1.DEAD;
	            }
	        }
	    }
	    Object.defineProperty(ScalarNode$$1.prototype, "path", {
	        /*
	         * Returnes (escaped) path representation as string
	         */
	        get: function () {
	            if (!this.parent)
	                return "";
	            return this.parent.path + "/" + escapeJsonPath$$1(this.subpath);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "isRoot", {
	        get: function () {
	            return this.parent === null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "parent", {
	        get: function () {
	            return this._parent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "root", {
	        get: function () {
	            // future optimization: store root ref in the node and maintain it
	            if (!this._parent)
	                return fail("This scalar node is not part of a tree");
	            return this._parent.root;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScalarNode$$1.prototype.setParent = function (newParent, subpath) {
	        if (subpath === void 0) { subpath = null; }
	        if (this.parent !== newParent)
	            fail("Cannot change parent of immutable node");
	        if (this.subpath === subpath)
	            return;
	        this.subpath = subpath || "";
	    };
	    Object.defineProperty(ScalarNode$$1.prototype, "value", {
	        get: function () {
	            return this.type.getValue(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "snapshot", {
	        get: function () {
	            var snapshot = this.type.getSnapshot(this);
	            // avoid any external modification in dev mode
	            return freeze(snapshot);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "isAlive", {
	        get: function () {
	            return this.state !== NodeLifeCycle$$1.DEAD;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScalarNode$$1.prototype.unbox = function (childNode) {
	        if (childNode && this._autoUnbox === true)
	            return childNode.value;
	        return childNode;
	    };
	    ScalarNode$$1.prototype.toString = function () {
	        return this.type.name + "@" + (this.path || "<root>") + (this.isAlive ? "" : "[dead]");
	    };
	    ScalarNode$$1.prototype.die = function () {
	        this.state = NodeLifeCycle$$1.DEAD;
	    };
	    __decorate([
	        mobx.observable
	    ], ScalarNode$$1.prototype, "subpath", void 0);
	    return ScalarNode$$1;
	}());
	
	var nextNodeId = 1;
	var ObjectNode$$1 = /** @class */ (function () {
	    function ObjectNode$$1(type, parent, subpath, environment, initialValue, storedValue, canAttachTreeNode, finalizeNewInstance) {
	        if (finalizeNewInstance === void 0) { finalizeNewInstance = noop; }
	        var _this = this;
	        this.nodeId = ++nextNodeId;
	        this.subpath = "";
	        this._parent = null;
	        this._isRunningAction = false; // only relevant for root
	        this.isProtectionEnabled = true;
	        this.identifierAttribute = undefined; // not to be modified directly, only through model initialization
	        this._environment = undefined;
	        this._autoUnbox = true; // unboxing is disabled when reading child nodes
	        this.state = NodeLifeCycle$$1.INITIALIZING;
	        this.middlewares = EMPTY_ARRAY;
	        this.type = type;
	        this.storedValue = storedValue;
	        this._parent = parent;
	        this.subpath = subpath;
	        this._environment = environment;
	        this.unbox = this.unbox.bind(this);
	        this.preboot();
	        if (!parent)
	            this.identifierCache = new IdentifierCache$$1();
	        if (canAttachTreeNode)
	            addHiddenFinalProp(this.storedValue, "$treenode", this);
	        var sawException = true;
	        try {
	            if (canAttachTreeNode)
	                addHiddenFinalProp(this.storedValue, "toJSON", toJSON$$1);
	            this._isRunningAction = true;
	            finalizeNewInstance(this, initialValue);
	            this._isRunningAction = false;
	            if (parent)
	                parent.root.identifierCache.addNodeToCache(this);
	            else
	                this.identifierCache.addNodeToCache(this);
	            this.fireHook("afterCreate");
	            this.state = NodeLifeCycle$$1.CREATED;
	            sawException = false;
	        }
	        finally {
	            if (sawException) {
	                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
	                this.state = NodeLifeCycle$$1.DEAD;
	            }
	        }
	        var snapshotDisposer = mobx.reaction(function () { return _this.snapshot; }, function (snapshot) {
	            _this.emitSnapshot(snapshot);
	        }, {
	            onError: function (e) {
	                throw e;
	            }
	        });
	        this.addDisposer(snapshotDisposer);
	    }
	    Object.defineProperty(ObjectNode$$1.prototype, "path", {
	        /*
	         * Returnes (escaped) path representation as string
	         */
	        get: function () {
	            if (!this.parent)
	                return "";
	            return this.parent.path + "/" + escapeJsonPath$$1(this.subpath);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "isRoot", {
	        get: function () {
	            return this.parent === null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "parent", {
	        get: function () {
	            return this._parent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "root", {
	        // Optimization: make computed
	        get: function () {
	            var p, r = this;
	            while ((p = r.parent))
	                r = p;
	            return r;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.setParent = function (newParent, subpath) {
	        if (subpath === void 0) { subpath = null; }
	        if (this.parent === newParent && this.subpath === subpath)
	            return;
	        if (newParent) {
	            if (this._parent && newParent !== this._parent) {
	                fail("A node cannot exists twice in the state tree. Failed to add " + this + " to path '" + newParent.path + "/" + subpath + "'.");
	            }
	            if (!this._parent && newParent.root === this) {
	                fail("A state tree is not allowed to contain itself. Cannot assign " + this + " to path '" + newParent.path + "/" + subpath + "'");
	            }
	            if (!this._parent &&
	                !!this.root._environment &&
	                this.root._environment !== newParent.root._environment) {
	                fail("A state tree cannot be made part of another state tree as long as their environments are different.");
	            }
	        }
	        if (this.parent && !newParent) {
	            this.die();
	        }
	        else {
	            this.subpath = subpath || "";
	            if (newParent && newParent !== this._parent) {
	                newParent.root.identifierCache.mergeCache(this);
	                this._parent = newParent;
	                this.fireHook("afterAttach");
	            }
	        }
	    };
	    ObjectNode$$1.prototype.fireHook = function (name) {
	        var fn = this.storedValue && typeof this.storedValue === "object" && this.storedValue[name];
	        if (typeof fn === "function")
	            fn.apply(this.storedValue);
	    };
	    Object.defineProperty(ObjectNode$$1.prototype, "value", {
	        get: function () {
	            if (!this.isAlive)
	                return undefined;
	            return this.type.getValue(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "snapshot", {
	        get: function () {
	            if (!this.isAlive)
	                return undefined;
	            // advantage of using computed for a snapshot is that nicely respects transactions etc.
	            var snapshot = this.type.getSnapshot(this);
	            // avoid any external modification in dev mode
	            return freeze(snapshot);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.isRunningAction = function () {
	        if (this._isRunningAction)
	            return true;
	        if (this.isRoot)
	            return false;
	        return this.parent.isRunningAction();
	    };
	    Object.defineProperty(ObjectNode$$1.prototype, "identifier", {
	        get: function () {
	            // RF: do not read from the snapshot here, it can lead to cycle computations
	            // using bidirectional references
	            return this.identifierAttribute ? this.storedValue[this.identifierAttribute] : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "isAlive", {
	        get: function () {
	            return this.state !== NodeLifeCycle$$1.DEAD;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.assertAlive = function () {
	        if (!this.isAlive)
	            fail(this + " cannot be used anymore as it has died; it has been removed from a state tree. If you want to remove an element from a tree and let it live on, use 'detach' or 'clone' the value");
	    };
	    ObjectNode$$1.prototype.getChildNode = function (subpath) {
	        this.assertAlive();
	        this._autoUnbox = false;
	        try {
	            return this.type.getChildNode(this, subpath);
	        }
	        finally {
	            this._autoUnbox = true;
	        }
	    };
	    ObjectNode$$1.prototype.getChildren = function () {
	        this.assertAlive();
	        this._autoUnbox = false;
	        try {
	            return this.type.getChildren(this);
	        }
	        finally {
	            this._autoUnbox = true;
	        }
	    };
	    ObjectNode$$1.prototype.getChildType = function (key) {
	        return this.type.getChildType(key);
	    };
	    Object.defineProperty(ObjectNode$$1.prototype, "isProtected", {
	        get: function () {
	            return this.root.isProtectionEnabled;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.assertWritable = function () {
	        this.assertAlive();
	        if (!this.isRunningAction() && this.isProtected) {
	            fail("Cannot modify '" + this + "', the object is protected and can only be modified by using an action.");
	        }
	    };
	    ObjectNode$$1.prototype.removeChild = function (subpath) {
	        this.type.removeChild(this, subpath);
	    };
	    ObjectNode$$1.prototype.unbox = function (childNode) {
	        if (childNode && this._autoUnbox === true)
	            return childNode.value;
	        return childNode;
	    };
	    ObjectNode$$1.prototype.toString = function () {
	        var identifier$$1 = this.identifier ? "(id: " + this.identifier + ")" : "";
	        return this.type.name + "@" + (this.path || "<root>") + identifier$$1 + (this.isAlive
	            ? ""
	            : "[dead]");
	    };
	    ObjectNode$$1.prototype.finalizeCreation = function () {
	        // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
	        if (this.state === NodeLifeCycle$$1.CREATED) {
	            if (this.parent) {
	                if (this.parent.state !== NodeLifeCycle$$1.FINALIZED) {
	                    // parent not ready yet, postpone
	                    return;
	                }
	                this.fireHook("afterAttach");
	            }
	            this.state = NodeLifeCycle$$1.FINALIZED;
	            for (var _i = 0, _a = this.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                if (child instanceof ObjectNode$$1)
	                    child.finalizeCreation();
	            }
	        }
	    };
	    ObjectNode$$1.prototype.detach = function () {
	        if (!this.isAlive)
	            fail("Error while detaching, node is not alive.");
	        if (this.isRoot)
	            return;
	        else {
	            this.fireHook("beforeDetach");
	            this._environment = this.root._environment; // make backup of environment
	            this.state = NodeLifeCycle$$1.DETACHING;
	            this.identifierCache = this.root.identifierCache.splitCache(this);
	            this.parent.removeChild(this.subpath);
	            this._parent = null;
	            this.subpath = "";
	            this.state = NodeLifeCycle$$1.FINALIZED;
	        }
	    };
	    ObjectNode$$1.prototype.preboot = function () {
	        var _this = this;
	        this.disposers = [];
	        this.middlewares = [];
	        this.snapshotSubscribers = [];
	        this.patchSubscribers = [];
	        // Optimization: this does not need to be done per instance
	        // if some pieces from createActionInvoker are extracted
	        this.applyPatches = createActionInvoker$$1(this.storedValue, "@APPLY_PATCHES", function (patches) {
	            patches.forEach(function (patch) {
	                var parts = splitJsonPath$$1(patch.path);
	                var node = resolveNodeByPathParts$$1(_this, parts.slice(0, -1));
	                node.applyPatchLocally(parts[parts.length - 1], patch);
	            });
	        }).bind(this.storedValue);
	        this.applySnapshot = createActionInvoker$$1(this.storedValue, "@APPLY_SNAPSHOT", function (snapshot) {
	            // if the snapshot is the same as the current one, avoid performing a reconcile
	            if (snapshot === _this.snapshot)
	                return;
	            // else, apply it by calling the type logic
	            return _this.type.applySnapshot(_this, snapshot);
	        }).bind(this.storedValue);
	    };
	    ObjectNode$$1.prototype.die = function () {
	        if (this.state === NodeLifeCycle$$1.DETACHING)
	            return;
	        if (isStateTreeNode$$1(this.storedValue)) {
	            // optimization: don't use walk, but getChildNodes for more efficiency
	            walk$$1(this.storedValue, function (child) {
	                var node = getStateTreeNode$$1(child);
	                if (node instanceof ObjectNode$$1)
	                    node.aboutToDie();
	            });
	            walk$$1(this.storedValue, function (child) {
	                var node = getStateTreeNode$$1(child);
	                if (node instanceof ObjectNode$$1)
	                    node.finalizeDeath();
	            });
	        }
	    };
	    ObjectNode$$1.prototype.aboutToDie = function () {
	        this.disposers.splice(0).forEach(function (f) { return f(); });
	        this.fireHook("beforeDestroy");
	    };
	    ObjectNode$$1.prototype.finalizeDeath = function () {
	        // invariant: not called directly but from "die"
	        this.root.identifierCache.notifyDied(this);
	        var self = this;
	        var oldPath = this.path;
	        addReadOnlyProp(this, "snapshot", this.snapshot); // kill the computed prop and just store the last snapshot
	        this.patchSubscribers.splice(0);
	        this.snapshotSubscribers.splice(0);
	        this.patchSubscribers.splice(0);
	        this.state = NodeLifeCycle$$1.DEAD;
	        this._parent = null;
	        this.subpath = "";
	        // This is quite a hack, once interceptable objects / arrays / maps are extracted from mobx,
	        // we could express this in a much nicer way
	        // TODO: should be possible to obtain id's still...
	        Object.defineProperty(this.storedValue, "$mobx", {
	            get: function () {
	                fail("This object has died and is no longer part of a state tree. It cannot be used anymore. The object (of type '" + self
	                    .type
	                    .name + "') used to live at '" + oldPath + "'. It is possible to access the last snapshot of this object using 'getSnapshot', or to create a fresh copy using 'clone'. If you want to remove an object from the tree without killing it, use 'detach' instead.");
	            }
	        });
	    };
	    ObjectNode$$1.prototype.onSnapshot = function (onChange) {
	        return registerEventHandler(this.snapshotSubscribers, onChange);
	    };
	    ObjectNode$$1.prototype.emitSnapshot = function (snapshot) {
	        this.snapshotSubscribers.forEach(function (f) { return f(snapshot); });
	    };
	    ObjectNode$$1.prototype.onPatch = function (handler) {
	        return registerEventHandler(this.patchSubscribers, handler);
	    };
	    ObjectNode$$1.prototype.emitPatch = function (basePatch, source) {
	        if (this.patchSubscribers.length) {
	            var localizedPatch = extend({}, basePatch, {
	                path: source.path.substr(this.path.length) + "/" + basePatch.path // calculate the relative path of the patch
	            });
	            var _a = splitPatch$$1(localizedPatch), patch_1 = _a[0], reversePatch_1 = _a[1];
	            this.patchSubscribers.forEach(function (f) { return f(patch_1, reversePatch_1); });
	        }
	        if (this.parent)
	            this.parent.emitPatch(basePatch, source);
	    };
	    ObjectNode$$1.prototype.addDisposer = function (disposer) {
	        this.disposers.unshift(disposer);
	    };
	    ObjectNode$$1.prototype.removeMiddleware = function (handler) {
	        this.middlewares = this.middlewares.filter(function (middleware) { return middleware.handler !== handler; });
	    };
	    ObjectNode$$1.prototype.addMiddleWare = function (handler, includeHooks) {
	        var _this = this;
	        if (includeHooks === void 0) { includeHooks = true; }
	        this.middlewares.push({ handler: handler, includeHooks: includeHooks });
	        return function () {
	            _this.removeMiddleware(handler);
	        };
	    };
	    ObjectNode$$1.prototype.applyPatchLocally = function (subpath, patch) {
	        this.assertWritable();
	        this.type.applyPatchLocally(this, subpath, patch);
	    };
	    __decorate([
	        mobx.observable
	    ], ObjectNode$$1.prototype, "subpath", void 0);
	    __decorate([
	        mobx.observable
	    ], ObjectNode$$1.prototype, "_parent", void 0);
	    __decorate([
	        mobx.computed
	    ], ObjectNode$$1.prototype, "path", null);
	    __decorate([
	        mobx.computed
	    ], ObjectNode$$1.prototype, "value", null);
	    __decorate([
	        mobx.computed
	    ], ObjectNode$$1.prototype, "snapshot", null);
	    return ObjectNode$$1;
	}());
	
	var TypeFlags$$1;
	(function (TypeFlags$$1) {
	    TypeFlags$$1[TypeFlags$$1["String"] = 1] = "String";
	    TypeFlags$$1[TypeFlags$$1["Number"] = 2] = "Number";
	    TypeFlags$$1[TypeFlags$$1["Boolean"] = 4] = "Boolean";
	    TypeFlags$$1[TypeFlags$$1["Date"] = 8] = "Date";
	    TypeFlags$$1[TypeFlags$$1["Literal"] = 16] = "Literal";
	    TypeFlags$$1[TypeFlags$$1["Array"] = 32] = "Array";
	    TypeFlags$$1[TypeFlags$$1["Map"] = 64] = "Map";
	    TypeFlags$$1[TypeFlags$$1["Object"] = 128] = "Object";
	    TypeFlags$$1[TypeFlags$$1["Frozen"] = 256] = "Frozen";
	    TypeFlags$$1[TypeFlags$$1["Optional"] = 512] = "Optional";
	    TypeFlags$$1[TypeFlags$$1["Reference"] = 1024] = "Reference";
	    TypeFlags$$1[TypeFlags$$1["Identifier"] = 2048] = "Identifier";
	    TypeFlags$$1[TypeFlags$$1["Late"] = 4096] = "Late";
	    TypeFlags$$1[TypeFlags$$1["Refinement"] = 8192] = "Refinement";
	    TypeFlags$$1[TypeFlags$$1["Union"] = 16384] = "Union";
	    TypeFlags$$1[TypeFlags$$1["Null"] = 32768] = "Null";
	    TypeFlags$$1[TypeFlags$$1["Undefined"] = 65536] = "Undefined";
	})(TypeFlags$$1 || (TypeFlags$$1 = {}));
	/*
	 * A complex type produces a MST node (Node in the state tree)
	 */
	var ComplexType$$1 = /** @class */ (function () {
	    function ComplexType$$1(name) {
	        this.isType = true;
	        this.name = name;
	    }
	    ComplexType$$1.prototype.create = function (snapshot, environment) {
	        if (snapshot === void 0) { snapshot = this.getDefaultSnapshot(); }
	        typecheck$$1(this, snapshot);
	        return this.instantiate(null, "", environment, snapshot).value;
	    };
	    ComplexType$$1.prototype.isAssignableFrom = function (type) {
	        return type === this;
	    };
	    ComplexType$$1.prototype.validate = function (value, context) {
	        if (isStateTreeNode$$1(value)) {
	            return getType$$1(value) === this || this.isAssignableFrom(getType$$1(value))
	                ? typeCheckSuccess$$1()
	                : typeCheckFailure$$1(context, value);
	            // it is tempting to compare snapshots, but in that case we should always clone on assignments...
	        }
	        return this.isValidSnapshot(value, context);
	    };
	    ComplexType$$1.prototype.is = function (value) {
	        return this.validate(value, [{ path: "", type: this }]).length === 0;
	    };
	    ComplexType$$1.prototype.reconcile = function (current, newValue) {
	        if (current.snapshot === newValue)
	            // newValue is the current snapshot of the node, noop
	            return current;
	        if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue) === current)
	            // the current node is the same as the new one
	            return current;
	        if (current.type === this &&
	            isMutable(newValue) &&
	            !isStateTreeNode$$1(newValue) &&
	            (!current.identifierAttribute ||
	                current.identifier === newValue[current.identifierAttribute])) {
	            // the newValue has no node, so can be treated like a snapshot
	            // we can reconcile
	            current.applySnapshot(newValue);
	            return current;
	        }
	        // current node cannot be recycled in any way
	        var parent = current.parent, subpath = current.subpath;
	        current.die();
	        // attempt to reuse the new one
	        if (isStateTreeNode$$1(newValue) && this.isAssignableFrom(getType$$1(newValue))) {
	            // newValue is a Node as well, move it here..
	            var newNode = getStateTreeNode$$1(newValue);
	            newNode.setParent(parent, subpath);
	            return newNode;
	        }
	        // nothing to do, we have to create a new node
	        return this.instantiate(parent, subpath, current._environment, newValue);
	    };
	    Object.defineProperty(ComplexType$$1.prototype, "Type", {
	        get: function () {
	            return fail("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ComplexType$$1.prototype, "SnapshotType", {
	        get: function () {
	            return fail("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        mobx.action
	    ], ComplexType$$1.prototype, "create", null);
	    return ComplexType$$1;
	}());
	var Type$$1 = /** @class */ (function (_super) {
	    __extends(Type$$1, _super);
	    function Type$$1(name) {
	        return _super.call(this, name) || this;
	    }
	    Type$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    Type$$1.prototype.getSnapshot = function (node) {
	        return node.storedValue;
	    };
	    Type$$1.prototype.getDefaultSnapshot = function () {
	        return undefined;
	    };
	    Type$$1.prototype.applySnapshot = function (node, snapshot) {
	        fail("Immutable types do not support applying snapshots");
	    };
	    Type$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        fail("Immutable types do not support applying patches");
	    };
	    Type$$1.prototype.getChildren = function (node) {
	        return EMPTY_ARRAY;
	    };
	    Type$$1.prototype.getChildNode = function (node, key) {
	        return fail("No child '" + key + "' available in type: " + this.name);
	    };
	    Type$$1.prototype.getChildType = function (key) {
	        return fail("No child '" + key + "' available in type: " + this.name);
	    };
	    Type$$1.prototype.reconcile = function (current, newValue) {
	        // reconcile only if type and value are still the same
	        if (current.type === this && current.storedValue === newValue)
	            return current;
	        var res = this.instantiate(current.parent, current.subpath, current._environment, newValue);
	        current.die();
	        return res;
	    };
	    Type$$1.prototype.removeChild = function (node, subpath) {
	        return fail("No child '" + subpath + "' available in type: " + this.name);
	    };
	    return Type$$1;
	}(ComplexType$$1));
	function isType$$1(value) {
	    return typeof value === "object" && value && value.isType === true;
	}
	
	var runningActions = new Map();
	/**
	 * Convenience utility to create action based middleware that supports async processes more easily.
	 * All hooks are called for both synchronous and asynchronous actions. Except that either `onSuccess` or `onFail` is called
	 *
	 * The create middleware tracks the process of an action (assuming it passes the `filter`).
	 * `onResume` can return any value, which will be passed as second argument to any other hook. This makes it possible to keep state during a process.
	 *
	 * See the `atomic` middleware for an example
	 *
	 * @export
	 * @template T
	 * @template any
	 * @param {{
	 *     filter?: (call: IMiddlewareEvent) => boolean
	 *     onStart: (call: IMiddlewareEvent) => T
	 *     onResume: (call: IMiddlewareEvent, context: T) => void
	 *     onSuspend: (call: IMiddlewareEvent, context: T) => void
	 *     onSuccess: (call: IMiddlewareEvent, context: T, result: any) => void
	 *     onFail: (call: IMiddlewareEvent, context: T, error: any) => void
	 * }} hooks
	 * @returns {IMiddlewareHandler}
	 */
	function createActionTrackingMiddleware(hooks) {
	    return function actionTrackingMiddleware(call, next, abort) {
	        switch (call.type) {
	            case "action": {
	                if (!hooks.filter || hooks.filter(call) === true) {
	                    var context = hooks.onStart(call);
	                    hooks.onResume(call, context);
	                    runningActions.set(call.id, {
	                        call: call,
	                        context: context,
	                        async: false
	                    });
	                    try {
	                        var res = next(call);
	                        hooks.onSuspend(call, context);
	                        if (runningActions.get(call.id).async === false) {
	                            runningActions.delete(call.id);
	                            hooks.onSuccess(call, context, res);
	                        }
	                        return res;
	                    }
	                    catch (e) {
	                        runningActions.delete(call.id);
	                        hooks.onFail(call, context, e);
	                        throw e;
	                    }
	                }
	                else {
	                    return next(call);
	                }
	            }
	            case "flow_spawn": {
	                var root = runningActions.get(call.rootId);
	                root.async = true;
	                return next(call);
	            }
	            case "flow_resume":
	            case "flow_resume_error": {
	                var root = runningActions.get(call.rootId);
	                hooks.onResume(call, root.context);
	                try {
	                    return next(call);
	                }
	                finally {
	                    hooks.onSuspend(call, root.context);
	                }
	            }
	            case "flow_throw": {
	                var root = runningActions.get(call.rootId);
	                runningActions.delete(call.id);
	                hooks.onFail(call, root.context, call.args[0]);
	                return next(call);
	            }
	            case "flow_return": {
	                var root = runningActions.get(call.rootId);
	                runningActions.delete(call.id);
	                hooks.onSuccess(call, root.context, call.args[0]);
	                return next(call);
	            }
	        }
	    };
	}
	
	function serializeArgument(node, actionName, index, arg) {
	    if (arg instanceof Date)
	        return { $MST_DATE: arg.getTime() };
	    if (isPrimitive(arg))
	        return arg;
	    // We should not serialize MST nodes, even if we can, because we don't know if the receiving party can handle a raw snapshot instead of an
	    // MST type instance. So if one wants to serialize a MST node that was pass in, either explitly pass: 1: an id, 2: a (relative) path, 3: a snapshot
	    if (isStateTreeNode$$1(arg))
	        return serializeTheUnserializable("[MSTNode: " + getType$$1(arg).name + "]");
	    if (typeof arg === "function")
	        return serializeTheUnserializable("[function]");
	    if (typeof arg === "object" && !isPlainObject(arg) && !isArray(arg))
	        return serializeTheUnserializable("[object " + ((arg && arg.constructor && arg.constructor.name) || "Complex Object") + "]");
	    try {
	        // Check if serializable, cycle free etc...
	        // MWE: there must be a better way....
	        JSON.stringify(arg); // or throws
	        return arg;
	    }
	    catch (e) {
	        return serializeTheUnserializable("" + e);
	    }
	}
	function deserializeArgument(adm, value) {
	    if (value && typeof value === "object" && "$MST_DATE" in value)
	        return new Date(value["$MST_DATE"]);
	    return value;
	}
	function serializeTheUnserializable(baseType) {
	    return {
	        $MST_UNSERIALIZABLE: true,
	        type: baseType
	    };
	}
	/**
	 * Applies an action or a series of actions in a single MobX transaction.
	 * Does not return any value
	 * Takes an action description as produced by the `onAction` middleware.
	 *
	 * @export
	 * @param {Object} target
	 * @param {IActionCall[]} actions
	 * @param {IActionCallOptions} [options]
	 */
	function applyAction$$1(target, actions) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof actions !== "object")
	            fail("expected second argument to be an object or array, got " + actions + " instead");
	    }
	    mobx.runInAction(function () {
	        asArray(actions).forEach(function (action$$1) { return baseApplyAction(target, action$$1); });
	    });
	}
	function baseApplyAction(target, action$$1) {
	    var resolvedTarget = tryResolve$$1(target, action$$1.path || "");
	    if (!resolvedTarget)
	        return fail("Invalid action path: " + (action$$1.path || ""));
	    var node = getStateTreeNode$$1(resolvedTarget);
	    // Reserved functions
	    if (action$$1.name === "@APPLY_PATCHES") {
	        return applyPatch$$1.call(null, resolvedTarget, action$$1.args[0]);
	    }
	    if (action$$1.name === "@APPLY_SNAPSHOT") {
	        return applySnapshot$$1.call(null, resolvedTarget, action$$1.args[0]);
	    }
	    if (!(typeof resolvedTarget[action$$1.name] === "function"))
	        fail("Action '" + action$$1.name + "' does not exist in '" + node.path + "'");
	    return resolvedTarget[action$$1.name].apply(resolvedTarget, action$$1.args ? action$$1.args.map(function (v) { return deserializeArgument(node, v); }) : []);
	}
	/**
	 * Small abstraction around `onAction` and `applyAction`, attaches an action listener to a tree and records all the actions emitted.
	 * Returns an recorder object with the following signature:
	 *
	 * @example
	 * export interface IActionRecorder {
	 *      // the recorded actions
	 *      actions: ISerializedActionCall[]
	 *      // stop recording actions
	 *      stop(): any
	 *      // apply all the recorded actions on the given object
	 *      replay(target: IStateTreeNode): any
	 * }
	 *
	 * @export
	 * @param {IStateTreeNode} subject
	 * @returns {IPatchRecorder}
	 */
	function recordActions$$1(subject) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(subject))
	            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
	    }
	    var recorder = {
	        actions: [],
	        stop: function () { return disposer(); },
	        replay: function (target) {
	            applyAction$$1(target, recorder.actions);
	        }
	    };
	    var disposer = onAction$$1(subject, recorder.actions.push.bind(recorder.actions));
	    return recorder;
	}
	/**
	 * Registers a function that will be invoked for each action that is called on the provided model instance, or to any of its children.
	 * See [actions](https://github.com/mobxjs/mobx-state-tree#actions) for more details. onAction events are emitted only for the outermost called action in the stack.
	 * Action can also be intercepted by middleware using addMiddleware to change the function call before it will be run.
	 *
	 * Not all action arguments might be serializable. For unserializable arguments, a struct like `{ $MST_UNSERIALIZABLE: true, type: "someType" }` will be generated.
	 * MST Nodes are considered non-serializable as well (they could be serialized as there snapshot, but it is uncertain whether an replaying party will be able to handle such a non-instantiated snapshot).
	 * Rather, when using `onAction` middleware, one should consider in passing arguments which are 1: an id, 2: a (relative) path, or 3: a snapshot. Instead of a real MST node.
	 *
	 * @example
	 * const Todo = types.model({
	 *   task: types.string
	 * })
	 *
	 * const TodoStore = types.model({
	 *   todos: types.array(Todo)
	 * }).actions(self => ({
	 *   add(todo) {
	 *     self.todos.push(todo);
	 *   }
	 * }))
	 *
	 * const s = TodoStore.create({ todos: [] })
	 *
	 * let disposer = onAction(s, (call) => {
	 *   console.log(call);
	 * })
	 *
	 * s.add({ task: "Grab a coffee" })
	 * // Logs: { name: "add", path: "", args: [{ task: "Grab a coffee" }] }
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @param {(call: ISerializedActionCall) => void} listener
	 * @param attachAfter {boolean} (default false) fires the listener *after* the action has executed instead of before.
	 * @returns {IDisposer}
	 */
	function onAction$$1(target, listener, attachAfter) {
	    if (attachAfter === void 0) { attachAfter = false; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (!isRoot$$1(target))
	            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non root nodes is dangerous: No events will be emitted for actions initiated higher up in the tree.");
	        if (!isProtected$$1(target))
	            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non protected nodes is dangerous: No events will be emitted for direct modifications without action.");
	    }
	    function fireListener(rawCall) {
	        if (rawCall.type === "action" && rawCall.id === rawCall.rootId) {
	            var sourceNode_1 = getStateTreeNode$$1(rawCall.context);
	            listener({
	                name: rawCall.name,
	                path: getRelativePathBetweenNodes$$1(getStateTreeNode$$1(target), sourceNode_1),
	                args: rawCall.args.map(function (arg, index) {
	                    return serializeArgument(sourceNode_1, rawCall.name, index, arg);
	                })
	            });
	        }
	    }
	    return addMiddleware$$1(target, attachAfter
	        ? function onActionMiddleware(rawCall, next) {
	            var res = next(rawCall);
	            fireListener(rawCall);
	            return res;
	        }
	        : function onActionMiddleware(rawCall, next) {
	            fireListener(rawCall);
	            return next(rawCall);
	        });
	}
	
	var nextActionId = 1;
	var currentActionContext = null;
	function getNextActionId$$1() {
	    return nextActionId++;
	}
	function runWithActionContext$$1(context, fn) {
	    var node = getStateTreeNode$$1(context.context);
	    var baseIsRunningAction = node._isRunningAction;
	    var prevContext = currentActionContext;
	    node.assertAlive();
	    node._isRunningAction = true;
	    currentActionContext = context;
	    try {
	        return runMiddleWares(node, context, fn);
	    }
	    finally {
	        currentActionContext = prevContext;
	        node._isRunningAction = baseIsRunningAction;
	    }
	}
	function getActionContext$$1() {
	    if (!currentActionContext)
	        return fail("Not running an action!");
	    return currentActionContext;
	}
	function createActionInvoker$$1(target, name, fn) {
	    var res = function () {
	        var id = getNextActionId$$1();
	        return runWithActionContext$$1({
	            type: "action",
	            name: name,
	            id: id,
	            args: argsToArray(arguments),
	            context: target,
	            tree: getRoot$$1(target),
	            rootId: currentActionContext ? currentActionContext.rootId : id,
	            parentId: currentActionContext ? currentActionContext.id : 0
	        }, fn);
	    };
	    res._isMSTAction = true;
	    return res;
	}
	/**
	 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
	 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
	 *
	 * For more details, see the [middleware docs](docs/middleware.md)
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @param {(action: IRawActionCall, next: (call: IRawActionCall) => any) => any} middleware
	 * @returns {IDisposer}
	 */
	function addMiddleware$$1(target, handler, includeHooks) {
	    if (includeHooks === void 0) { includeHooks = true; }
	    var node = getStateTreeNode$$1(target);
	    if (false) {
	        if (!node.isProtectionEnabled)
	            console.warn("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
	    }
	    return node.addMiddleWare(handler, includeHooks);
	}
	/**
	 * Binds middleware to a specific action
	 *
	 * @example
	 * type.actions(self => {
	 *   function takeA____() {
	 *       self.toilet.donate()
	 *       self.wipe()
	 *       self.wipe()
	 *       self.toilet.flush()
	 *   }
	 *   return {
	 *     takeA____: decorate(atomic, takeA____)
	 *   }
	 * })
	 *
	 * @export
	 * @template T
	 * @param {IMiddlewareHandler} handler
	 * @param Function} fn
	 * @returns the original function
	 */
	function decorate$$1(handler, fn) {
	    var middleware = { handler: handler, includeHooks: true };
	    if (fn.$mst_middleware)
	        fn.$mst_middleware.push(middleware);
	    else
	        fn.$mst_middleware = [middleware];
	    return fn;
	}
	function collectMiddlewares(node, baseCall, fn) {
	    var middlewares = fn.$mst_middleware || EMPTY_ARRAY;
	    var n = node;
	    // Find all middlewares. Optimization: cache this?
	    while (n) {
	        if (n.middlewares)
	            middlewares = middlewares.concat(n.middlewares);
	        n = n.parent;
	    }
	    return middlewares;
	}
	function runMiddleWares(node, baseCall, originalFn) {
	    var middlewares = collectMiddlewares(node, baseCall, originalFn);
	    // Short circuit
	    if (!middlewares.length)
	        return mobx.action(originalFn).apply(null, baseCall.args);
	    var index = 0;
	    var result = null;
	    function runNextMiddleware(call) {
	        var middleware = middlewares[index++];
	        var handler = middleware && middleware.handler;
	        var nextInvoked = false;
	        var abortInvoked = false;
	        function next(call, callback) {
	            nextInvoked = true;
	            // the result can contain
	            // - the non manipulated return value from an action
	            // - the non manipulated abort value
	            // - one of the above but manipulated through the callback function
	            if (callback) {
	                result = callback(runNextMiddleware(call) || result);
	            }
	            else {
	                result = runNextMiddleware(call);
	            }
	        }
	        function abort(value) {
	            abortInvoked = true;
	            // overwrite the result
	            // can be manipulated through middlewares earlier in the queue using the callback fn
	            result = value;
	        }
	        var invokeHandler = function () {
	            handler(call, next, abort);
	            if (false) {
	                if (!nextInvoked && !abortInvoked) {
	                    var node_1 = getStateTreeNode$$1(call.tree);
	                    fail("Neither the next() nor the abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node_1
	                        .type.name + " was invoked.");
	                }
	                if (nextInvoked && abortInvoked) {
	                    var node_2 = getStateTreeNode$$1(call.tree);
	                    fail("The next() and abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node_2
	                        .type.name + " were invoked.");
	                }
	            }
	            return result;
	        };
	        if (handler && middleware.includeHooks) {
	            return invokeHandler();
	        }
	        else if (handler && !middleware.includeHooks) {
	            if (HookNames$$1[call.name])
	                return runNextMiddleware(call);
	            return invokeHandler();
	        }
	        else {
	            return mobx.action(originalFn).apply(null, call.args);
	        }
	    }
	    return runNextMiddleware(baseCall);
	}
	
	function safeStringify(value) {
	    try {
	        return JSON.stringify(value);
	    }
	    catch (e) {
	        return "<Unserializable: " + e + ">";
	    }
	}
	function prettyPrintValue$$1(value) {
	    return typeof value === "function"
	        ? "<function" + (value.name ? " " + value.name : "") + ">"
	        : isStateTreeNode$$1(value) ? "<" + value + ">" : "`" + safeStringify(value) + "`";
	}
	function shortenPrintValue(valueInString) {
	    return valueInString.length < 280
	        ? valueInString
	        : valueInString.substring(0, 272) + "......" + valueInString.substring(valueInString.length - 8);
	}
	function toErrorString(error) {
	    var value = error.value;
	    var type = error.context[error.context.length - 1].type;
	    var fullPath = error.context
	        .map(function (_a) {
	        var path = _a.path;
	        return path;
	    })
	        .filter(function (path) { return path.length > 0; })
	        .join("/");
	    var pathPrefix = fullPath.length > 0 ? "at path \"/" + fullPath + "\" " : "";
	    var currentTypename = isStateTreeNode$$1(value)
	        ? "value of type " + getStateTreeNode$$1(value).type.name + ":"
	        : isPrimitive(value) ? "value" : "snapshot";
	    var isSnapshotCompatible = type && isStateTreeNode$$1(value) && type.is(getStateTreeNode$$1(value).snapshot);
	    return ("" + pathPrefix + currentTypename + " " + prettyPrintValue$$1(value) + " is not assignable " + (type
	        ? "to type: `" + type.name + "`"
	        : "") +
	        (error.message ? " (" + error.message + ")" : "") +
	        (type
	            ? isPrimitiveType$$1(type)
	                ? "."
	                : ", expected an instance of `" + type.name + "` or a snapshot like `" + type.describe() + "` instead." +
	                    (isSnapshotCompatible
	                        ? " (Note that a snapshot of the provided value is compatible with the targeted type)"
	                        : "")
	            : "."));
	}
	
	function getContextForPath$$1(context, path, type) {
	    return context.concat([{ path: path, type: type }]);
	}
	function typeCheckSuccess$$1() {
	    return EMPTY_ARRAY;
	}
	function typeCheckFailure$$1(context, value, message) {
	    return [{ context: context, value: value, message: message }];
	}
	function flattenTypeErrors$$1(errors) {
	    return errors.reduce(function (a, i) { return a.concat(i); }, []);
	}
	// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
	function typecheck$$1(type, value) {
	    // if not in dev-mode, do not even try to run typecheck. Everything is developer fault!
	    if (true)
	        return;
	    typecheckPublic$$1(type, value);
	}
	/**
	 * Run's the typechecker on the given type.
	 * Throws if the given value is not according the provided type specification.
	 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
	 *
	 * @alias typecheck
	 * @export
	 * @param {IType<any, any>} type
	 * @param {*} value
	 */
	function typecheckPublic$$1(type, value) {
	    var errors = type.validate(value, [{ path: "", type: type }]);
	    if (errors.length > 0) {
	        console.error("Failed to create \"" + type.name + "\" from:", value);
	        fail("Error while converting " + shortenPrintValue(prettyPrintValue$$1(value)) + " to `" + type.name + "`:\n\n    " + errors.map(toErrorString).join("\n    "));
	    }
	}
	
	var IdentifierCache$$1 = /** @class */ (function () {
	    function IdentifierCache$$1() {
	        // n.b. in cache all identifiers are normalized to strings
	        this.cache = mobx.observable.map();
	    }
	    IdentifierCache$$1.prototype.addNodeToCache = function (node) {
	        if (node.identifierAttribute) {
	            var identifier$$1 = "" + node.identifier;
	            if (!this.cache.has(identifier$$1)) {
	                this.cache.set(identifier$$1, mobx.observable.array([], mobxShallow));
	            }
	            var set = this.cache.get(identifier$$1);
	            if (set.indexOf(node) !== -1)
	                fail("Already registered");
	            set.push(node);
	        }
	        return this;
	    };
	    IdentifierCache$$1.prototype.mergeCache = function (node) {
	        var _this = this;
	        mobx.values(node.identifierCache.cache).forEach(function (nodes) {
	            return nodes.forEach(function (child) {
	                _this.addNodeToCache(child);
	            });
	        });
	    };
	    IdentifierCache$$1.prototype.notifyDied = function (node) {
	        if (node.identifierAttribute) {
	            var set = this.cache.get("" + node.identifier);
	            if (set)
	                set.remove(node);
	        }
	    };
	    IdentifierCache$$1.prototype.splitCache = function (node) {
	        var res = new IdentifierCache$$1();
	        var basePath = node.path;
	        mobx.values(this.cache).forEach(function (nodes) {
	            for (var i = nodes.length - 1; i >= 0; i--) {
	                if (nodes[i].path.indexOf(basePath) === 0) {
	                    res.addNodeToCache(nodes[i]);
	                    nodes.splice(i, 1);
	                }
	            }
	        });
	        return res;
	    };
	    IdentifierCache$$1.prototype.resolve = function (type, identifier$$1) {
	        var set = this.cache.get("" + identifier$$1);
	        if (!set)
	            return null;
	        var matches = set.filter(function (candidate) { return type.isAssignableFrom(candidate.type); });
	        switch (matches.length) {
	            case 0:
	                return null;
	            case 1:
	                return matches[0];
	            default:
	                return fail("Cannot resolve a reference to type '" + type.name + "' with id: '" + identifier$$1 + "' unambigously, there are multiple candidates: " + matches
	                    .map(function (n) { return n.path; })
	                    .join(", "));
	        }
	    };
	    return IdentifierCache$$1;
	}());
	
	// TODO: split into object and scalar node?
	function createNode$$1(type, parent, subpath, environment, initialValue, createNewInstance, finalizeNewInstance) {
	    if (createNewInstance === void 0) { createNewInstance = identity; }
	    if (finalizeNewInstance === void 0) { finalizeNewInstance = noop; }
	    if (isStateTreeNode$$1(initialValue)) {
	        var targetNode = initialValue.$treenode;
	        if (!targetNode.isRoot)
	            fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + (parent
	                ? parent.path
	                : "") + "/" + subpath + "', but it lives already at '" + targetNode.path + "'");
	        targetNode.setParent(parent, subpath);
	        return targetNode;
	    }
	    var storedValue = createNewInstance(initialValue);
	    if (type.shouldAttachNode) {
	        var node = new ObjectNode$$1(type, parent, subpath, environment, initialValue, storedValue, type.shouldAttachNode, finalizeNewInstance);
	        node.finalizeCreation();
	        return node;
	    }
	    return new ScalarNode$$1(type, parent, subpath, environment, initialValue, storedValue, type.shouldAttachNode, finalizeNewInstance);
	}
	function isNode$$1(value) {
	    return value instanceof ScalarNode$$1 || value instanceof ObjectNode$$1;
	}
	
	var NodeLifeCycle$$1;
	(function (NodeLifeCycle$$1) {
	    NodeLifeCycle$$1[NodeLifeCycle$$1["INITIALIZING"] = 0] = "INITIALIZING";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["CREATED"] = 1] = "CREATED";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["FINALIZED"] = 2] = "FINALIZED";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["DETACHING"] = 3] = "DETACHING";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["DEAD"] = 4] = "DEAD"; // no coming back from this one
	})(NodeLifeCycle$$1 || (NodeLifeCycle$$1 = {}));
	/**
	 * Returns true if the given value is a node in a state tree.
	 * More precisely, that is, if the value is an instance of a
	 * `types.model`, `types.array` or `types.map`.
	 *
	 * @export
	 * @param {*} value
	 * @returns {value is IStateTreeNode}
	 */
	function isStateTreeNode$$1(value) {
	    return !!(value && value.$treenode);
	}
	function getStateTreeNode$$1(value) {
	    if (isStateTreeNode$$1(value))
	        return value.$treenode;
	    else
	        return fail("Value " + value + " is no MST Node");
	}
	
	function toJSON$$1() {
	    return getStateTreeNode$$1(this).snapshot;
	}
	var doubleDot = function (_) { return ".."; };
	function getRelativePathBetweenNodes$$1(base, target) {
	    // PRE condition target is (a child of) base!
	    if (base.root !== target.root)
	        fail("Cannot calculate relative path: objects '" + base + "' and '" + target + "' are not part of the same object tree");
	    var baseParts = splitJsonPath$$1(base.path);
	    var targetParts = splitJsonPath$$1(target.path);
	    var common = 0;
	    for (; common < baseParts.length; common++) {
	        if (baseParts[common] !== targetParts[common])
	            break;
	    }
	    // TODO: assert that no targetParts paths are "..", "." or ""!
	    return (baseParts
	        .slice(common)
	        .map(doubleDot)
	        .join("/") + joinJsonPath$$1(targetParts.slice(common)));
	}
	function resolveNodeByPath$$1(base, path, failIfResolveFails) {
	    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
	    return resolveNodeByPathParts$$1(base, splitJsonPath$$1(path), failIfResolveFails);
	}
	function resolveNodeByPathParts$$1(base, pathParts, failIfResolveFails) {
	    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
	    // counter part of getRelativePath
	    // note that `../` is not part of the JSON pointer spec, which is actually a prefix format
	    // in json pointer: "" = current, "/a", attribute a, "/" is attribute "" etc...
	    // so we treat leading ../ apart...
	    var current = base;
	    for (var i = 0; i < pathParts.length; i++) {
	        var part = pathParts[i];
	        if (part === "") {
	            current = current.root;
	            continue;
	        }
	        else if (part === "..") {
	            current = current.parent;
	            if (current)
	                continue; // not everything has a parent
	        }
	        else if (part === "." || part === "") {
	            // '/bla' or 'a//b' splits to empty strings
	            continue;
	        }
	        else if (current) {
	            if (current instanceof ScalarNode$$1) {
	                // check if the value of a scalar resolves to a state tree node (e.g. references)
	                // then we can continue resolving...
	                try {
	                    var value = current.value;
	                    if (isStateTreeNode$$1(value)) {
	                        current = getStateTreeNode$$1(value);
	                        // fall through
	                    }
	                }
	                catch (e) {
	                    if (!failIfResolveFails) {
	                        return undefined;
	                    }
	                    throw e;
	                }
	            }
	            if (current instanceof ObjectNode$$1) {
	                var subType = current.getChildType(part);
	                if (subType) {
	                    current = current.getChildNode(part);
	                    if (current)
	                        continue;
	                }
	            }
	        }
	        if (failIfResolveFails)
	            return fail("Could not resolve '" + part + "' in path '" + (joinJsonPath$$1(pathParts.slice(0, i)) ||
	                "/") + "' while resolving '" + joinJsonPath$$1(pathParts) + "'");
	        else
	            return undefined;
	    }
	    return current;
	}
	
	// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
	/*
	    All contents of this file are deprecated.
	
	    The term `process` has been replaced with `flow` to avoid conflicts with the
	    global `process` object.
	
	    Refer to `flow.ts` for any further changes to this implementation.
	*/
	var DEPRECATION_MESSAGE = "See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information. " +
	    "Note that the middleware event types starting with `process` now start with `flow`.";
	/**
	 * @deprecated has been renamed to `flow()`.
	 * See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information.
	 * Note that the middleware event types starting with `process` now start with `flow`.
	 *
	 * @export
	 * @alias process
	 * @returns {Promise}
	 */
	function process$1$$1(asyncAction) {
	    deprecated("process", "`process()` has been renamed to `flow()`. " + DEPRECATION_MESSAGE);
	    return flow(asyncAction);
	}
	
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	var mobxShallow = { deep: false };
	Object.freeze(mobxShallow);
	function fail(message) {
	    if (message === void 0) { message = "Illegal state"; }
	    throw new Error("[mobx-state-tree] " + message);
	}
	function identity(_) {
	    return _;
	}
	
	function noop() { }
	function isArray(val) {
	    return !!(Array.isArray(val) || mobx.isObservableArray(val));
	}
	function asArray(val) {
	    if (!val)
	        return EMPTY_ARRAY;
	    if (isArray(val))
	        return val;
	    return [val];
	}
	function extend(a) {
	    var b = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        b[_i - 1] = arguments[_i];
	    }
	    for (var i = 0; i < b.length; i++) {
	        var current = b[i];
	        for (var key in current)
	            a[key] = current[key];
	    }
	    return a;
	}
	
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function isMutable(value) {
	    return (value !== null &&
	        typeof value === "object" &&
	        !(value instanceof Date) &&
	        !(value instanceof RegExp));
	}
	function isPrimitive(value) {
	    if (value === null || value === undefined)
	        return true;
	    if (typeof value === "string" ||
	        typeof value === "number" ||
	        typeof value === "boolean" ||
	        value instanceof Date)
	        return true;
	    return false;
	}
	/*
	 * Freeze a value and return it (if not in production)
	 */
	function freeze(value) {
	    if (true)
	        return value;
	    return isPrimitive(value) ? value : Object.freeze(value);
	}
	/*
	 * Recursively freeze a value (if not in production)
	 */
	function deepFreeze(value) {
	    if (true)
	        return value;
	    freeze(value);
	    if (isPlainObject(value)) {
	        Object.keys(value).forEach(function (propKey) {
	            if (!isPrimitive(value[propKey]) &&
	                !Object.isFrozen(value[propKey])) {
	                deepFreeze(value[propKey]);
	            }
	        });
	    }
	    return value;
	}
	function isSerializable(value) {
	    return typeof value !== "function";
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenWritableProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addReadOnlyProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: true,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function remove(collection, item) {
	    var idx = collection.indexOf(item);
	    if (idx !== -1)
	        collection.splice(idx, 1);
	}
	function registerEventHandler(handlers, handler) {
	    handlers.push(handler);
	    return function () {
	        remove(handlers, handler);
	    };
	}
	
	function argsToArray(args) {
	    var res = new Array(args.length);
	    for (var i = 0; i < args.length; i++)
	        res[i] = args[i];
	    return res;
	}
	var deprecated = function () { };
	deprecated = function (id, message) {
	    // skip if running production
	    if (true)
	        return;
	    // warn if hasn't been warned before
	    if (deprecated.ids && !deprecated.ids.hasOwnProperty(id)) {
	        console.warn("[mobx-state-tree] Deprecation warning: " + message);
	    }
	    // mark as warned to avoid duplicate warn message
	    if (deprecated.ids)
	        deprecated.ids[id] = true;
	};
	deprecated.ids = {};
	
	// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
	/**
	 * See [asynchronous actions](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/async-actions.md).
	 *
	 * @export
	 * @alias flow
	 * @returns {Promise}
	 */
	function flow(asyncAction) {
	    return createFlowSpawner(asyncAction.name, asyncAction);
	}
	function createFlowSpawner(name, generator) {
	    var spawner = function flowSpawner() {
	        // Implementation based on https://github.com/tj/co/blob/master/index.js
	        var runId = getNextActionId$$1();
	        var baseContext = getActionContext$$1();
	        var args = arguments;
	        function wrap(fn, type, arg) {
	            fn.$mst_middleware = spawner.$mst_middleware; // pick up any middleware attached to the flow
	            runWithActionContext$$1({
	                name: name,
	                type: type,
	                id: runId,
	                args: [arg],
	                tree: baseContext.tree,
	                context: baseContext.context,
	                parentId: baseContext.id,
	                rootId: baseContext.rootId
	            }, fn);
	        }
	        return new Promise(function (resolve, reject) {
	            var gen;
	            var init = function asyncActionInit() {
	                gen = generator.apply(null, arguments);
	                onFulfilled(undefined); // kick off the flow
	            };
	            init.$mst_middleware = spawner.$mst_middleware;
	            runWithActionContext$$1({
	                name: name,
	                type: "flow_spawn",
	                id: runId,
	                args: argsToArray(args),
	                tree: baseContext.tree,
	                context: baseContext.context,
	                parentId: baseContext.id,
	                rootId: baseContext.rootId
	            }, init);
	            function onFulfilled(res) {
	                var ret;
	                try {
	                    // prettier-ignore
	                    wrap(function (r) { ret = gen.next(r); }, "flow_resume", res);
	                }
	                catch (e) {
	                    // prettier-ignore
	                    setImmediate(function () {
	                        wrap(function (r) { reject(e); }, "flow_throw", e);
	                    });
	                    return;
	                }
	                next(ret);
	                return;
	            }
	            function onRejected(err) {
	                var ret;
	                try {
	                    // prettier-ignore
	                    wrap(function (r) { ret = gen.throw(r); }, "flow_resume_error", err); // or yieldError?
	                }
	                catch (e) {
	                    // prettier-ignore
	                    setImmediate(function () {
	                        wrap(function (r) { reject(e); }, "flow_throw", e);
	                    });
	                    return;
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret.done) {
	                    // prettier-ignore
	                    setImmediate(function () {
	                        wrap(function (r) { resolve(r); }, "flow_return", ret.value);
	                    });
	                    return;
	                }
	                // TODO: support more type of values? See https://github.com/tj/co/blob/249bbdc72da24ae44076afd716349d2089b31c4c/index.js#L100
	                if (!ret.value || typeof ret.value.then !== "function")
	                    fail("Only promises can be yielded to `async`, got: " + ret);
	                return ret.value.then(onFulfilled, onRejected);
	            }
	        });
	    };
	    return spawner;
	}
	
	function splitPatch$$1(patch) {
	    if (!("oldValue" in patch))
	        fail("Patches without `oldValue` field cannot be inversed");
	    return [stripPatch$$1(patch), invertPatch(patch)];
	}
	function stripPatch$$1(patch) {
	    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
	    // this removes the ability to undo the patch
	    switch (patch.op) {
	        case "add":
	            return { op: "add", path: patch.path, value: patch.value };
	        case "remove":
	            return { op: "remove", path: patch.path };
	        case "replace":
	            return { op: "replace", path: patch.path, value: patch.value };
	    }
	}
	function invertPatch(patch) {
	    switch (patch.op) {
	        case "add":
	            return {
	                op: "remove",
	                path: patch.path
	            };
	        case "remove":
	            return {
	                op: "add",
	                path: patch.path,
	                value: patch.oldValue
	            };
	        case "replace":
	            return {
	                op: "replace",
	                path: patch.path,
	                value: patch.oldValue
	            };
	    }
	}
	// simple simple simple check
	function isNumber(x) {
	    return typeof x === "number";
	}
	/**
	 * escape slashes and backslashes
	 * http://tools.ietf.org/html/rfc6901
	 */
	function escapeJsonPath$$1(str) {
	    if (isNumber(str) === true) {
	        return "" + str;
	    }
	    return str.replace(/~/g, "~1").replace(/\//g, "~0");
	}
	/**
	 * unescape slashes and backslashes
	 */
	function unescapeJsonPath$$1(str) {
	    return str.replace(/~0/g, "/").replace(/~1/g, "~");
	}
	/**
	 * Generates a json-path compliant json path from path parts
	 *
	 * @export
	 * @param {string[]} path
	 * @returns {string}
	 */
	function joinJsonPath$$1(path) {
	    // `/` refers to property with an empty name, while `` refers to root itself!
	    if (path.length === 0)
	        return "";
	    return "/" + path.map(escapeJsonPath$$1).join("/");
	}
	/**
	 * Splits and decodes a json path into several parts
	 *
	 * @export
	 * @param {string} path
	 * @returns {string[]}
	 */
	function splitJsonPath$$1(path) {
	    // `/` refers to property with an empty name, while `` refers to root itself!
	    var parts = path.split("/").map(unescapeJsonPath$$1);
	    // path '/a/b/c' -> a b c
	    // path '../../b/c -> .. .. b c
	    return parts[0] === "" ? parts.slice(1) : parts;
	}
	
	function mapToString$$1() {
	    return getStateTreeNode$$1(this) + "(" + this.size + " items)";
	}
	var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
	function put(value) {
	    if (!!!value)
	        fail("Map.put cannot be used to set empty values");
	    if (isStateTreeNode$$1(value)) {
	        var node = getStateTreeNode$$1(value);
	        if (false) {
	            if (!node.identifierAttribute)
	                return fail(needsIdentifierError);
	        }
	        this.set("" + node.identifier, node.value);
	        return this;
	    }
	    else if (!isMutable(value)) {
	        return fail("Map.put can only be used to store complex values");
	    }
	    else {
	        var mapType = getStateTreeNode$$1(this).type;
	        if (mapType.identifierMode === MapIdentifierMode$$1.NO)
	            return fail(needsIdentifierError);
	        if (mapType.identifierMode === MapIdentifierMode$$1.YES) {
	            this.set("" + value[mapType.identifierAttribute], value);
	            return this;
	        }
	        // we don't know the identifier attr yet, so we have to create the instance already to be able to determine
	        // luckily, needs to happen only once
	        var node = getStateTreeNode$$1(mapType.subType.create(value)); // FIXME: this will unecessarly first create and after that attach.
	        if (!node.identifierAttribute)
	            return fail(needsIdentifierError);
	        this.set("" + node.value[node.identifierAttribute], node.value);
	        return this;
	    }
	}
	var MapIdentifierMode$$1;
	(function (MapIdentifierMode$$1) {
	    MapIdentifierMode$$1[MapIdentifierMode$$1["UNKNOWN"] = 0] = "UNKNOWN";
	    MapIdentifierMode$$1[MapIdentifierMode$$1["YES"] = 1] = "YES";
	    MapIdentifierMode$$1[MapIdentifierMode$$1["NO"] = 2] = "NO";
	})(MapIdentifierMode$$1 || (MapIdentifierMode$$1 = {}));
	var MapType$$1 = /** @class */ (function (_super) {
	    __extends(MapType$$1, _super);
	    function MapType$$1(name, subType) {
	        var _this = _super.call(this, name) || this;
	        _this.shouldAttachNode = true;
	        _this.identifierMode = MapIdentifierMode$$1.UNKNOWN;
	        _this.identifierAttribute = undefined;
	        _this.flags = TypeFlags$$1.Map;
	        _this.createNewInstance = function () {
	            // const identifierAttr = getIdentifierAttribute(this.subType)
	            var map$$1 = mobx.observable.map({}, mobxShallow);
	            addHiddenFinalProp(map$$1, "put", put);
	            addHiddenFinalProp(map$$1, "toString", mapToString$$1);
	            return map$$1;
	        };
	        _this.finalizeNewInstance = function (node, snapshot) {
	            var objNode = node;
	            var instance = objNode.storedValue;
	            mobx._interceptReads(instance, objNode.unbox);
	            mobx.intercept(instance, function (c) { return _this.willChange(c); });
	            objNode.applySnapshot(snapshot);
	            mobx.observe(instance, _this.didChange);
	        };
	        _this.subType = subType;
	        return _this;
	    }
	    MapType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot, this.createNewInstance, this.finalizeNewInstance);
	    };
	    MapType$$1.prototype.describe = function () {
	        return "Map<string, " + this.subType.describe() + ">";
	    };
	    MapType$$1.prototype.getChildren = function (node) {
	        // return (node.storedValue as ObservableMap<any>).values()
	        return mobx.values(node.storedValue);
	    };
	    MapType$$1.prototype.getChildNode = function (node, key) {
	        var childNode = node.storedValue.get("" + key);
	        if (!childNode)
	            fail("Not a child " + key);
	        return childNode;
	    };
	    MapType$$1.prototype.willChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        var key = "" + change.name;
	        node.assertWritable();
	        switch (change.type) {
	            case "update":
	                {
	                    var newValue = change.newValue;
	                    var oldValue = change.object.get(key);
	                    if (newValue === oldValue)
	                        return null;
	                    typecheck$$1(this.subType, newValue);
	                    change.newValue = this.subType.reconcile(node.getChildNode(key), change.newValue);
	                    this.processIdentifier(key, change.newValue);
	                }
	                break;
	            case "add":
	                {
	                    typecheck$$1(this.subType, change.newValue);
	                    change.newValue = this.subType.instantiate(node, key, undefined, change.newValue);
	                    this.processIdentifier(key, change.newValue);
	                }
	                break;
	        }
	        return change;
	    };
	    MapType$$1.prototype.processIdentifier = function (expected, node) {
	        if (node instanceof ObjectNode$$1) {
	            // identifier cannot be determined up front, as they might need to go through unions etc
	            // but for maps, we do want them to be regular, and consistently used.
	            if (this.identifierMode === MapIdentifierMode$$1.UNKNOWN) {
	                this.identifierMode =
	                    node.identifierAttribute !== undefined
	                        ? MapIdentifierMode$$1.YES
	                        : MapIdentifierMode$$1.NO;
	                this.identifierAttribute = node.identifierAttribute;
	            }
	            if (node.identifierAttribute !== this.identifierAttribute)
	                // both undefined if type is NO
	                fail("The objects in a map should all have the same identifier attribute, expected '" + this
	                    .identifierAttribute + "', but child of type '" + node.type
	                    .name + "' declared attribute '" + node.identifierAttribute + "' as identifier");
	            if (this.identifierMode === MapIdentifierMode$$1.YES) {
	                var identifier$$1 = "" + node.identifier; // 'cause snapshots always have their identifiers as strings. blegh..
	                if (identifier$$1 !== expected)
	                    fail("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + identifier$$1 + "', but expected: '" + expected + "'");
	            }
	        }
	    };
	    MapType$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    MapType$$1.prototype.getSnapshot = function (node) {
	        var res = {};
	        node.getChildren().forEach(function (childNode) {
	            res[childNode.subpath] = childNode.snapshot;
	        });
	        return res;
	    };
	    MapType$$1.prototype.didChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        switch (change.type) {
	            case "update":
	                return void node.emitPatch({
	                    op: "replace",
	                    path: escapeJsonPath$$1(change.name),
	                    value: change.newValue.snapshot,
	                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
	                }, node);
	            case "add":
	                return void node.emitPatch({
	                    op: "add",
	                    path: escapeJsonPath$$1(change.name),
	                    value: change.newValue.snapshot,
	                    oldValue: undefined
	                }, node);
	            case "delete":
	                // a node got deleted, get the old snapshot and make the node die
	                var oldSnapshot = change.oldValue.snapshot;
	                change.oldValue.die();
	                // emit the patch
	                return void node.emitPatch({ op: "remove", path: escapeJsonPath$$1(change.name), oldValue: oldSnapshot }, node);
	        }
	    };
	    MapType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        var target = node.storedValue;
	        switch (patch.op) {
	            case "add":
	            case "replace":
	                target.set(subpath, patch.value);
	                break;
	            case "remove":
	                target.delete(subpath);
	                break;
	        }
	    };
	    MapType$$1.prototype.applySnapshot = function (node, snapshot) {
	        typecheck$$1(this, snapshot);
	        var target = node.storedValue;
	        var currentKeys = {};
	        Array.from(target.keys()).forEach(function (key) {
	            currentKeys[key] = false;
	        });
	        // Don't use target.replace, as it will throw all existing items first
	        for (var key in snapshot) {
	            target.set("" + key, snapshot[key]);
	            currentKeys["" + key] = true;
	        }
	        Object.keys(currentKeys).forEach(function (key) {
	            if (currentKeys[key] === false)
	                target.delete(key);
	        });
	    };
	    MapType$$1.prototype.getChildType = function (key) {
	        return this.subType;
	    };
	    MapType$$1.prototype.isValidSnapshot = function (value, context) {
	        var _this = this;
	        if (!isPlainObject(value)) {
	            return typeCheckFailure$$1(context, value, "Value is not a plain object");
	        }
	        return flattenTypeErrors$$1(Object.keys(value).map(function (path) {
	            return _this.subType.validate(value[path], getContextForPath$$1(context, path, _this.subType));
	        }));
	    };
	    MapType$$1.prototype.getDefaultSnapshot = function () {
	        return {};
	    };
	    MapType$$1.prototype.removeChild = function (node, subpath) {
	        
	        node.storedValue.delete(subpath);
	    };
	    __decorate([
	        mobx.action
	    ], MapType$$1.prototype, "applySnapshot", null);
	    return MapType$$1;
	}(ComplexType$$1));
	/**
	 * Creates a key based collection type who's children are all of a uniform declared type.
	 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
	 *
	 * This type will always produce [observable maps](https://mobx.js.org/refguide/map.html)
	 *
	 * @example
	 * const Todo = types.model({
	 *   id: types.identifier(types.number),
	 *   task: types.string
	 * })
	 *
	 * const TodoStore = types.model({
	 *   todos: types.map(Todo)
	 * })
	 *
	 * const s = TodoStore.create({ todos: {} })
	 * unprotect(s)
	 * s.todos.set(17, { task: "Grab coffee", id: 17 })
	 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
	 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
	 *
	 * @export
	 * @alias types.map
	 * @param {IType<S, T>} subtype
	 * @returns {IComplexType<S[], IObservableArray<T>>}
	 */
	function map$$1(subtype) {
	    return new MapType$$1("map<string, " + subtype.name + ">", subtype);
	}
	
	function arrayToString$$1() {
	    return getStateTreeNode$$1(this) + "(" + this.length + " items)";
	}
	var ArrayType$$1 = /** @class */ (function (_super) {
	    __extends(ArrayType$$1, _super);
	    function ArrayType$$1(name, subType) {
	        var _this = _super.call(this, name) || this;
	        _this.shouldAttachNode = true;
	        _this.flags = TypeFlags$$1.Array;
	        _this.createNewInstance = function () {
	            var array$$1 = mobx.observable.array([], mobxShallow);
	            addHiddenFinalProp(array$$1, "toString", arrayToString$$1);
	            return array$$1;
	        };
	        _this.finalizeNewInstance = function (node, snapshot) {
	            var objNode = node;
	            var instance = objNode.storedValue;
	            mobx._getAdministration(instance).dehancer = objNode.unbox;
	            mobx.intercept(instance, function (change) { return _this.willChange(change); });
	            objNode.applySnapshot(snapshot);
	            mobx.observe(instance, _this.didChange);
	        };
	        _this.subType = subType;
	        return _this;
	    }
	    ArrayType$$1.prototype.describe = function () {
	        return this.subType.describe() + "[]";
	    };
	    ArrayType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot, this.createNewInstance, this.finalizeNewInstance);
	    };
	    ArrayType$$1.prototype.getChildren = function (node) {
	        return node.storedValue.peek();
	    };
	    ArrayType$$1.prototype.getChildNode = function (node, key) {
	        var index = parseInt(key, 10);
	        if (index < node.storedValue.length)
	            return node.storedValue[index];
	        return fail("Not a child: " + key);
	    };
	    ArrayType$$1.prototype.willChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        node.assertWritable();
	        var childNodes = node.getChildren();
	        switch (change.type) {
	            case "update":
	                if (change.newValue === change.object[change.index])
	                    return null;
	                change.newValue = reconcileArrayChildren(node, this.subType, [childNodes[change.index]], [change.newValue], [change.index])[0];
	                break;
	            case "splice":
	                var index_1 = change.index, removedCount = change.removedCount, added = change.added;
	                change.added = reconcileArrayChildren(node, this.subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function (_, i) { return index_1 + i; }));
	                // update paths of remaining items
	                for (var i = index_1 + removedCount; i < childNodes.length; i++) {
	                    childNodes[i].setParent(node, "" + (i + added.length - removedCount));
	                }
	                break;
	        }
	        return change;
	    };
	    ArrayType$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    ArrayType$$1.prototype.getSnapshot = function (node) {
	        return node.getChildren().map(function (childNode) { return childNode.snapshot; });
	    };
	    ArrayType$$1.prototype.didChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        switch (change.type) {
	            case "update":
	                return void node.emitPatch({
	                    op: "replace",
	                    path: "" + change.index,
	                    value: change.newValue.snapshot,
	                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
	                }, node);
	            case "splice":
	                for (var i = change.removedCount - 1; i >= 0; i--)
	                    node.emitPatch({
	                        op: "remove",
	                        path: "" + (change.index + i),
	                        oldValue: change.removed[i].snapshot
	                    }, node);
	                for (var i = 0; i < change.addedCount; i++)
	                    node.emitPatch({
	                        op: "add",
	                        path: "" + (change.index + i),
	                        value: node.getChildNode("" + (change.index + i)).snapshot,
	                        oldValue: undefined
	                    }, node);
	                return;
	        }
	    };
	    ArrayType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        var target = node.storedValue;
	        var index = subpath === "-" ? target.length : parseInt(subpath);
	        switch (patch.op) {
	            case "replace":
	                target[index] = patch.value;
	                break;
	            case "add":
	                target.splice(index, 0, patch.value);
	                break;
	            case "remove":
	                target.splice(index, 1);
	                break;
	        }
	    };
	    ArrayType$$1.prototype.applySnapshot = function (node, snapshot) {
	        typecheck$$1(this, snapshot);
	        var target = node.storedValue;
	        target.replace(snapshot);
	    };
	    ArrayType$$1.prototype.getChildType = function (key) {
	        return this.subType;
	    };
	    ArrayType$$1.prototype.isValidSnapshot = function (value, context) {
	        var _this = this;
	        if (!isArray(value)) {
	            return typeCheckFailure$$1(context, value, "Value is not an array");
	        }
	        return flattenTypeErrors$$1(value.map(function (item, index) {
	            return _this.subType.validate(item, getContextForPath$$1(context, "" + index, _this.subType));
	        }));
	    };
	    ArrayType$$1.prototype.getDefaultSnapshot = function () {
	        return [];
	    };
	    ArrayType$$1.prototype.removeChild = function (node, subpath) {
	        node.storedValue.splice(parseInt(subpath, 10), 1);
	    };
	    __decorate([
	        mobx.action
	    ], ArrayType$$1.prototype, "applySnapshot", null);
	    return ArrayType$$1;
	}(ComplexType$$1));
	/**
	 * Creates an index based collection type who's children are all of a uniform declared type.
	 *
	 * This type will always produce [observable arrays](https://mobx.js.org/refguide/array.html)
	 *
	 * @example
	 * const Todo = types.model({
	 *   task: types.string
	 * })
	 *
	 * const TodoStore = types.model({
	 *   todos: types.array(Todo)
	 * })
	 *
	 * const s = TodoStore.create({ todos: [] })
	 * unprotect(s) // needed to allow modifying outside of an action
	 * s.todos.push({ task: "Grab coffee" })
	 * console.log(s.todos[0]) // prints: "Grab coffee"
	 *
	 * @export
	 * @alias types.array
	 * @param {IType<S, T>} subtype
	 * @returns {IComplexType<S[], IObservableArray<T>>}
	 */
	function array$$1(subtype) {
	    if (false) {
	        if (!isType$$1(subtype))
	            fail("expected a mobx-state-tree type as first argument, got " + subtype + " instead");
	    }
	    return new ArrayType$$1(subtype.name + "[]", subtype);
	}
	function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
	    var oldNode, newValue, hasNewNode = false, oldMatch = undefined;
	    for (var i = 0;; i++) {
	        hasNewNode = i <= newValues.length - 1;
	        oldNode = oldNodes[i];
	        newValue = hasNewNode ? newValues[i] : undefined;
	        // for some reason, instead of newValue we got a node, fallback to the storedValue
	        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
	        if (isNode$$1(newValue))
	            newValue = newValue.storedValue;
	        // both are empty, end
	        if (!oldNode && !hasNewNode) {
	            break;
	            // new one does not exists, old one dies
	        }
	        else if (!hasNewNode) {
	            oldNode.die();
	            oldNodes.splice(i, 1);
	            i--;
	            // there is no old node, create it
	        }
	        else if (!oldNode) {
	            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
	            if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue).parent === parent) {
	                // this node is owned by this parent, but not in the reconcilable set, so it must be double
	                fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + parent.path + "/" + newPaths[i] + "', but it lives already at '" + getStateTreeNode$$1(newValue).path + "'");
	            }
	            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue));
	            // both are the same, reconcile
	        }
	        else if (areSame(oldNode, newValue)) {
	            oldNodes[i] = valueAsNode(childType, parent, "" + newPaths[i], newValue, oldNode);
	            // nothing to do, try to reorder
	        }
	        else {
	            oldMatch = undefined;
	            // find a possible candidate to reuse
	            for (var j = i; j < oldNodes.length; j++) {
	                if (areSame(oldNodes[j], newValue)) {
	                    oldMatch = oldNodes.splice(j, 1)[0];
	                    break;
	                }
	            }
	            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue, oldMatch));
	        }
	    }
	    return oldNodes;
	}
	// convert a value to a node at given parent and subpath. attempts to reuse old node if possible and given
	function valueAsNode(childType, parent, subpath, newValue, oldNode) {
	    // ensure the value is valid-ish
	    typecheck$$1(childType, newValue);
	    // the new value has a MST node
	    if (isStateTreeNode$$1(newValue)) {
	        var childNode_1 = getStateTreeNode$$1(newValue);
	        childNode_1.assertAlive();
	        // the node lives here
	        if (childNode_1.parent !== null && childNode_1.parent === parent) {
	            childNode_1.setParent(parent, subpath);
	            if (oldNode && oldNode !== childNode_1)
	                oldNode.die();
	            return childNode_1;
	        }
	    }
	    // there is old node and new one is a value/snapshot
	    if (oldNode) {
	        var childNode_2 = childType.reconcile(oldNode, newValue);
	        childNode_2.setParent(parent, subpath);
	        return childNode_2;
	    }
	    // nothing to do, create from scratch
	    var childNode = childType.instantiate(parent, subpath, parent._environment, newValue);
	    return childNode;
	}
	// given a value
	function areSame(oldNode, newValue) {
	    // the new value has the same node
	    if (isStateTreeNode$$1(newValue)) {
	        return getStateTreeNode$$1(newValue) === oldNode;
	    }
	    // the provided value is the snapshot of the old node
	    if (isMutable(newValue) && oldNode.snapshot === newValue)
	        return true;
	    // new value is a snapshot with the correct identifier
	    if (oldNode instanceof ObjectNode$$1 &&
	        oldNode.identifier !== null &&
	        oldNode.identifierAttribute &&
	        isPlainObject(newValue) &&
	        newValue[oldNode.identifierAttribute] === oldNode.identifier)
	        return true;
	    return false;
	}
	
	var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
	var HookNames$$1;
	(function (HookNames$$1) {
	    HookNames$$1["afterCreate"] = "afterCreate";
	    HookNames$$1["afterAttach"] = "afterAttach";
	    HookNames$$1["postProcessSnapshot"] = "postProcessSnapshot";
	    HookNames$$1["beforeDetach"] = "beforeDetach";
	    HookNames$$1["beforeDestroy"] = "beforeDestroy";
	})(HookNames$$1 || (HookNames$$1 = {}));
	function objectTypeToString() {
	    return getStateTreeNode$$1(this).toString();
	}
	var defaultObjectOptions = {
	    name: "AnonymousModel",
	    properties: {},
	    initializers: EMPTY_ARRAY
	};
	function toPropertiesObject(properties) {
	    // loop through properties and ensures that all items are types
	    return Object.keys(properties).reduce(function (properties, key) {
	        // warn if user intended a HOOK
	        if (key in HookNames$$1)
	            return fail("Hook '" + key + "' was defined as property. Hooks should be defined as part of the actions");
	        // the user intended to use a view
	        var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	        if ("get" in descriptor) {
	            fail("Getters are not supported as properties. Please use views instead");
	        }
	        // undefined and null are not valid
	        var value = descriptor.value;
	        if (value === null || value === undefined) {
	            fail("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
	            // its a primitive, convert to its type
	        }
	        else if (isPrimitive(value)) {
	            return Object.assign({}, properties, (_a = {},
	                _a[key] = optional$$1(getPrimitiveFactoryFromValue$$1(value), value),
	                _a));
	            // its already a type
	        }
	        else if (isType$$1(value)) {
	            return properties;
	            // its a function, maybe the user wanted a view?
	        }
	        else if (typeof value === "function") {
	            fail("Functions are not supported as properties, use views instead");
	            // no other complex values
	        }
	        else if (typeof value === "object") {
	            fail("In property '" + key + "': base models should not contain complex values: '" + value + "'");
	            // WTF did you pass in mate?
	        }
	        else {
	            fail("Unexpected value for property '" + key + "'");
	        }
	        var _a;
	    }, properties);
	}
	var ModelType$$1 = /** @class */ (function (_super) {
	    __extends(ModelType$$1, _super);
	    function ModelType$$1(opts) {
	        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
	        _this.flags = TypeFlags$$1.Object;
	        _this.shouldAttachNode = true;
	        _this.properties = {};
	        _this.createNewInstance = function () {
	            var instance = mobx.observable.object(EMPTY_OBJECT, EMPTY_OBJECT, mobxShallow);
	            addHiddenFinalProp(instance, "toString", objectTypeToString);
	            return instance;
	        };
	        _this.finalizeNewInstance = function (node, snapshot) {
	            var objNode = node;
	            var instance = objNode.storedValue;
	            _this.forAllProps(function (name, type) {
	                mobx.extendObservable(instance, (_a = {},
	                    _a[name] = type.instantiate(objNode, name, objNode._environment, snapshot[name]),
	                    _a), EMPTY_OBJECT, mobxShallow);
	                mobx._interceptReads(instance, name, objNode.unbox);
	                var _a;
	            });
	            _this.initializers.reduce(function (self, fn) { return fn(self); }, instance);
	            mobx.intercept(instance, function (change) { return _this.willChange(change); });
	            mobx.observe(instance, _this.didChange);
	        };
	        _this.didChange = function (change) {
	            if (!_this.properties[change.name]) {
	                // don't emit patches for volatile state
	                return;
	            }
	            var node = getStateTreeNode$$1(change.object);
	            var oldValue = change.oldValue ? change.oldValue.snapshot : undefined;
	            node.emitPatch({
	                op: "replace",
	                path: escapeJsonPath$$1(change.name),
	                value: change.newValue.snapshot,
	                oldValue: oldValue
	            }, node);
	        };
	        var name = opts.name || defaultObjectOptions.name;
	        // TODO: this test still needed?
	        if (!/^\w[\w\d_]*$/.test(name))
	            fail("Typename should be a valid identifier: " + name);
	        Object.assign(_this, defaultObjectOptions, opts);
	        // ensures that any default value gets converted to its related type
	        _this.properties = toPropertiesObject(_this.properties);
	        freeze(_this.properties); // make sure nobody messes with it
	        return _this;
	    }
	    Object.defineProperty(ModelType$$1.prototype, "propertyNames", {
	        get: function () {
	            return Object.keys(this.properties);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ModelType$$1.prototype.cloneAndEnhance = function (opts) {
	        return new ModelType$$1({
	            name: opts.name || this.name,
	            properties: Object.assign({}, this.properties, opts.properties),
	            initializers: this.initializers.concat(opts.initializers || []),
	            preProcessor: opts.preProcessor || this.preProcessor
	        });
	    };
	    ModelType$$1.prototype.actions = function (fn) {
	        var _this = this;
	        var actionInitializer = function (self) {
	            _this.instantiateActions(self, fn(self));
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [actionInitializer] });
	    };
	    ModelType$$1.prototype.instantiateActions = function (self, actions) {
	        // check if return is correct
	        if (!isPlainObject(actions))
	            fail("actions initializer should return a plain object containing actions");
	        // bind actions to the object created
	        Object.keys(actions).forEach(function (name) {
	            // warn if preprocessor was given
	            if (name === PRE_PROCESS_SNAPSHOT)
	                return fail("Cannot define action '" + PRE_PROCESS_SNAPSHOT + "', it should be defined using 'type.preProcessSnapshot(fn)' instead");
	            // apply hook composition
	            var action$$1 = actions[name];
	            var baseAction = self[name];
	            if (name in HookNames$$1 && baseAction) {
	                var specializedAction_1 = action$$1;
	                if (name === HookNames$$1.postProcessSnapshot)
	                    action$$1 = function (snapshot) { return specializedAction_1(baseAction(snapshot)); };
	                else
	                    action$$1 = function () {
	                        baseAction.apply(null, arguments);
	                        specializedAction_1.apply(null, arguments);
	                    };
	            }
	            // See #646, allow models to be mocked
	            
	            ( true ? addHiddenFinalProp : addHiddenWritableProp)(self, name, createActionInvoker$$1(self, name, action$$1));
	            return;
	        });
	    };
	    ModelType$$1.prototype.named = function (name) {
	        return this.cloneAndEnhance({ name: name });
	    };
	    ModelType$$1.prototype.props = function (properties) {
	        return this.cloneAndEnhance({ properties: properties });
	    };
	    ModelType$$1.prototype.volatile = function (fn) {
	        var _this = this;
	        var stateInitializer = function (self) {
	            _this.instantiateVolatileState(self, fn(self));
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [stateInitializer] });
	    };
	    ModelType$$1.prototype.instantiateVolatileState = function (self, state) {
	        // check views return
	        if (!isPlainObject(state))
	            fail("volatile state initializer should return a plain object containing state");
	        // TODO: typecheck & namecheck members of state?
	        mobx.extendObservable(self, state, EMPTY_OBJECT, mobxShallow);
	    };
	    ModelType$$1.prototype.extend = function (fn) {
	        var _this = this;
	        var initializer = function (self) {
	            var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, ["actions", "views", "state"]);
	            for (var key in rest)
	                fail("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '" + key + "'");
	            if (state)
	                _this.instantiateVolatileState(self, state);
	            if (views)
	                _this.instantiateViews(self, views);
	            if (actions)
	                _this.instantiateActions(self, actions);
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [initializer] });
	    };
	    ModelType$$1.prototype.views = function (fn) {
	        var _this = this;
	        var viewInitializer = function (self) {
	            _this.instantiateViews(self, fn(self));
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [viewInitializer] });
	    };
	    ModelType$$1.prototype.instantiateViews = function (self, views) {
	        // check views return
	        if (!isPlainObject(views))
	            fail("views initializer should return a plain object containing views");
	        Object.keys(views).forEach(function (key) {
	            // is this a computed property?
	            var descriptor = Object.getOwnPropertyDescriptor(views, key);
	            var value = descriptor.value;
	            if ("get" in descriptor) {
	                // TODO: mobx currently does not allow redefining computes yet, pending #1121
	                if (mobx.isComputed(self.$mobx.values[key])) {
	                    // TODO: use `isComputed(self, key)`, pending mobx #1120
	                    
	                    self.$mobx.values[key] = mobx.computed(descriptor.get, {
	                        name: key,
	                        set: descriptor.set,
	                        context: self
	                    });
	                }
	                else {
	                    var tmp = {};
	                    Object.defineProperty(tmp, key, {
	                        get: descriptor.get,
	                        set: descriptor.set,
	                        enumerable: true
	                    });
	                    mobx.extendObservable(self, tmp, EMPTY_OBJECT, mobxShallow);
	                }
	            }
	            else if (typeof value === "function") {
	                // this is a view function, merge as is!
	                // See #646, allow models to be mocked
	                
	                ( true
	                    ? addHiddenFinalProp
	                    : addHiddenWritableProp)(self, key, value);
	            }
	            else {
	                fail("A view member should either be a function or getter based property");
	            }
	        });
	    };
	    ModelType$$1.prototype.preProcessSnapshot = function (preProcessor) {
	        var currentPreprocessor = this.preProcessor;
	        if (!currentPreprocessor)
	            return this.cloneAndEnhance({ preProcessor: preProcessor });
	        else
	            return this.cloneAndEnhance({
	                preProcessor: function (snapshot) { return currentPreprocessor(preProcessor(snapshot)); }
	            });
	    };
	    ModelType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, this.applySnapshotPreProcessor(snapshot), this.createNewInstance, this.finalizeNewInstance);
	        // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
	        // that pre-reserves all these fields for fast object-member lookups
	    };
	    ModelType$$1.prototype.willChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        node.assertWritable();
	        var type = this.properties[change.name];
	        // only properties are typed, state are stored as-is references
	        if (type) {
	            typecheck$$1(type, change.newValue);
	            change.newValue = type.reconcile(node.getChildNode(change.name), change.newValue);
	        }
	        return change;
	    };
	    ModelType$$1.prototype.getChildren = function (node) {
	        var _this = this;
	        var res = [];
	        this.forAllProps(function (name, type) {
	            res.push(_this.getChildNode(node, name));
	        });
	        return res;
	    };
	    ModelType$$1.prototype.getChildNode = function (node, key) {
	        if (!(key in this.properties))
	            return fail("Not a value property: " + key);
	        var childNode = node.storedValue.$mobx.values[key].value; // TODO: blegh!
	        if (!childNode)
	            return fail("Node not available for property " + key);
	        return childNode;
	    };
	    ModelType$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    ModelType$$1.prototype.getSnapshot = function (node) {
	        var _this = this;
	        var res = {};
	        this.forAllProps(function (name, type) {
	            // TODO: FIXME, make sure the observable ref is used!
	            
	            mobx.getAtom(node.storedValue, name).reportObserved();
	            res[name] = _this.getChildNode(node, name).snapshot;
	        });
	        if (typeof node.storedValue.postProcessSnapshot === "function") {
	            return node.storedValue.postProcessSnapshot.call(null, res);
	        }
	        return res;
	    };
	    ModelType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        if (!(patch.op === "replace" || patch.op === "add"))
	            fail("object does not support operation " + patch.op);
	        node.storedValue[subpath] = patch.value;
	    };
	    ModelType$$1.prototype.applySnapshot = function (node, snapshot) {
	        var s = this.applySnapshotPreProcessor(snapshot);
	        typecheck$$1(this, s);
	        this.forAllProps(function (name, type) {
	            node.storedValue[name] = s[name];
	        });
	    };
	    ModelType$$1.prototype.applySnapshotPreProcessor = function (snapshot) {
	        if (this.preProcessor)
	            return this.preProcessor.call(null, snapshot);
	        return snapshot;
	    };
	    ModelType$$1.prototype.getChildType = function (key) {
	        return this.properties[key];
	    };
	    ModelType$$1.prototype.isValidSnapshot = function (value, context) {
	        var _this = this;
	        var snapshot = this.applySnapshotPreProcessor(value);
	        if (!isPlainObject(snapshot)) {
	            return typeCheckFailure$$1(context, snapshot, "Value is not a plain object");
	        }
	        return flattenTypeErrors$$1(this.propertyNames.map(function (key) {
	            return _this.properties[key].validate(snapshot[key], getContextForPath$$1(context, key, _this.properties[key]));
	        }));
	    };
	    ModelType$$1.prototype.forAllProps = function (fn) {
	        var _this = this;
	        this.propertyNames.forEach(function (key) { return fn(key, _this.properties[key]); });
	    };
	    ModelType$$1.prototype.describe = function () {
	        var _this = this;
	        // optimization: cache
	        return ("{ " +
	            this.propertyNames.map(function (key) { return key + ": " + _this.properties[key].describe(); }).join("; ") +
	            " }");
	    };
	    ModelType$$1.prototype.getDefaultSnapshot = function () {
	        return {};
	    };
	    ModelType$$1.prototype.removeChild = function (node, subpath) {
	        node.storedValue[subpath] = null;
	    };
	    __decorate([
	        mobx.action
	    ], ModelType$$1.prototype, "applySnapshot", null);
	    return ModelType$$1;
	}(ComplexType$$1));
	/**
	 * Creates a new model type by providing a name, properties, volatile state and actions.
	 *
	 * See the [model type](https://github.com/mobxjs/mobx-state-tree#creating-models) description or the [getting started](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/getting-started.md#getting-started-1) tutorial.
	 *
	 * @export
	 * @alias types.model
	 */
	function model$$1() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
	    var properties = args.shift() || {};
	    return new ModelType$$1({ name: name, properties: properties });
	}
	/**
	 * Composes a new model from one or more existing model types.
	 * This method can be invoked in two forms:
	 * Given 2 or more model types, the types are composed into a new Type.
	 *
	 * @export
	 * @alias types.compose
	 */
	function compose$$1() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // TODO: just join the base type names if no name is provided
	    var typeName = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
	    // check all parameters
	    if (false) {
	        args.forEach(function (type) {
	            if (!isType$$1(type))
	                fail("expected a mobx-state-tree type, got " + type + " instead");
	        });
	    }
	    return args
	        .reduce(function (prev, cur) {
	        return prev.cloneAndEnhance({
	            name: prev.name + "_" + cur.name,
	            properties: cur.properties,
	            initializers: cur.initializers
	        });
	    })
	        .named(typeName);
	}
	
	// TODO: implement CoreType using types.custom ?
	var CoreType$$1 = /** @class */ (function (_super) {
	    __extends(CoreType$$1, _super);
	    function CoreType$$1(name, flags, checker, initializer) {
	        if (initializer === void 0) { initializer = identity; }
	        var _this = _super.call(this, name) || this;
	        _this.shouldAttachNode = false;
	        _this.flags = flags;
	        _this.checker = checker;
	        _this.initializer = initializer;
	        return _this;
	    }
	    CoreType$$1.prototype.describe = function () {
	        return this.name;
	    };
	    CoreType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot, this.initializer);
	    };
	    CoreType$$1.prototype.isValidSnapshot = function (value, context) {
	        if (isPrimitive(value) && this.checker(value)) {
	            return typeCheckSuccess$$1();
	        }
	        var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
	        return typeCheckFailure$$1(context, value, "Value is not a " + typeName);
	    };
	    return CoreType$$1;
	}(Type$$1));
	/**
	 * Creates a type that can only contain a string value.
	 * This type is used for string values by default
	 *
	 * @export
	 * @alias types.string
	 * @example
	 * const Person = types.model({
	 *   firstName: types.string,
	 *   lastName: "Doe"
	 * })
	 */
	// tslint:disable-next-line:variable-name
	var string$$1 = new CoreType$$1("string", TypeFlags$$1.String, function (v) { return typeof v === "string"; });
	/**
	 * Creates a type that can only contain a numeric value.
	 * This type is used for numeric values by default
	 *
	 * @export
	 * @alias types.number
	 * @example
	 * const Vector = types.model({
	 *   x: types.number,
	 *   y: 0
	 * })
	 */
	// tslint:disable-next-line:variable-name
	var number$$1 = new CoreType$$1("number", TypeFlags$$1.Number, function (v) { return typeof v === "number"; });
	/**
	 * Creates a type that can only contain a boolean value.
	 * This type is used for boolean values by default
	 *
	 * @export
	 * @alias types.boolean
	 * @example
	 * const Thing = types.model({
	 *   isCool: types.boolean,
	 *   isAwesome: false
	 * })
	 */
	// tslint:disable-next-line:variable-name
	var boolean$$1 = new CoreType$$1("boolean", TypeFlags$$1.Boolean, function (v) { return typeof v === "boolean"; });
	/**
	 * The type of the value `null`
	 *
	 * @export
	 * @alias types.null
	 */
	var nullType$$1 = new CoreType$$1("null", TypeFlags$$1.Null, function (v) { return v === null; });
	/**
	 * The type of the value `undefined`
	 *
	 * @export
	 * @alias types.undefined
	 */
	var undefinedType$$1 = new CoreType$$1("undefined", TypeFlags$$1.Undefined, function (v) { return v === undefined; });
	/**
	 * Creates a type that can only contain a javascript Date value.
	 *
	 * @export
	 * @alias types.Date
	 * @example
	 * const LogLine = types.model({
	 *   timestamp: types.Date,
	 * })
	 *
	 * LogLine.create({ timestamp: new Date() })
	 */
	// tslint:disable-next-line:variable-name
	var DatePrimitive$$1 = new CoreType$$1("Date", TypeFlags$$1.Date, function (v) { return typeof v === "number" || v instanceof Date; }, function (v) { return (v instanceof Date ? v : new Date(v)); });
	DatePrimitive$$1.getSnapshot = function (node) {
	    return node.storedValue.getTime();
	};
	function getPrimitiveFactoryFromValue$$1(value) {
	    switch (typeof value) {
	        case "string":
	            return string$$1;
	        case "number":
	            return number$$1;
	        case "boolean":
	            return boolean$$1;
	        case "object":
	            if (value instanceof Date)
	                return DatePrimitive$$1;
	    }
	    return fail("Cannot determine primitive type from value " + value);
	}
	function isPrimitiveType$$1(type) {
	    return (isType$$1(type) &&
	        (type.flags & (TypeFlags$$1.String | TypeFlags$$1.Number | TypeFlags$$1.Boolean | TypeFlags$$1.Date)) >
	            0);
	}
	
	var Literal$$1 = /** @class */ (function (_super) {
	    __extends(Literal$$1, _super);
	    function Literal$$1(value) {
	        var _this = _super.call(this, JSON.stringify(value)) || this;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Literal;
	        _this.value = value;
	        return _this;
	    }
	    Literal$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot);
	    };
	    Literal$$1.prototype.describe = function () {
	        return JSON.stringify(this.value);
	    };
	    Literal$$1.prototype.isValidSnapshot = function (value, context) {
	        if (isPrimitive(value) && value === this.value) {
	            return typeCheckSuccess$$1();
	        }
	        return typeCheckFailure$$1(context, value, "Value is not a literal " + JSON.stringify(this.value));
	    };
	    return Literal$$1;
	}(Type$$1));
	/**
	 * The literal type will return a type that will match only the exact given type.
	 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
	 * You can use literal to match exact strings for example the exact male or female string.
	 *
	 * @example
	 * const Person = types.model({
	 *     name: types.string,
	 *     gender: types.union(types.literal('male'), types.literal('female'))
	 * })
	 *
	 * @export
	 * @alias types.literal
	 * @template S
	 * @param {S} value The value to use in the strict equal check
	 * @returns {ISimpleType<S>}
	 */
	function literal$$1(value) {
	    // check that the given value is a primitive
	    if (false) {
	        if (!isPrimitive(value))
	            fail("Literal types can be built only on top of primitives");
	    }
	    return new Literal$$1(value);
	}
	
	var Refinement$$1 = /** @class */ (function (_super) {
	    __extends(Refinement$$1, _super);
	    function Refinement$$1(name, type, predicate, message) {
	        var _this = _super.call(this, name) || this;
	        _this.type = type;
	        _this.predicate = predicate;
	        _this.message = message;
	        return _this;
	    }
	    Object.defineProperty(Refinement$$1.prototype, "flags", {
	        get: function () {
	            return this.type.flags | TypeFlags$$1.Refinement;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Refinement$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.type.shouldAttachNode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Refinement$$1.prototype.describe = function () {
	        return this.name;
	    };
	    Refinement$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        // create the child type
	        var inst = this.type.instantiate(parent, subpath, environment, value);
	        return inst;
	    };
	    Refinement$$1.prototype.isAssignableFrom = function (type) {
	        return this.type.isAssignableFrom(type);
	    };
	    Refinement$$1.prototype.isValidSnapshot = function (value, context) {
	        var subtypeErrors = this.type.validate(value, context);
	        if (subtypeErrors.length > 0)
	            return subtypeErrors;
	        var snapshot = isStateTreeNode$$1(value) ? getStateTreeNode$$1(value).snapshot : value;
	        if (!this.predicate(snapshot)) {
	            return typeCheckFailure$$1(context, value, this.message(value));
	        }
	        return typeCheckSuccess$$1();
	    };
	    return Refinement$$1;
	}(Type$$1));
	/**
	 * `types.refinement(baseType, (snapshot) => boolean)` creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
	 *
	 * @export
	 * @alias types.refinement
	 * @template T
	 * @param {string} name
	 * @param {IType<T, T>} type
	 * @param {(snapshot: T) => boolean} predicate
	 * @returns {IType<T, T>}
	 */
	function refinement$$1() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var name = typeof args[0] === "string" ? args.shift() : isType$$1(args[0]) ? args[0].name : null;
	    var type = args[0];
	    var predicate = args[1];
	    var message = args[2]
	        ? args[2]
	        : function (v) { return "Value does not respect the refinement predicate"; };
	    // ensures all parameters are correct
	    if (false) {
	        if (typeof name !== "string")
	            fail("expected a string as first argument, got " + name + " instead");
	        if (!isType$$1(type))
	            fail("expected a mobx-state-tree type as first or second argument, got " +
	                type +
	                " instead");
	        if (typeof predicate !== "function")
	            fail("expected a function as third argument, got " + predicate + " instead");
	        if (typeof message !== "function")
	            fail("expected a function as fourth argument, got " + message + " instead");
	    }
	    return new Refinement$$1(name, type, predicate, message);
	}
	
	/**
	 * Can be used to create an string based enumeration.
	 * (note: this methods is just sugar for a union of string literals)
	 *
	 * @example
	 * const TrafficLight = types.model({
	 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
	 * })
	 *
	 * @export
	 * @alias types.enumeration
	 * @param {string} name descriptive name of the enumeration (optional)
	 * @param {string[]} options possible values this enumeration can have
	 * @returns {ISimpleType<string>}
	 */
	function enumeration$$1(name, options) {
	    var realOptions = typeof name === "string" ? options : name;
	    // check all options
	    if (false) {
	        realOptions.forEach(function (option) {
	            if (typeof option !== "string")
	                fail("expected all options to be string, got " + type + " instead");
	        });
	    }
	    var type = union$$1.apply(void 0, realOptions.map(function (option) { return literal$$1("" + option); }));
	    if (typeof name === "string")
	        type.name = name;
	    return type;
	}
	
	var Union$$1 = /** @class */ (function (_super) {
	    __extends(Union$$1, _super);
	    function Union$$1(name, types, dispatcher) {
	        var _this = _super.call(this, name) || this;
	        _this.dispatcher = null;
	        _this.dispatcher = dispatcher;
	        _this.types = types;
	        return _this;
	    }
	    Object.defineProperty(Union$$1.prototype, "flags", {
	        get: function () {
	            var result = TypeFlags$$1.Union;
	            this.types.forEach(function (type) {
	                result |= type.flags;
	            });
	            return result;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Union$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.types.some(function (type) { return type.shouldAttachNode; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Union$$1.prototype.isAssignableFrom = function (type) {
	        return this.types.some(function (subType) { return subType.isAssignableFrom(type); });
	    };
	    Union$$1.prototype.describe = function () {
	        return "(" + this.types.map(function (factory) { return factory.describe(); }).join(" | ") + ")";
	    };
	    Union$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        return this.determineType(value).instantiate(parent, subpath, environment, value);
	    };
	    Union$$1.prototype.reconcile = function (current, newValue) {
	        return this.determineType(newValue).reconcile(current, newValue);
	    };
	    Union$$1.prototype.determineType = function (value) {
	        // try the dispatcher, if defined
	        if (this.dispatcher !== null) {
	            return this.dispatcher(value);
	        }
	        // find the most accomodating type
	        var applicableTypes = this.types.filter(function (type) { return type.is(value); });
	        if (applicableTypes.length > 1)
	            return fail("Ambiguos snapshot " + JSON.stringify(value) + " for union " + this
	                .name + ". Please provide a dispatch in the union declaration.");
	        return applicableTypes[0];
	    };
	    Union$$1.prototype.isValidSnapshot = function (value, context) {
	        if (this.dispatcher !== null) {
	            return this.dispatcher(value).validate(value, context);
	        }
	        var errors = this.types.map(function (type) { return type.validate(value, context); });
	        var applicableTypes = errors.filter(function (errorArray) { return errorArray.length === 0; });
	        if (applicableTypes.length > 1) {
	            return typeCheckFailure$$1(context, value, "Multiple types are applicable for the union (hint: provide a dispatch function)");
	        }
	        else if (applicableTypes.length === 0) {
	            return typeCheckFailure$$1(context, value, "No type is applicable for the union").concat(flattenTypeErrors$$1(errors));
	        }
	        return typeCheckSuccess$$1();
	    };
	    return Union$$1;
	}(Type$$1));
	/**
	 * types.union(dispatcher?, types...) create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form (snapshot) => Type.
	 *
	 * @export
	 * @alias types.union
	 * @param {(ITypeDispatcher | IType<any, any>)} dispatchOrType
	 * @param {...IType<any, any>[]} otherTypes
	 * @returns {IType<any, any>}
	 */
	function union$$1(dispatchOrType) {
	    var otherTypes = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        otherTypes[_i - 1] = arguments[_i];
	    }
	    var dispatcher = isType$$1(dispatchOrType) ? null : dispatchOrType;
	    var types = isType$$1(dispatchOrType) ? otherTypes.concat(dispatchOrType) : otherTypes;
	    var name = "(" + types.map(function (type) { return type.name; }).join(" | ") + ")";
	    // check all options
	    if (false) {
	        types.forEach(function (type) {
	            if (!isType$$1(type))
	                fail("expected all possible types to be a mobx-state-tree type, got " +
	                    type +
	                    " instead");
	        });
	    }
	    return new Union$$1(name, types, dispatcher);
	}
	
	var OptionalValue$$1 = /** @class */ (function (_super) {
	    __extends(OptionalValue$$1, _super);
	    function OptionalValue$$1(type, defaultValue) {
	        var _this = _super.call(this, type.name) || this;
	        _this.type = type;
	        _this.defaultValue = defaultValue;
	        return _this;
	    }
	    Object.defineProperty(OptionalValue$$1.prototype, "flags", {
	        get: function () {
	            return this.type.flags | TypeFlags$$1.Optional;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OptionalValue$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.type.shouldAttachNode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OptionalValue$$1.prototype.describe = function () {
	        return this.type.describe() + "?";
	    };
	    OptionalValue$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        if (typeof value === "undefined") {
	            var defaultValue = this.getDefaultValue();
	            var defaultSnapshot = isStateTreeNode$$1(defaultValue)
	                ? getStateTreeNode$$1(defaultValue).snapshot
	                : defaultValue;
	            return this.type.instantiate(parent, subpath, environment, defaultSnapshot);
	        }
	        return this.type.instantiate(parent, subpath, environment, value);
	    };
	    OptionalValue$$1.prototype.reconcile = function (current, newValue) {
	        return this.type.reconcile(current, this.type.is(newValue) ? newValue : this.getDefaultValue());
	    };
	    OptionalValue$$1.prototype.getDefaultValue = function () {
	        var defaultValue = typeof this.defaultValue === "function" ? this.defaultValue() : this.defaultValue;
	        if (typeof this.defaultValue === "function")
	            typecheck$$1(this, defaultValue);
	        return defaultValue;
	    };
	    OptionalValue$$1.prototype.isValidSnapshot = function (value, context) {
	        // defaulted values can be skipped
	        if (value === undefined) {
	            return typeCheckSuccess$$1();
	        }
	        // bounce validation to the sub-type
	        return this.type.validate(value, context);
	    };
	    OptionalValue$$1.prototype.isAssignableFrom = function (type) {
	        return this.type.isAssignableFrom(type);
	    };
	    return OptionalValue$$1;
	}(Type$$1));
	/**
	 * `types.optional` can be used to create a property with a default value.
	 * If the given value is not provided in the snapshot, it will default to the provided `defaultValue`.
	 * If `defaultValue` is a function, the function will be invoked for every new instance.
	 * Applying a snapshot in which the optional value is _not_ present, causes the value to be reset
	 *
	 * @example
	 * const Todo = types.model({
	 *   title: types.optional(types.string, "Test"),
	 *   done: types.optional(types.boolean, false),
	 *   created: types.optional(types.Date, () => new Date())
	 * })
	 *
	 * // it is now okay to omit 'created' and 'done'. created will get a freshly generated timestamp
	 * const todo = Todo.create({ title: "Get coffee "})
	 *
	 * @export
	 * @alias types.optional
	 */
	function optional$$1(type, defaultValueOrFunction) {
	    if (false) {
	        if (!isType$$1(type))
	            fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
	        var defaultValue = typeof defaultValueOrFunction === "function"
	            ? defaultValueOrFunction()
	            : defaultValueOrFunction;
	        var defaultSnapshot = isStateTreeNode$$1(defaultValue)
	            ? getStateTreeNode$$1(defaultValue).snapshot
	            : defaultValue;
	        typecheck$$1(type, defaultSnapshot);
	    }
	    return new OptionalValue$$1(type, defaultValueOrFunction);
	}
	
	var optionalNullType = optional$$1(nullType$$1, null);
	/**
	 * Maybe will make a type nullable, and also null by default.
	 *
	 * @export
	 * @alias types.maybe
	 * @template S
	 * @template T
	 * @param {IType<S, T>} type The type to make nullable
	 * @returns {(IType<S | null | undefined, T | null>)}
	 */
	function maybe$$1(type) {
	    if (false) {
	        if (!isType$$1(type))
	            fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
	        if (type === frozen$$1) {
	            fail("Unable to declare `types.maybe(types.frozen)`. Frozen already accepts `null`. Consider using `types.optional(types.frozen, null)` instead.");
	        }
	    }
	    return union$$1(optionalNullType, type);
	}
	
	var Late$$1 = /** @class */ (function (_super) {
	    __extends(Late$$1, _super);
	    function Late$$1(name, definition) {
	        var _this = _super.call(this, name) || this;
	        _this._subType = null;
	        _this.definition = definition;
	        return _this;
	    }
	    Object.defineProperty(Late$$1.prototype, "flags", {
	        get: function () {
	            return this.subType.flags | TypeFlags$$1.Late;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Late$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.subType.shouldAttachNode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Late$$1.prototype, "subType", {
	        get: function () {
	            if (this._subType === null) {
	                this._subType = this.definition();
	            }
	            return this._subType;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Late$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return this.subType.instantiate(parent, subpath, environment, snapshot);
	    };
	    Late$$1.prototype.reconcile = function (current, newValue) {
	        return this.subType.reconcile(current, newValue);
	    };
	    Late$$1.prototype.describe = function () {
	        return this.subType.name;
	    };
	    Late$$1.prototype.isValidSnapshot = function (value, context) {
	        return this.subType.validate(value, context);
	    };
	    Late$$1.prototype.isAssignableFrom = function (type) {
	        return this.subType.isAssignableFrom(type);
	    };
	    return Late$$1;
	}(Type$$1));
	/**
	 * Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
	 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
	 * You need to declare an interface to explicit the return type of the late parameter function.
	 *
	 * @example
	 *  interface INode {
	 *       childs: INode[]
	 *  }
	 *
	 *   // TypeScript is'nt smart enough to infer self referencing types.
	 *  const Node = types.model({
	 *       childs: types.optional(types.array(types.late<any, INode>(() => Node)), [])
	 *  })
	 *
	 * @export
	 * @alias types.late
	 * @template S
	 * @template T
	 * @param {string} [name] The name to use for the type that will be returned.
	 * @param {ILateType<S, T>} type A function that returns the type that will be defined.
	 * @returns {IType<S, T>}
	 */
	function late$$1(nameOrType, maybeType) {
	    var name = typeof nameOrType === "string" ? nameOrType : "late(" + nameOrType.toString() + ")";
	    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
	    // checks that the type is actually a late type
	    if (false) {
	        if (!(typeof type === "function" && type.length === 0))
	            fail("Invalid late type, expected a function with zero arguments that returns a type, got: " +
	                type);
	    }
	    return new Late$$1(name, type);
	}
	
	var Frozen$$1 = /** @class */ (function (_super) {
	    __extends(Frozen$$1, _super);
	    function Frozen$$1() {
	        var _this = _super.call(this, "frozen") || this;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Frozen;
	        return _this;
	    }
	    Frozen$$1.prototype.describe = function () {
	        return "<any immutable value>";
	    };
	    Frozen$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        // create the node
	        return createNode$$1(this, parent, subpath, environment, deepFreeze(value));
	    };
	    Frozen$$1.prototype.isValidSnapshot = function (value, context) {
	        if (!isSerializable(value)) {
	            return typeCheckFailure$$1(context, value, "Value is not serializable and cannot be frozen");
	        }
	        return typeCheckSuccess$$1();
	    };
	    return Frozen$$1;
	}(Type$$1));
	/**
	 * Frozen can be used to story any value that is serializable in itself (that is valid JSON).
	 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
	 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
	 *
	 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
	 *
	 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
	 *
	 * @example
	 * const GameCharacter = types.model({
	 *   name: string,
	 *   location: types.frozen
	 * })
	 *
	 * const hero = GameCharacter.create({
	 *   name: "Mario",
	 *   location: { x: 7, y: 4 }
	 * })
	 *
	 * hero.location = { x: 10, y: 2 } // OK
	 * hero.location.x = 7 // Not ok!
	 *
	 * @alias types.frozen
	 */
	var frozen$$1 = new Frozen$$1();
	
	var StoredReference = /** @class */ (function () {
	    function StoredReference(mode, value) {
	        this.mode = mode;
	        this.value = value;
	        if (mode === "object") {
	            if (!isStateTreeNode$$1(value))
	                return fail("Can only store references to tree nodes, got: '" + value + "'");
	            var targetNode = getStateTreeNode$$1(value);
	            if (!targetNode.identifierAttribute)
	                return fail("Can only store references with a defined identifier attribute.");
	        }
	    }
	    return StoredReference;
	}());
	var BaseReferenceType$$1 = /** @class */ (function (_super) {
	    __extends(BaseReferenceType$$1, _super);
	    function BaseReferenceType$$1(targetType) {
	        var _this = _super.call(this, "reference(" + targetType.name + ")") || this;
	        _this.targetType = targetType;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Reference;
	        return _this;
	    }
	    BaseReferenceType$$1.prototype.describe = function () {
	        return this.name;
	    };
	    BaseReferenceType$$1.prototype.isAssignableFrom = function (type) {
	        return this.targetType.isAssignableFrom(type);
	    };
	    BaseReferenceType$$1.prototype.isValidSnapshot = function (value, context) {
	        return typeof value === "string" || typeof value === "number"
	            ? typeCheckSuccess$$1()
	            : typeCheckFailure$$1(context, value, "Value is not a valid identifier, which is a string or a number");
	    };
	    return BaseReferenceType$$1;
	}(Type$$1));
	var IdentifierReferenceType$$1 = /** @class */ (function (_super) {
	    __extends(IdentifierReferenceType$$1, _super);
	    function IdentifierReferenceType$$1(targetType) {
	        return _super.call(this, targetType) || this;
	    }
	    IdentifierReferenceType$$1.prototype.getValue = function (node) {
	        if (!node.isAlive)
	            return undefined;
	        var ref = node.storedValue;
	        // id already resolved, return
	        if (ref.mode === "object")
	            return ref.value;
	        // reference was initialized with the identifier of the target
	        var target = node.root.identifierCache.resolve(this.targetType, ref.value);
	        if (!target)
	            return fail("Failed to resolve reference '" + ref.value + "' to type '" + this.targetType
	                .name + "' (from node: " + node.path + ")");
	        return target.value;
	    };
	    IdentifierReferenceType$$1.prototype.getSnapshot = function (node) {
	        var ref = node.storedValue;
	        switch (ref.mode) {
	            case "identifier":
	                return ref.value;
	            case "object":
	                return getStateTreeNode$$1(ref.value).identifier;
	        }
	    };
	    IdentifierReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, new StoredReference(isStateTreeNode$$1(snapshot) ? "object" : "identifier", snapshot));
	    };
	    IdentifierReferenceType$$1.prototype.reconcile = function (current, newValue) {
	        if (current.type === this) {
	            var targetMode = isStateTreeNode$$1(newValue) ? "object" : "identifier";
	            var ref = current.storedValue;
	            if (targetMode === ref.mode && ref.value === newValue)
	                return current;
	        }
	        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newValue);
	        current.die();
	        return newNode;
	    };
	    return IdentifierReferenceType$$1;
	}(BaseReferenceType$$1));
	var CustomReferenceType$$1 = /** @class */ (function (_super) {
	    __extends(CustomReferenceType$$1, _super);
	    function CustomReferenceType$$1(targetType, options) {
	        var _this = _super.call(this, targetType) || this;
	        _this.options = options;
	        return _this;
	    }
	    CustomReferenceType$$1.prototype.getValue = function (node) {
	        if (!node.isAlive)
	            return undefined;
	        return this.options.get(node.storedValue, node.parent ? node.parent.storedValue : null);
	    };
	    CustomReferenceType$$1.prototype.getSnapshot = function (node) {
	        return node.storedValue;
	    };
	    CustomReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        var identifier$$1 = isStateTreeNode$$1(snapshot)
	            ? this.options.set(snapshot, parent ? parent.storedValue : null)
	            : snapshot;
	        return createNode$$1(this, parent, subpath, environment, identifier$$1);
	    };
	    CustomReferenceType$$1.prototype.reconcile = function (current, snapshot) {
	        var newIdentifier = isStateTreeNode$$1(snapshot)
	            ? this.options.set(snapshot, current ? current.storedValue : null)
	            : snapshot;
	        if (current.type === this) {
	            if (current.storedValue === newIdentifier)
	                return current;
	        }
	        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newIdentifier);
	        current.die();
	        return newNode;
	    };
	    return CustomReferenceType$$1;
	}(BaseReferenceType$$1));
	/**
	 * Creates a reference to another type, which should have defined an identifier.
	 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
	 *
	 * @export
	 * @alias types.reference
	 */
	function reference$$1(subType, options) {
	    // check that a type is given
	    if (false) {
	        if (!isType$$1(subType))
	            fail("expected a mobx-state-tree type as first argument, got " + subType + " instead");
	        if (arguments.length === 2 && typeof arguments[1] === "string")
	            fail("References with base path are no longer supported. Please remove the base path.");
	    }
	    if (options)
	        return new CustomReferenceType$$1(subType, options);
	    else
	        return new IdentifierReferenceType$$1(subType);
	}
	
	var IdentifierType$$1 = /** @class */ (function (_super) {
	    __extends(IdentifierType$$1, _super);
	    function IdentifierType$$1(identifierType) {
	        var _this = _super.call(this, "identifier(" + identifierType.name + ")") || this;
	        _this.identifierType = identifierType;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Identifier;
	        return _this;
	    }
	    IdentifierType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        if (!parent || !isStateTreeNode$$1(parent.storedValue))
	            return fail("Identifier types can only be instantiated as direct child of a model type");
	        if (parent.identifierAttribute)
	            fail("Cannot define property '" + subpath + "' as object identifier, property '" + parent.identifierAttribute + "' is already defined as identifier property");
	        parent.identifierAttribute = subpath;
	        return createNode$$1(this, parent, subpath, environment, snapshot);
	    };
	    IdentifierType$$1.prototype.reconcile = function (current, newValue) {
	        if (current.storedValue !== newValue)
	            return fail("Tried to change identifier from '" + current.storedValue + "' to '" + newValue + "'. Changing identifiers is not allowed.");
	        return current;
	    };
	    IdentifierType$$1.prototype.describe = function () {
	        return "identifier(" + this.identifierType.describe() + ")";
	    };
	    IdentifierType$$1.prototype.isValidSnapshot = function (value, context) {
	        if (value === undefined ||
	            value === null ||
	            typeof value === "string" ||
	            typeof value === "number")
	            return this.identifierType.validate(value, context);
	        return typeCheckFailure$$1(context, value, "Value is not a valid identifier, which is a string or a number");
	    };
	    return IdentifierType$$1;
	}(Type$$1));
	/**
	 * Identifiers are used to make references, lifecycle events and reconciling works.
	 * Inside a state tree, for each type can exist only one instance for each given identifier.
	 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
	 * Identifier can be used only as type property of a model.
	 * This type accepts as parameter the value type of the identifier field that can be either string or number.
	 *
	 * @example
	 *  const Todo = types.model("Todo", {
	 *      id: types.identifier(types.string),
	 *      title: types.string
	 *  })
	 *
	 * @export
	 * @alias types.identifier
	 * @template T
	 * @param {IType<T, T>} baseType
	 * @returns {IType<T, T>}
	 */
	function identifier$$1(baseType) {
	    if (baseType === void 0) { baseType = string$$1; }
	    if (false) {
	        if (!isType$$1(baseType))
	            fail("expected a mobx-state-tree type as first argument, got " + baseType + " instead");
	    }
	    return new IdentifierType$$1(baseType);
	}
	
	/**
	 * Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
	 *
	 * The signature of the options is:
	 *
	 * ```javascript
	 * export type CustomTypeOptions<S, T> = {
	 *     // Friendly name
	 *     name: string
	 *     // given a serialized value, how to turn it into the target type
	 *     fromSnapshot(snapshot: S): T
	 *     // return the serialization of the current value
	 *     toSnapshot(value: T): S
	 *     // if true, this is a converted value, if false, it's a snapshot
	 *     isTargetType(value: T | S): boolean
	 *     // a non empty string is assumed to be a validation error
	 *     getValidationMessage?(snapshot: S): string
	 * }
	 * ```
	 *
	 * @export
	 * @alias types.custom
	 *
	 * @example
	 * const DecimalPrimitive = types.custom<string, Decimal>({
	 *     name: "Decimal",
	 *     fromSnapshot(value: string) {
	 *         return new Decimal(value)
	 *     },
	 *     toSnapshot(value: Decimal) {
	 *         return value.toString()
	 *     },
	 *     isTargetType(value: string | Decimal): boolean {
	 *         return value instanceof Decimal
	 *     },
	 *     getValidationMessage(value: string): string {
	 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
	 *         return `'${value}' doesn't look like a valid decimal number`
	 *     }
	 * })
	 *
	 * const Wallet = types.model({
	 *     balance: DecimalPrimitive
	 * })
	 */
	function custom$$1(options) {
	    return new CustomType$$1(options);
	}
	var CustomType$$1 = /** @class */ (function (_super) {
	    __extends(CustomType$$1, _super);
	    function CustomType$$1(options) {
	        var _this = _super.call(this, options.name) || this;
	        _this.options = options;
	        _this.flags = TypeFlags$$1.Reference;
	        _this.shouldAttachNode = false;
	        return _this;
	    }
	    CustomType$$1.prototype.describe = function () {
	        return this.name;
	    };
	    CustomType$$1.prototype.isAssignableFrom = function (type) {
	        return type === this;
	    };
	    CustomType$$1.prototype.isValidSnapshot = function (value, context) {
	        if (this.options.isTargetType(value))
	            return typeCheckSuccess$$1();
	        var typeError = this.options.getValidationMessage(value);
	        if (typeError) {
	            return typeCheckFailure$$1(context, value, "Invalid value for type '" + this.name + "': " + typeError);
	        }
	        return typeCheckSuccess$$1();
	    };
	    CustomType$$1.prototype.getValue = function (node) {
	        if (!node.isAlive)
	            return undefined;
	        return node.storedValue;
	    };
	    CustomType$$1.prototype.getSnapshot = function (node) {
	        return this.options.toSnapshot(node.storedValue);
	    };
	    CustomType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        var valueToStore = this.options.isTargetType(snapshot)
	            ? snapshot
	            : this.options.fromSnapshot(snapshot);
	        return createNode$$1(this, parent, subpath, environment, valueToStore);
	    };
	    CustomType$$1.prototype.reconcile = function (current, value) {
	        var isSnapshot = !this.options.isTargetType(value);
	        var unchanged = current.type === this &&
	            (isSnapshot ? value === current.snapshot : value === current.storedValue);
	        if (unchanged)
	            return current;
	        var valueToStore = isSnapshot ? this.options.fromSnapshot(value) : value;
	        var newNode = this.instantiate(current.parent, current.subpath, current._environment, valueToStore);
	        current.die();
	        return newNode;
	    };
	    return CustomType$$1;
	}(Type$$1));
	
	/*
	 * All imports / exports should be proxied through this file.
	 * Why? It gives us full control over the module load order, preventing circular dependency isses
	 */
	
	/* all code is initially loaded through internal, to avoid circular dep issues */
	// tslint:disable-next-line:no_unused-variable
	var types = {
	    enumeration: enumeration$$1,
	    model: model$$1,
	    compose: compose$$1,
	    custom: custom$$1,
	    reference: reference$$1,
	    union: union$$1,
	    optional: optional$$1,
	    literal: literal$$1,
	    maybe: maybe$$1,
	    refinement: refinement$$1,
	    string: string$$1,
	    boolean: boolean$$1,
	    number: number$$1,
	    Date: DatePrimitive$$1,
	    map: map$$1,
	    array: array$$1,
	    frozen: frozen$$1,
	    identifier: identifier$$1,
	    late: late$$1,
	    undefined: undefinedType$$1,
	    null: nullType$$1
	};
	
	exports.types = types;
	exports.typecheck = typecheckPublic$$1;
	exports.escapeJsonPath = escapeJsonPath$$1;
	exports.unescapeJsonPath = unescapeJsonPath$$1;
	exports.joinJsonPath = joinJsonPath$$1;
	exports.splitJsonPath = splitJsonPath$$1;
	exports.decorate = decorate$$1;
	exports.addMiddleware = addMiddleware$$1;
	exports.process = process$1$$1;
	exports.isStateTreeNode = isStateTreeNode$$1;
	exports.flow = flow;
	exports.applyAction = applyAction$$1;
	exports.onAction = onAction$$1;
	exports.recordActions = recordActions$$1;
	exports.createActionTrackingMiddleware = createActionTrackingMiddleware;
	exports.getType = getType$$1;
	exports.getChildType = getChildType$$1;
	exports.onPatch = onPatch$$1;
	exports.onSnapshot = onSnapshot$$1;
	exports.applyPatch = applyPatch$$1;
	exports.recordPatches = recordPatches$$1;
	exports.protect = protect$$1;
	exports.unprotect = unprotect$$1;
	exports.isProtected = isProtected$$1;
	exports.applySnapshot = applySnapshot$$1;
	exports.getSnapshot = getSnapshot$$1;
	exports.hasParent = hasParent$$1;
	exports.getParent = getParent$$1;
	exports.getRoot = getRoot$$1;
	exports.getPath = getPath$$1;
	exports.getPathParts = getPathParts$$1;
	exports.isRoot = isRoot$$1;
	exports.resolvePath = resolvePath$$1;
	exports.resolveIdentifier = resolveIdentifier$$1;
	exports.getIdentifier = getIdentifier$$1;
	exports.tryResolve = tryResolve$$1;
	exports.getRelativePath = getRelativePath$$1;
	exports.clone = clone$$1;
	exports.detach = detach$$1;
	exports.destroy = destroy$$1;
	exports.isAlive = isAlive$$1;
	exports.addDisposer = addDisposer$$1;
	exports.getEnv = getEnv$$1;
	exports.walk = walk$$1;
	exports.getMembers = getMembers$$1;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108).setImmediate))

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}
	
	var enumerableDescriptorCache = {};
	var nonEnumerableDescriptorCache = {};
	function createPropertyInitializerDescriptor(prop, enumerable) {
	    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
	    return (cache[prop] ||
	        (cache[prop] = {
	            configurable: true,
	            enumerable: enumerable,
	            get: function () {
	                initializeInstance(this);
	                return this[prop];
	            },
	            set: function (value) {
	                initializeInstance(this);
	                this[prop] = value;
	            }
	        }));
	}
	function initializeInstance(target) {
	    if (target.__mobxDidRunLazyInitializers === true)
	        return;
	    var decorators = target.__mobxDecorators;
	    if (decorators) {
	        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
	        for (var key in decorators) {
	            var d = decorators[key];
	            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
	        }
	    }
	}
	function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
	    return function decoratorFactory() {
	        var decoratorArguments;
	        var decorator = function decorate(target, prop, descriptor, applyImmediately
	        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
	        // as the instance to apply the decorator to equals the target
	        ) {
	            if (applyImmediately === true) {
	                propertyCreator(target, prop, descriptor, target, decoratorArguments);
	                return null;
	            }
	            if (false)
	                fail$1("This function is a decorator, but it wasn't invoked like a decorator");
	            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
	                var inheritedDecorators = target.__mobxDecorators;
	                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
	            }
	            target.__mobxDecorators[prop] = {
	                prop: prop,
	                propertyCreator: propertyCreator,
	                descriptor: descriptor,
	                decoratorTarget: target,
	                decoratorArguments: decoratorArguments
	            };
	            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
	        };
	        if (quacksLikeADecorator(arguments)) {
	            // @decorator
	            decoratorArguments = EMPTY_ARRAY;
	            return decorator.apply(null, arguments);
	        }
	        else {
	            // @decorator(args)
	            decoratorArguments = Array.prototype.slice.call(arguments);
	            return decorator;
	        }
	    };
	}
	function quacksLikeADecorator(args) {
	    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
	        (args.length === 4 && args[3] === true));
	}
	
	function isSpyEnabled() {
	    return !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length)
	        return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart(event) {
	    var change = __assign({}, event, { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change)
	        spyReport(__assign({}, change, { spyReportEnd: true }));
	    else
	        spyReport(END_EVENT);
	}
	function spy(listener) {
	    globalState.spyListeners.push(listener);
	    return once(function () {
	        globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
	    });
	}
	
	function createAction(actionName, fn) {
	    if (false) {
	        invariant(typeof fn === "function", "`action` can only be invoked on functions");
	        if (typeof actionName !== "string" || !actionName)
	            fail$1("actions should have valid names, got: '" + actionName + "'");
	    }
	    var res = function () {
	        return executeAction(actionName, fn, this, arguments);
	    };
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = startAction(actionName, fn, scope, args);
	    try {
	        return fn.apply(scope, args);
	    }
	    finally {
	        endAction(runInfo);
	    }
	}
	function startAction(actionName, fn, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart({
	            type: "action",
	            name: actionName,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    return {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        notifySpy: notifySpy,
	        startTime: startTime
	    };
	}
	function endAction(runInfo) {
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy)
	        spyReportEnd({ time: Date.now() - runInfo.startTime });
	}
	function allowStateChanges(allowStateChanges, func) {
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	
	function dontReassignFields() {
	    fail$1(("production") !== "production" && "@action fields are not reassignable");
	}
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor) {
	            if (false) {
	                return fail$1("@action cannot be used with getters");
	            }
	            // babel / typescript
	            // @action method() { }
	            if (descriptor.value) {
	                // typescript
	                return {
	                    value: createAction(name, descriptor.value),
	                    enumerable: false,
	                    configurable: true,
	                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
	                };
	            }
	            // babel only: @action method = () => {}
	            var initializer_1 = descriptor.initializer;
	            return {
	                enumerable: false,
	                configurable: true,
	                writable: true,
	                initializer: function () {
	                    // N.B: we can't immediately invoke initializer; this would be wrong
	                    return createAction(name, initializer_1.call(this));
	                }
	            };
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function actionFieldDecorator(name) {
	    // Simple property that writes on first invocation to the current instance
	    return function (target, prop, descriptor) {
	        Object.defineProperty(target, prop, {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return undefined;
	            },
	            set: function (value) {
	                addHiddenFinalProp(this, prop, action(name, value));
	            }
	        });
	    };
	}
	function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
	    if (applyToInstance === true) {
	        defineBoundAction(target, propertyName, descriptor.value);
	        return null;
	    }
	    if (descriptor) {
	        // if (descriptor.value)
	        // Typescript / Babel: @action.bound method() { }
	        // also: babel @action.bound method = () => {}
	        return {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
	                return this[propertyName];
	            },
	            set: dontReassignFields
	        };
	    }
	    // field decorator Typescript @action.bound method = () => {}
	    return {
	        enumerable: false,
	        configurable: true,
	        set: function (v) {
	            defineBoundAction(this, propertyName, v);
	        },
	        get: function () {
	            return undefined;
	        }
	    };
	}
	
	var action = function action(arg1, arg2, arg3, arg4) {
	    // action(fn() {})
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction(arg1.name || "<unnamed action>", arg1);
	    // action("name", fn() {})
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction(arg1, arg2);
	    // @action("name") fn() {}
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator(arg1);
	    // @action fn() {}
	    if (arg4 === true) {
	        // apply to instance immediately
	        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
	    }
	    else {
	        return namedActionDecorator(arg2).apply(null, arguments);
	    }
	};
	action.bound = boundActionDecorator;
	function runInAction(arg1, arg2) {
	    // TODO: deprecate?
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    if (false) {
	        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
	        if (typeof actionName !== "string" || !actionName)
	            fail$1("actions should have valid names, got: '" + actionName + "'");
	    }
	    return executeAction(actionName, fn, this, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b) {
	    return eq(a, b);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    return deepEq(a, b, aStack, bStack);
	}
	// Internal recursive comparison function for `isEqual`.
	function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys$$1 = Object.keys(a), key;
	        length = keys$$1.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys$$1[length];
	            if (!(has$$1(b, key) && eq(a[key], b[key], aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a))
	        return a.peek();
	    if (isES6Map(a) || isObservableMap(a))
	        return iteratorToArray(a.entries());
	    return a;
	}
	function has$$1(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function defaultComparer(a, b) {
	    return areBothNaN(a, b) || identityComparer(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer
	};
	
	/**
	 * Creates a named reactive view and keeps it alive, so that the view is always
	 * updated if one of the dependencies changes, even when the view is not further used by something else.
	 * @param view The reactive view
	 * @returns disposer function, which can be used to stop the view from being updated in the future.
	 */
	function autorun(view, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    if (false) {
	        invariant(typeof view === "function", "Autorun expects a function as first argument");
	        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
	    }
	    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
	    var runSync = !opts.scheduler && !opts.delay;
	    var reaction;
	    if (runSync) {
	        // normal autorun
	        reaction = new Reaction(name, function () {
	            this.track(reactionRunner);
	        }, opts.onError);
	    }
	    else {
	        var scheduler_1 = createSchedulerFromOptions(opts);
	        // debounced autorun
	        var isScheduled_1 = false;
	        reaction = new Reaction(name, function () {
	            if (!isScheduled_1) {
	                isScheduled_1 = true;
	                scheduler_1(function () {
	                    isScheduled_1 = false;
	                    if (!reaction.isDisposed)
	                        reaction.track(reactionRunner);
	                });
	            }
	        }, opts.onError);
	    }
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	var run = function (f) { return f(); };
	function createSchedulerFromOptions(opts) {
	    return opts.scheduler
	        ? opts.scheduler
	        : opts.delay ? function (f) { return setTimeout(f, opts.delay); } : run;
	}
	function reaction(expression, effect, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    if (typeof opts === "boolean") {
	        opts = { fireImmediately: opts };
	        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
	    }
	    if (false) {
	        invariant(typeof expression === "function", "First argument to reaction should be a function");
	        invariant(typeof opts === "object", "Third argument of reactions should be an object");
	    }
	    var name = opts.name || "Reaction@" + getNextId();
	    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
	    var runSync = !opts.scheduler && !opts.delay;
	    var scheduler = createSchedulerFromOptions(opts);
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.compareStructural
	        ? comparer.structural
	        : opts.equals || comparer.default;
	    var r = new Reaction(name, function () {
	        if (firstTime || runSync) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            scheduler(reactionRunner);
	        }
	    }, opts.onError);
	    function reactionRunner() {
	        isScheduled = false; // Q: move into reaction runner?
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effectAction(value, r);
	        if (!firstTime && changed === true)
	            effectAction(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function wrapErrorHandler(errorHandler, baseFn) {
	    return function () {
	        try {
	            return baseFn.apply(this, arguments);
	        }
	        catch (e) {
	            errorHandler.call(this, e);
	        }
	    };
	}
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce an new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(options) {
	        var _this = this;
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isBeingObserved = false;
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        if (false)
	            return fail$1("missing option for computed: get");
	        this.derivation = options.get;
	        this.name = options.name || "ComputedValue@" + getNextId();
	        if (options.set)
	            this.setter = createAction(this.name + "-setter", options.set);
	        this.equals =
	            options.equals ||
	                (options.compareStructural || options.struct
	                    ? comparer.structural
	                    : comparer.default);
	        this.scope = options.context;
	        this.requiresReaction = !!options.requiresReaction;
	        if (options.keepAlive === true) {
	            // dangerous: never exposed, so this cmputed value should not depend on observables
	            // that live globally, or it will never get disposed! (nor anything attached to it)
	            autorun(function () { return _this.get(); });
	        }
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () { };
	    ComputedValue.prototype.onBecomeObserved = function () { };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        if (this.isComputing)
	            fail$1("Cycle detected in computation " + this.name + ": " + this.derivation);
	        if (globalState.inBatch === 0) {
	            if (shouldCompute(this)) {
	                this.warnAboutUntrackedRead();
	                startBatch(); // See perf test 'computed memoization'
	                this.value = this.computeValue(false);
	                endBatch();
	            }
	        }
	        else {
	            reportObserved(this);
	            if (shouldCompute(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this
	                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant(false, ("production") !== "production" &&
	                "[ComputedValue '" + this
	                    .name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled()) {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                name: this.name
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = this.computeValue(true);
	        var changed = wasSuspended ||
	            isCaughtException(oldValue) ||
	            isCaughtException(newValue) ||
	            !this.equals(oldValue, newValue);
	        if (changed) {
	            this.value = newValue;
	        }
	        return changed;
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        }
	        else {
	            if (globalState.disableErrorBoundaries === true) {
	                res = this.derivation.call(this.scope);
	            }
	            else {
	                try {
	                    res = this.derivation.call(this.scope);
	                }
	                catch (e) {
	                    res = new CaughtException(e);
	                }
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.suspend = function () {
	        clearObserving(this);
	        this.value = undefined; // don't hold on to computed value!
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.warnAboutUntrackedRead = function () {
	        if (true)
	            return;
	        if (this.requiresReaction === true) {
	            fail$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
	        }
	        if (this.isTracing !== TraceMode.NONE) {
	            console.log("[mobx.trace] '" + this
	                .name + "' is being read outside a reactive context. Doing a full recompute");
	        }
	        if (globalState.computedRequiresReaction) {
	            console.warn("[mobx] Computed value " + this
	                .name + " is being read outside a reactive context. Doing a full recompute");
	        }
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ComputedValue;
	}());
	ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors)
	            for (var i = 0, l = interceptors.length; i < l; i++) {
	                change = interceptors[i](change);
	                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	                if (!change)
	                    break;
	            }
	        return change;
	    }
	    finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	var UNCHANGED = {};
	declareAtom();
	var ObservableValue = /** @class */ (function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.hasUnreportedChange = false;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy) {
	                spyReportStart({
	                    type: "update",
	                    name: this.name,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.value !== newValue ? newValue : UNCHANGED;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ObservableValue;
	}(Atom));
	ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	var ObservableObjectAdministration = /** @class */ (function () {
	    function ObservableObjectAdministration(target, name, defaultEnhancer) {
	        this.target = target;
	        this.name = name;
	        this.defaultEnhancer = defaultEnhancer;
	        this.values = {};
	    }
	    ObservableObjectAdministration.prototype.read = function (owner, key) {
	        if (this.target !== owner) {
	            this.illegalAccess(owner, key);
	            return;
	        }
	        return this.values[key].get();
	    };
	    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
	        var instance = this.target;
	        if (instance !== owner) {
	            this.illegalAccess(owner, key);
	            return;
	        }
	        var observable = this.values[key];
	        if (observable instanceof ComputedValue) {
	            observable.set(newValue);
	            return;
	        }
	        // intercept
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "update",
	                object: instance,
	                name: key,
	                newValue: newValue
	            });
	            if (!change)
	                return;
	            newValue = change.newValue;
	        }
	        newValue = observable.prepareNewValue(newValue);
	        // notify spy & observers
	        if (newValue !== UNCHANGED) {
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: instance,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableObjectAdministration.prototype.remove = function (key) {
	        if (!this.values[key])
	            return;
	        var target = this.target;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: target,
	                name: key,
	                type: "remove"
	            });
	            if (!change)
	                return;
	        }
	        try {
	            startBatch();
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var oldValue = this.values[key].get();
	            if (this.keys)
	                this.keys.remove(key);
	            delete this.values[key];
	            delete this.target[key];
	            var change = notify || notifySpy
	                ? {
	                    type: "remove",
	                    object: target,
	                    oldValue: oldValue,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	        finally {
	            endBatch();
	        }
	    };
	    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
	        /**
	         * This happens if a property is accessed through the prototype chain, but the property was
	         * declared directly as own property on the prototype.
	         *
	         * E.g.:
	         * class A {
	         * }
	         * extendObservable(A.prototype, { x: 1 })
	         *
	         * classB extens A {
	         * }
	         * console.log(new B().x)
	         *
	         * It is unclear whether the property should be considered 'static' or inherited.
	         * Either use `console.log(A.x)`
	         * or: decorate(A, { x: observable })
	         *
	         * When using decorate, the property will always be redeclared as own property on the actual instance
	         */
	        return fail$1("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        ("production") !== "production" &&
	            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableObjectAdministration.prototype.getKeys = function () {
	        var _this = this;
	        if (this.keys === undefined) {
	            this.keys = new ObservableArray(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue; }), referenceEnhancer, "keys(" + this.name + ")", true);
	        }
	        return this.keys.slice();
	    };
	    return ObservableObjectAdministration;
	}());
	function asObservableObject(target, name, defaultEnhancer) {
	    if (name === void 0) { name = ""; }
	    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
	    var adm = target.$mobx;
	    if (adm)
	        return adm;
	    ("production") !== "production" &&
	        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
	    if (!isPlainObject(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name)
	        name = "ObservableObject@" + getNextId();
	    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
	    addHiddenFinalProp(target, "$mobx", adm);
	    return adm;
	}
	function defineObservableProperty(target, propName, newValue, enhancer) {
	    var adm = asObservableObject(target);
	    assertPropertyConfigurable(target, propName);
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            object: target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
	    newValue = observable.value; // observableValue might have changed it
	    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
	    if (adm.keys)
	        adm.keys.push(propName);
	    notifyPropertyAddition(adm, target, propName, newValue);
	}
	function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
	propName, options) {
	    var adm = asObservableObject(target);
	    options.name = adm.name + "." + propName;
	    options.context = target;
	    adm.values[propName] = new ComputedValue(options);
	    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
	}
	var observablePropertyConfigs = {};
	var computedPropertyConfigs = {};
	function generateObservablePropConfig(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this.$mobx.read(this, propName);
	            },
	            set: function (v) {
	                this.$mobx.write(this, propName, v);
	            }
	        }));
	}
	function getAdministrationForComputedPropOwner(owner) {
	    var adm = owner.$mobx;
	    if (!adm) {
	        // because computed props are declared on proty,
	        // the current instance might not have been initialized yet
	        initializeInstance(owner);
	        return owner.$mobx;
	    }
	    return adm;
	}
	function generateComputedPropConfig(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return getAdministrationForComputedPropOwner(this).read(this, propName);
	            },
	            set: function (v) {
	                getAdministrationForComputedPropOwner(this).write(this, propName, v);
	            }
	        }));
	}
	function notifyPropertyAddition(adm, object, key, newValue) {
	    var notify = hasListeners(adm);
	    var notifySpy = isSpyEnabled();
	    var change = notify || notifySpy
	        ? {
	            type: "add",
	            object: object,
	            name: key,
	            newValue: newValue
	        }
	        : null;
	    if (notifySpy)
	        spyReportStart(__assign({}, change, { name: adm.name, key: key }));
	    if (notify)
	        notifyListeners(adm, change);
	    if (notifySpy)
	        spyReportEnd();
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
	        if (false) {
	            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
	        }
	        var initialValue = descriptor
	            ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value
	            : undefined;
	        defineObservableProperty(target, propertyName, initialValue, enhancer);
	    });
	    var res = 
	    // Extra process checks, as this happens during module initialization
	    typeof process !== "undefined" && ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}) && ("production") !== "production"
	        ? function observableDecorator() {
	            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
	            // and simply return the created prop decorator
	            if (arguments.length < 2)
	                return fail$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
	            return decorator.apply(null, arguments);
	        }
	        : decorator;
	    res.enhancer = enhancer;
	    return res;
	}
	
	function _isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (false)
	            return fail$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
	        if (isObservableObject(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject(value) ||
	        !!value.$mobx ||
	        isAtom(value) ||
	        isReaction(value) ||
	        isComputedValue(value));
	}
	function isObservable(value) {
	    if (arguments.length !== 1)
	        fail$1(("production") !== "production" &&
	            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isObservable(value);
	}
	function isObservableProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail$1(("production") !== "production" && "expected a property name as second argument");
	    return _isObservable(value, propName);
	}
	
	function _isComputed(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false)
	            return false;
	        if (!value.$mobx.values[property])
	            return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	function isComputed(value) {
	    if (arguments.length > 1)
	        return fail$1(("production") !== "production" &&
	            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isComputed(value);
	}
	function isComputedProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail$1(("production") !== "production" &&
	            "isComputed expected a property name as second argument");
	    return _isComputed(value, propName);
	}
	
	var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
	    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
	    // Optimization: faster on decorator target or instance? Assuming target
	    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
	    var options = decoratorArgs[0] || {};
	    defineComputedProperty(instance, propertyName, __assign({}, options, { get: get, set: set }));
	});
	var computedStructDecorator = computedDecorator({ equals: comparer.structural });
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        // @computed
	        return computedDecorator.apply(null, arguments);
	    }
	    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
	        // @computed({ options })
	        return computedDecorator.apply(null, arguments);
	    }
	    // computed(expr, options?)
	    if (false) {
	        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
	        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
	    }
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.get = arg1;
	    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
	    opts.name = opts.name || arg1.name || ""; /* for generated name */
	    return new ComputedValue(opts);
	};
	computed.struct = computedStructDecorator;
	
	function extendShallowObservable(target, properties, decorators) {
	    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
	    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
	}
	function extendObservable(target, properties, decorators, options) {
	    if (false) {
	        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
	        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
	        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
	        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
	        if (decorators)
	            for (var key in decorators)
	                if (!(key in properties))
	                    fail$1("Trying to declare a decorator for unspecified property '" + key + "'");
	    }
	    options = asCreateObservableOptions(options);
	    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
	    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
	    startBatch();
	    try {
	        for (var key in properties) {
	            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	            if (false) {
	                if (Object.getOwnPropertyDescriptor(target, key))
	                    fail$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
	                if (isComputed(descriptor.value))
	                    fail$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
	            }
	            var decorator = decorators && key in decorators
	                ? decorators[key]
	                : descriptor.get ? computedDecorator : defaultDecorator;
	            if (false)
	                return fail$1("Not a valid decorator for '" + key + "', got: " + decorator);
	            var resultDescriptor = decorator(target, key, descriptor, true);
	            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
	            )
	                Object.defineProperty(target, key, resultDescriptor);
	        }
	    }
	    finally {
	        endBatch();
	    }
	    return target;
	}
	
	// Predefined bags of create observable options, to avoid allocating temporarily option objects
	// in the majority of cases
	var defaultCreateObservableOptions = {
	    deep: true,
	    name: undefined,
	    defaultDecorator: undefined
	};
	var shallowCreateObservableOptions = {
	    deep: false,
	    name: undefined,
	    defaultDecorator: undefined
	};
	Object.freeze(defaultCreateObservableOptions);
	Object.freeze(shallowCreateObservableOptions);
	function assertValidOption(key) {
	    if (!/^(deep|name|defaultDecorator)$/.test(key))
	        fail$1("invalid option for (extend)observable: " + key);
	}
	function asCreateObservableOptions(thing) {
	    if (thing === null || thing === undefined)
	        return defaultCreateObservableOptions;
	    if (typeof thing === "string")
	        return { name: thing, deep: true };
	    if (false) {
	        if (typeof thing !== "object")
	            return fail$1("expected options object");
	        Object.keys(thing).forEach(assertValidOption);
	    }
	    return thing;
	}
	function getEnhancerFromOptions(options) {
	    return options.defaultDecorator
	        ? options.defaultDecorator.enhancer
	        : options.deep === false ? referenceEnhancer : deepEnhancer;
	}
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v, arg2, arg3) {
	    // @observable someProp;
	    if (typeof arguments[1] === "string") {
	        return deepDecorator.apply(null, arguments);
	    }
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = isPlainObject(v)
	        ? observable.object(v, arg2, arg3)
	        : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : v;
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    fail$1(("production") !== "production" &&
	        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
	}
	var observableFactories = {
	    box: function (value, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        var o = asCreateObservableOptions(options);
	        return new ObservableValue(value, getEnhancerFromOptions(o), o.name);
	    },
	    shallowBox: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowBox");
	        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
	        return observable.box(value, { name: name, deep: false });
	    },
	    array: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        var o = asCreateObservableOptions(options);
	        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowArray: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowArray");
	        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
	        return observable.array(initialValues, { name: name, deep: false });
	    },
	    map: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        var o = asCreateObservableOptions(options);
	        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowMap: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowMap");
	        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
	        return observable.map(initialValues, { name: name, deep: false });
	    },
	    object: function (props, decorators, options) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("object");
	        var o = asCreateObservableOptions(options);
	        return extendObservable({}, props, decorators, o);
	    },
	    shallowObject: function (props, name) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("shallowObject");
	        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
	        return observable.object(props, {}, { name: name, deep: false });
	    },
	    ref: refDecorator,
	    shallow: shallowDecorator,
	    deep: deepDecorator,
	    struct: refStructDecorator
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
	function incorrectlyUsedAsDecorator(methodName) {
	    fail$1(
	    // process.env.NODE_ENV !== "production" &&
	    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	function deepEnhancer(v, _, name) {
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable.array(v, { name: name });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name });
	    if (isES6Map(v))
	        return observable.map(v, { name: name });
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
	        return v;
	    if (Array.isArray(v))
	        return observable.array(v, { name: name, deep: false });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name, deep: false });
	    if (isES6Map(v))
	        return observable.map(v, { name: name, deep: false });
	    return fail$1(("production") !== "production" &&
	        "The shallow modifier / decorator can only used in combination with arrays, objects and maps");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if (false)
	        throw "observable.struct should not be used with observable values";
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	function iteratorSymbol() {
	    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
	}
	
	function declareIterator(prototType, iteratorFactory) {
	    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
	}
	function makeIterable(iterator) {
	    iterator[iteratorSymbol()] = self;
	    return iterator;
	}
	function self() {
	    return this;
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    }
	    finally {
	        endBatch();
	    }
	}
	
	var ObservableMapMarker = {};
	var ObservableMap = /** @class */ (function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
	        if (typeof Map !== "function") {
	            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
	        }
	        this._data = new Map();
	        this._hasMap = new Map();
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return this._data.has(key);
	    };
	    ObservableMap.prototype.has = function (key) {
	        if (this._hasMap.has(key))
	            return this._hasMap.get(key).get();
	        return this._updateHasMapEntry(key, false).get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data.get(key).value,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            transaction(function () {
	                _this._keys.remove(key);
	                _this._updateHasMapEntry(key, false);
	                var observable = _this._data.get(key);
	                observable.setNewValue(undefined);
	                _this._data.delete(key);
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
	        var entry = this._hasMap.get(key);
	        if (entry) {
	            entry.setNewValue(value);
	        }
	        else {
	            entry = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
	            this._hasMap.set(key, entry);
	        }
	        return entry;
	    };
	    ObservableMap.prototype._updateValue = function (key, newValue) {
	        var observable = this._data.get(key);
	        newValue = observable.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (key, newValue) {
	        var _this = this;
	        transaction(function () {
	            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + key, false);
	            _this._data.set(key, observable);
	            newValue = observable.value; // value might have been changed
	            _this._updateHasMapEntry(key, true);
	            _this._keys.push(key);
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: key,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign({}, change, { name: this.name, key: key }));
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        if (this.has(key))
	            return this.dehanceValue(this._data.get(key).get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        return this._keys[iteratorSymbol()]();
	    };
	    ObservableMap.prototype.values = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable({
	            next: function () {
	                return nextIndex < self._keys.length
	                    ? { value: self.get(self._keys[nextIndex++]), done: false }
	                    : { value: undefined, done: true };
	            }
	        });
	    };
	    ObservableMap.prototype.entries = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable({
	            next: function () {
	                if (nextIndex < self._keys.length) {
	                    var key = self._keys[nextIndex++];
	                    return {
	                        value: [key, self.get(key)],
	                        done: false
	                    };
	                }
	                return { done: true };
	            }
	        });
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this._keys.forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            if (isPlainObject(other))
	                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
	            else if (Array.isArray(other))
	                other.forEach(function (_a) {
	                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
	                    return _this.set(key, value);
	                });
	            else if (isES6Map(other))
	                other.forEach(function (value, key) { return _this.set(key, value); });
	            else if (other !== null && other !== undefined)
	                fail$1("Cannot initialize map from " + other);
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                _this._keys.slice().forEach(function (key) { return _this.delete(key); });
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        transaction(function () {
	            // grab all the keys that are present in the new map but not present in the current map
	            // and delete them from the map, then merge the new map
	            // this will cause reactions only on changed values
	            var newKeys = getMapLikeKeys(values);
	            var oldKeys = _this._keys;
	            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
	            missingKeys.forEach(function (k) { return _this.delete(k); });
	            _this.merge(values);
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function () {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a plain object that represents this map.
	     * Note that all the keys being stringified.
	     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
	     */
	    ObservableMap.prototype.toPOJO = function () {
	        var _this = this;
	        var res = {};
	        this._keys.forEach(function (key) { return (res["" + key] = _this.get(key)); });
	        return res;
	    };
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        var _this = this;
	        var res = new Map();
	        this._keys.forEach(function (key) { return res.set(key, _this.get(key)); });
	        return res;
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toPOJO();
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            this._keys.map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        ("production") !== "production" &&
	            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}());
	declareIterator(ObservableMap.prototype, function () {
	    return this.entries();
	});
	addHiddenFinalProp(ObservableMap.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Map");
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	function getAtom(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            if (property !== undefined)
	                fail$1(("production") !== "production" &&
	                    "It is not possible to get index atoms from arrays");
	            return thing.$mobx.atom;
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return getAtom(anyThing._keys);
	            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
	            if (!observable)
	                fail$1(("production") !== "production" &&
	                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        if (property && !thing.$mobx)
	            thing[property]; // See #1072
	        if (isObservableObject(thing)) {
	            if (!property)
	                return fail$1(("production") !== "production" && "please specify a property");
	            var observable = thing.$mobx.values[property];
	            if (!observable)
	                fail$1(("production") !== "production" &&
	                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail$1(("production") !== "production" && "Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    if (!thing)
	        fail$1("Expecting some object");
	    if (property !== undefined)
	        return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
	        return thing;
	    if (isObservableMap(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    initializeInstance(thing);
	    if (thing.$mobx)
	        return thing.$mobx;
	    fail$1(("production") !== "production" && "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom(thing, property);
	    else if (isObservableObject(thing) || isObservableMap(thing))
	        named = getAdministration(thing);
	    else
	        named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	function onBecomeObserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeObserved", thing, arg2, arg3);
	}
	function onBecomeUnobserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
	}
	function interceptHook(hook, thing, arg2, arg3) {
	    var atom = typeof arg2 === "string" ? getAtom(thing, arg2) : getAtom(thing);
	    var cb = typeof arg2 === "string" ? arg3 : arg2;
	    var orig = atom[hook];
	    if (typeof orig !== "function")
	        return fail$1(("production") !== "production" && "Not an atom that can be (un)observed");
	    atom[hook] = function () {
	        orig.call(this);
	        cb.call(this);
	    };
	    return function () {
	        atom[hook] = orig;
	    };
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var Atom;
	var isAtom;
	function declareAtom() {
	    if (Atom)
	        return;
	    Atom = /** @class */ (function () {
	        /**
	         * Create a new atom. For debugging purposes it is recommended to give it a name.
	         * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	         */
	        function AtomImpl(name) {
	            if (name === void 0) { name = "Atom@" + getNextId(); }
	            this.name = name;
	            this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	            this.isBeingObserved = false;
	            this.observers = [];
	            this.observersIndexes = {};
	            this.diffValue = 0;
	            this.lastAccessedBy = 0;
	            this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	        }
	        AtomImpl.prototype.onBecomeUnobserved = function () {
	            // noop
	        };
	        AtomImpl.prototype.onBecomeObserved = function () {
	            /* noop */
	        };
	        /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     * Returns true if there is currently a reactive context.
	     */
	        AtomImpl.prototype.reportObserved = function () {
	            return reportObserved(this);
	        };
	        /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	        AtomImpl.prototype.reportChanged = function () {
	            startBatch();
	            propagateChanged(this);
	            endBatch();
	        };
	        AtomImpl.prototype.toString = function () {
	            return this.name;
	        };
	        return AtomImpl;
	    }());
	    isAtom = createInstanceofPredicate("Atom", Atom);
	}
	function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
	    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
	    var atom = new Atom(name);
	    onBecomeObserved(atom, onBecomeObservedHandler);
	    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
	    return atom;
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = (function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function () {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	})();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray = /** @class */ (function () {
	    function StubArray() {
	    }
	    return StubArray;
	}());
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    }
	    else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    }
	    else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	    
	    [
	        "constructor",
	        "push",
	        "shift",
	        "concat",
	        "pop",
	        "unshift",
	        "replace",
	        "find",
	        "findIndex",
	        "splice",
	        "reverse",
	        "sort"
	    ].forEach(function (key) {
	        Object.defineProperty(StubArray.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.atom = new Atom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined && this.values.length > 0)
	            return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
	            reserveArrayBuffer(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = EMPTY_ARRAY;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems =
	            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	        var _a;
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}());
	var ObservableArray = /** @class */ (function (_super) {
	    __extends(ObservableArray, _super);
	    function ObservableArray(initialValues, enhancer, name, owned) {
	        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
	        if (owned === void 0) { owned = false; }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            _this.spliceWithArray(0, 0, initialValues);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
	    };
	    ObservableArray.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
	        var items = this.peek(), l = items.length;
	        for (var i = fromIndex; i < l; i++)
	            if (predicate.call(thisArg, items[i], i, this))
	                return i;
	        return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray.prototype.move = function (fromIndex, toIndex) {
	        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex + 1));
	        }
	        else {
	            // toIndex < fromIndex
	            newItems = __spread(oldItems.slice(0, toIndex), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
	                .values
	                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    };
	    return ObservableArray;
	}(StubArray));
	declareIterator(ObservableArray.prototype, function () {
	    
	    this.$mobx.atom.reportObserved();
	    var self = this;
	    var nextIndex = 0;
	    return makeIterable({
	        next: function () {
	            return nextIndex < self.length
	                ? { value: self[nextIndex++], done: false }
	                : { done: true, value: undefined };
	        }
	    });
	});
	Object.defineProperty(ObservableArray.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function () {
	        return this.$mobx.getArrayLength();
	    },
	    set: function (newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
	    addHiddenProp(ObservableArray.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Array");
	}
	// Internet Explorer on desktop doesn't support this.....
	// So, let's don't do this to avoid different semantics
	// See #1395
	// addHiddenProp(
	//     ObservableArray.prototype,
	//     typeof Symbol !== "undefined" ? Symbol.isConcatSpreadable as any : "@@isConcatSpreadable",
	//     {
	//         enumerable: false,
	//         configurable: true,
	//         value: true
	//     }
	// )
	/**
	 * Wrap function from prototype
	 */
	
	[
	    "every",
	    "filter",
	    "forEach",
	    "indexOf",
	    "join",
	    "lastIndexOf",
	    "map",
	    "reduce",
	    "reduceRight",
	    "slice",
	    "some",
	    "toString",
	    "toLocaleString"
	].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable(ObservableArray.prototype, [
	    "constructor",
	    "intercept",
	    "observe",
	    "clear",
	    "concat",
	    "get",
	    "replace",
	    "toJS",
	    "toJSON",
	    "peek",
	    "find",
	    "findIndex",
	    "splice",
	    "spliceWithArray",
	    "push",
	    "pop",
	    "set",
	    "shift",
	    "unshift",
	    "reverse",
	    "sort",
	    "remove",
	    "move",
	    "toString",
	    "toLocaleString"
	]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function () {
	            return this.get(index);
	        },
	        set: function (value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
	        createArrayBufferItem(index);
	    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer(1000);
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	var EMPTY_OBJECT = {};
	Object.freeze(EMPTY_OBJECT);
	function getGlobal() {
	    return typeof window !== "undefined" ? window : global;
	}
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail$1(message) {
	    invariant(false, message);
	    throw "X"; // unreachable
	}
	function invariant(check, message) {
	    if (!check)
	        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg, thing) {
	    if (true)
	        return false;
	    if (thing) {
	        return deprecated("'" + msg + "', use '" + thing + "' instead.");
	    }
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function () { };
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function isObject(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	
	function makeNonEnumerable(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable(object, prop) {
	    if (false)
	        fail$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	function areBothNaN(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
	        return true;
	    return false;
	}
	function getMapLikeKeys(map) {
	    if (isPlainObject(map))
	        return Object.keys(map);
	    if (Array.isArray(map))
	        return map.map(function (_a) {
	            var _b = __read(_a, 1), key = _b[0];
	            return key;
	        });
	    if (isES6Map(map) || isObservableMap(map))
	        return iteratorToArray(map.keys());
	    return fail$1("Cannot get keys from '" + map + "'");
	}
	// use Array.from in Mobx 5
	function iteratorToArray(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done)
	            break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol() {
	    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
	}
	function toPrimitive(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = [
	    "mobxGuid",
	    "spyListeners",
	    "enforceActions",
	    "computedRequiresReaction",
	    "disableErrorBoundaries",
	    "runId"
	];
	var MobXGlobals = /** @class */ (function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         */
	        this.version = 5;
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.enforceActions = false;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	        /**
	         * Warn if computed values are accessed outside a reactive context
	         */
	        this.computedRequiresReaction = false;
	        /*
	         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
	         * the stack when an exception occurs while debugging.
	         */
	        this.disableErrorBoundaries = false;
	    }
	    return MobXGlobals;
	}());
	var globalState = new MobXGlobals();
	var runInIsolationCalled = false;
	{
	    var global_1 = getGlobal();
	    if (!global_1.__mobxInstanceCount) {
	        global_1.__mobxInstanceCount = 1;
	    }
	    else {
	        global_1.__mobxInstanceCount++;
	        setTimeout(function () {
	            if (!runInIsolationCalled) {
	                fail$1(("production") !== "production" &&
	                    "There are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	            }
	        }, 1);
	    }
	}
	function isolateGlobalState() {
	    runInIsolationCalled = true;
	    getGlobal().__mobxInstanceCount--;
	}
	function getGlobalState() {
	    return globalState;
	}
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState[key] = defaultGlobals[key];
	    globalState.allowStateChanges = !globalState.enforceActions;
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node))
	        result.observers = getObservers(node).map(nodeToObserverTree);
	    return result;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.length > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	// function invariantObservers(observable: IObservable) {
	//     const list = observable.observers
	//     const map = observable.observersIndexes
	//     const l = list.length
	//     for (let i = 0; i < l; i++) {
	//         const id = list[i].__mapid
	//         if (i) {
	//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
	//         } else {
	//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
	//         }
	//     }
	//     invariant(
	//         list.length === 0 || Object.keys(map).length === list.length - 1,
	//         "INTERNAL ERROR there is no junk in map"
	//     )
	// }
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable.observersIndexes[node.__mapid] = l;
	    }
	    observable.observers[l] = node;
	    if (observable.lowestObserverState > node.dependenciesState)
	        observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable.observers.length === 1) {
	        // deleting last observer
	        observable.observers.length = 0;
	        queueForUnobservation(observable);
	    }
	    else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable.observers;
	        var map = observable.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            }
	            else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (observable.isPendingUnobservation === false) {
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.length === 0) {
	                if (observable.isBeingObserved) {
	                    // if this observable had reactive observers, trigger the hooks
	                    observable.isBeingObserved = false;
	                    observable.onBecomeUnobserved();
	                }
	                if (observable instanceof ComputedValue) {
	                    // computed values are automatically teared down when the last observer leaves
	                    // this process happens recursively, this computed might be the last observabe of another, etc..
	                    observable.suspend();
	                }
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	            if (!observable.isBeingObserved) {
	                observable.isBeingObserved = true;
	                observable.onBecomeObserved();
	            }
	        }
	        return true;
	    }
	    else if (observable.observers.length === 0 && globalState.inBatch > 0) {
	        queueForUnobservation(observable);
	    }
	    return false;
	}
	// function invariantLOS(observable: IObservable, msg: string) {
	//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
	//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
	//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
	//     throw new Error(
	//         "lowestObserverState is wrong for " +
	//             msg +
	//             " because " +
	//             min +
	//             " < " +
	//             observable.lowestObserverState
	//     )
	// }
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */ (function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}());
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue(obj)) {
	                    if (globalState.disableErrorBoundaries) {
	                        obj.get();
	                    }
	                    else {
	                        try {
	                            obj.get();
	                        }
	                        catch (e) {
	                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                            untrackedEnd(prevUntracked);
	                            return true;
	                        }
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0(derivation);
	            untrackedEnd(prevUntracked);
	            return false;
	        }
	    }
	}
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers$$1 = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers$$1)
	        fail$1(("production") !== "production" &&
	            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && (hasObservers$$1 || globalState.enforceActions === "strict"))
	        fail$1(("production") !== "production" &&
	            (globalState.enforceActions
	                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
	                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
	                atom.name);
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    if (globalState.disableErrorBoundaries === true) {
	        result = f.call(context);
	    }
	    else {
	        try {
	            result = f.call(context);
	        }
	        catch (e) {
	            result = new CaughtException(e);
	        }
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    return result;
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    var res = action();
	    untrackedEnd(prev);
	    return res;
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail$1(("production") !== "production" &&
	            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	var Reaction = /** @class */ (function () {
	    function Reaction(name, onInvalidate, errorHandler) {
	        if (name === void 0) { name = "Reaction@" + getNextId(); }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.errorHandler = errorHandler;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                try {
	                    this.onInvalidate();
	                    if (this._isTrackPending && isSpyEnabled()) {
	                        // onInvalidate didn't trigger track right away..
	                        spyReport({
	                            name: this.name,
	                            type: "scheduled-reaction"
	                        });
	                    }
	                }
	                catch (e) {
	                    this.reportExceptionInDerivation(e);
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart({
	                name: this.name,
	                type: "reaction"
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        if (globalState.disableErrorBoundaries)
	            throw error;
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
	        console.error(message, error);
	        /** If debugging brought you here, please, read the above message :-). Tnx! */
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                name: this.name,
	                message: message,
	                error: "" + error
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}());
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	function when(predicate, arg1, arg2) {
	    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
	        return whenPromise(predicate, arg1);
	    return _when(predicate, arg1, arg2 || {});
	}
	function _when(predicate, effect, opts) {
	    var timeoutHandle;
	    if (typeof opts.timeout === "number") {
	        timeoutHandle = setTimeout(function () {
	            if (!disposer.$mobx.isDisposed) {
	                disposer();
	                var error = new Error("WHEN_TIMEOUT");
	                if (opts.onError)
	                    opts.onError(error);
	                else
	                    throw error;
	            }
	        }, opts.timeout);
	    }
	    opts.name = opts.name || "When@" + getNextId();
	    var effectAction = createAction(opts.name + "-effect", effect);
	    var disposer = autorun(function (r) {
	        if (predicate()) {
	            r.dispose();
	            if (timeoutHandle)
	                clearTimeout(timeoutHandle);
	            effectAction();
	        }
	    }, opts);
	    return disposer;
	}
	function whenPromise(predicate, opts) {
	    if (false)
	        return fail$1("the options 'onError' and 'promise' cannot be combined");
	    var cancel;
	    var res = new Promise(function (resolve, reject) {
	        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
	        cancel = function () {
	            disposer();
	            reject("WHEN_CANCELLED");
	        };
	    });
	    res.cancel = cancel;
	    return res;
	}
	
	function keys(obj) {
	    if (isObservableObject(obj)) {
	        return obj.$mobx.getKeys();
	    }
	    if (isObservableMap(obj)) {
	        return obj._keys.slice();
	    }
	    return fail$1(("production") !== "production" &&
	        "'keys()' can only be used on observable objects and maps");
	}
	function values(obj) {
	    if (isObservableObject(obj)) {
	        return keys(obj).map(function (key) { return obj[key]; });
	    }
	    if (isObservableMap(obj)) {
	        return keys(obj).map(function (key) { return obj.get(key); });
	    }
	    if (isObservableArray(obj)) {
	        return obj.slice();
	    }
	    return fail$1(("production") !== "production" &&
	        "'values()' can only be used on observable objects, arrays and maps");
	}
	function set(obj, key, value) {
	    if (arguments.length === 2) {
	        startBatch();
	        var values_1 = key;
	        try {
	            for (var key_1 in values_1)
	                set(obj, key_1, values_1[key_1]);
	        }
	        finally {
	            endBatch();
	        }
	        return;
	    }
	    if (isObservableObject(obj)) {
	        var adm = obj.$mobx;
	        var existingObservable = adm.values[key];
	        if (existingObservable) {
	            adm.write(obj, key, value);
	        }
	        else {
	            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
	        }
	    }
	    else if (isObservableMap(obj)) {
	        obj.set(key, value);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        startBatch();
	        if (key >= obj.length)
	            obj.length = key + 1;
	        obj[key] = value;
	        endBatch();
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'set()' can only be used on observable objects, arrays and maps");
	    }
	}
	function remove(obj, key) {
	    if (isObservableObject(obj)) {
	        
	        obj.$mobx.remove(key);
	    }
	    else if (isObservableMap(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        obj.splice(key, 1);
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'remove()' can only be used on observable objects, arrays and maps");
	    }
	}
	function has$1(obj, key) {
	    if (isObservableObject(obj)) {
	        // return keys(obj).indexOf(key) >= 0
	        var adm = getAdministration(obj);
	        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
	        return adm.values[key] instanceof ObservableValue;
	    }
	    else if (isObservableMap(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableArray(obj)) {
	        return key >= 0 && key < obj.length;
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'has()' can only be used on observable objects, arrays and maps");
	    }
	}
	function get(obj, key) {
	    if (!has$1(obj, key))
	        return undefined;
	    if (isObservableObject(obj)) {
	        return obj[key];
	    }
	    else if (isObservableMap(obj)) {
	        return obj.get(key);
	    }
	    else if (isObservableArray(obj)) {
	        return obj[key];
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'get()' can only be used on observable objects, arrays and maps");
	    }
	}
	
	function decorate(thing, decorators) {
	    ("production") !== "production" &&
	        invariant(isPlainObject(decorators), "Decorators should be a key value map");
	    var target = typeof thing === "function" ? thing.prototype : thing;
	    for (var prop in decorators) {
	        var decorator = decorators[prop];
	        ("production") !== "production" &&
	            invariant(typeof decorator === "function", "Decorate: expected a decorator function for '" + prop + "'");
	        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
	        var newDescriptor = decorator(target, prop, descriptor);
	        if (newDescriptor)
	            Object.defineProperty(target, prop, newDescriptor);
	    }
	    return thing;
	}
	
	function configure(options) {
	    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler;
	    if (enforceActions !== undefined) {
	        if (typeof enforceActions !== "boolean" && enforceActions !== "strict")
	            return fail("Invalid configuration for 'enforceActions': " + enforceActions);
	        globalState.enforceActions = enforceActions;
	        globalState.allowStateChanges =
	            enforceActions === true || enforceActions === "strict" ? false : true;
	    }
	    if (computedRequiresReaction !== undefined) {
	        globalState.computedRequiresReaction = !!computedRequiresReaction;
	    }
	    if (options.isolateGlobalState === true) {
	        isolateGlobalState();
	    }
	    if (disableErrorBoundaries !== undefined) {
	        if (disableErrorBoundaries === true)
	            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
	        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
	    }
	    if (typeof arrayBuffer === "number") {
	        reserveArrayBuffer(arrayBuffer);
	    }
	    if (reactionScheduler) {
	        setReactionScheduler(reactionScheduler);
	    }
	}
	
	var generatorId = 0;
	function flow(generator) {
	    if (arguments.length !== 1)
	        fail$1(("production") && "Flow expects one 1 argument and cannot be used as decorator");
	    var name = generator.name || "<unnamed flow>";
	    // Implementation based on https://github.com/tj/co/blob/master/index.js
	    return function () {
	        var ctx = this;
	        var args = arguments;
	        var runId = ++generatorId;
	        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
	        var rejector;
	        var pendingPromise = undefined;
	        var res = new Promise(function (resolve, reject) {
	            var stepId = 0;
	            rejector = reject;
	            function onFulfilled(res) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function onRejected(err) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret && typeof ret.then === "function") {
	                    // an async iterator
	                    ret.then(next, reject);
	                    return;
	                }
	                if (ret.done)
	                    return resolve(ret.value);
	                pendingPromise = Promise.resolve(ret.value);
	                return pendingPromise.then(onFulfilled, onRejected);
	            }
	            onFulfilled(undefined); // kick off the process
	        });
	        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
	            try {
	                if (pendingPromise)
	                    cancelPromise(pendingPromise);
	                // Finally block can return (or yield) stuff..
	                var res_1 = gen.return();
	                // eat anything that promise would do, it's cancelled!
	                var yieldedPromise = Promise.resolve(res_1.value);
	                yieldedPromise.then(noop, noop);
	                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
	                // reject our original promise
	                rejector(new Error("FLOW_CANCELLED"));
	            }
	            catch (e) {
	                rejector(e); // there could be a throwing finally block
	            }
	        });
	        return res;
	    };
	}
	function cancelPromise(promise) {
	    if (typeof promise.cancel === "function")
	        promise.cancel();
	}
	
	var defaultOptions = {
	    detectCycles: true,
	    exportMapsAsObjects: true
	};
	function cache(map, key, value, options) {
	    if (options.detectCycles)
	        map.set(key, value);
	    return value;
	}
	function toJSHelper(source, options, __alreadySeen) {
	    if (!isObservable(source))
	        return source;
	    var detectCycles = options.detectCycles === true;
	    if (detectCycles &&
	        source !== null &&
	        typeof source === "object" &&
	        __alreadySeen.has(source)) {
	        return __alreadySeen.get(source);
	    }
	    if (isObservableArray(source)) {
	        var res = cache(__alreadySeen, source, [], options);
	        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
	        res.length = toAdd.length;
	        for (var i = 0, l = toAdd.length; i < l; i++)
	            res[i] = toAdd[i];
	        return res;
	    }
	    if (isObservableObject(source)) {
	        var res = cache(__alreadySeen, source, {}, options);
	        keys(source); // make sure we track the keys of the object
	        for (var key in source) {
	            res[key] = toJSHelper(source[key], options, __alreadySeen);
	        }
	        return res;
	    }
	    if (isObservableMap(source)) {
	        if (options.exportMapsAsObjects === false) {
	            var res_1 = cache(__alreadySeen, source, new Map(), options);
	            source.forEach(function (value, key) {
	                res_1.set(key, toJSHelper(value, options, __alreadySeen));
	            });
	            return res_1;
	        }
	        else {
	            var res_2 = cache(__alreadySeen, source, {}, options);
	            source.forEach(function (value, key) {
	                res_2[key] = toJSHelper(value, options, __alreadySeen);
	            });
	            return res_2;
	        }
	    }
	    if (isObservableValue(source))
	        return toJSHelper(source.get(), options, __alreadySeen);
	    return source;
	}
	function toJS(source, options) {
	    if (!isObservable(source))
	        return source;
	    // backward compatibility
	    if (typeof options === "boolean")
	        options = { detectCycles: options };
	    if (!options)
	        options = defaultOptions;
	    var detectCycles = options.detectCycles === true;
	    var __alreadySeen;
	    if (detectCycles)
	        __alreadySeen = new Map();
	    return toJSHelper(source, options, __alreadySeen);
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    }
	    else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail$1(("production") !== "production" &&
	                "InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail$1(("production") !== "production" && "An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2016
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	try {
	    // define process.env if needed
	    // if this is not a production build in the first place
	    // (in which case the expression below would be substituted with 'production')
	    ("production");
	}
	catch (e) {
	    var g = typeof window !== "undefined" ? window : global;
	    if (typeof process === "undefined")
	        g.process = {};
	    g.process.env = {};
	}
	
	(function () {
	    function testCodeMinification() { }
	    if (testCodeMinification.name !== "testCodeMinification" &&
	        ("production") !== "production") {
	        console.warn("[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
	    }
	})();
	// This line should come after all the imports as well, for the same reason
	// as noted above. I will file a bug with rollupjs - @rossipedia
	// Devtools support
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    // See: https://github.com/andykog/mobx-devtools/
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
	        spy: spy,
	        extras: {
	            getDebugName: getDebugName
	        }
	    });
	}
	// TODO: remove in some future build
	if (false) {
	    var warnedAboutDefaultExport_1 = false;
	    Object.defineProperty(module.exports, "default", {
	        enumerable: false,
	        get: function () {
	            if (!warnedAboutDefaultExport_1) {
	                warnedAboutDefaultExport_1 = true;
	                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
	            }
	            return undefined;
	        }
	    });
	    [
	        "extras",
	        "Atom",
	        "BaseAtom",
	        "asFlat",
	        "asMap",
	        "asReference",
	        "asStructure",
	        "autorunAsync",
	        "createTranformer",
	        "expr",
	        "isModifierDescriptor",
	        "isStrictModeEnabled",
	        "map",
	        "useStrict",
	        "whyRun"
	    ].forEach(function (prop) {
	        Object.defineProperty(module.exports, prop, {
	            enumerable: false,
	            get: function () {
	                fail$1("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
	            },
	            set: function () { }
	        });
	    });
	}
	
	exports.Reaction = Reaction;
	exports.untracked = untracked;
	exports.createAtom = createAtom;
	exports.spy = spy;
	exports.comparer = comparer;
	exports.isObservableObject = isObservableObject;
	exports.isBoxedObservable = isObservableValue;
	exports.isObservableArray = isObservableArray;
	exports.ObservableMap = ObservableMap;
	exports.isObservableMap = isObservableMap;
	exports.transaction = transaction;
	exports.observable = observable;
	exports.computed = computed;
	exports.isObservable = isObservable;
	exports.isObservableProp = isObservableProp;
	exports.isComputed = isComputed;
	exports.isComputedProp = isComputedProp;
	exports.extendObservable = extendObservable;
	exports.extendShallowObservable = extendShallowObservable;
	exports.observe = observe;
	exports.intercept = intercept;
	exports.autorun = autorun;
	exports.reaction = reaction;
	exports.when = when;
	exports.action = action;
	exports.isAction = isAction;
	exports.runInAction = runInAction;
	exports.keys = keys;
	exports.values = values;
	exports.set = set;
	exports.remove = remove;
	exports.has = has$1;
	exports.get = get;
	exports.decorate = decorate;
	exports.configure = configure;
	exports.onBecomeObserved = onBecomeObserved;
	exports.onBecomeUnobserved = onBecomeUnobserved;
	exports.flow = flow;
	exports.toJS = toJS;
	exports.trace = trace;
	exports.getDependencyTree = getDependencyTree;
	exports.getObserverTree = getObserverTree;
	exports._resetGlobalState = resetGlobalState;
	exports._getGlobalState = getGlobalState;
	exports.getDebugName = getDebugName;
	exports.getAtom = getAtom;
	exports._getAdministration = getAdministration;
	exports._allowStateChanges = allowStateChanges;
	exports.isArrayLike = isArrayLike;
	exports._isComputingDerivation = isComputingDerivation;
	exports.onReactionError = onReactionError;
	exports._interceptReads = interceptReads;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), (function() { return this; }())))

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(11)))

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(107);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_dom_1 = __webpack_require__(13);
	__webpack_require__(101);
	
	var Overlay = function (_React$PureComponent) {
	    _inherits(Overlay, _React$PureComponent);
	
	    function Overlay() {
	        _classCallCheck(this, Overlay);
	
	        var _this = _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	
	        _this.escFn = function (e) {
	            if (e.keyCode === 27) {
	                _this.props.closeCallback();
	            }
	        };
	        return _this;
	    }
	
	    Overlay.prototype.componentDidMount = function componentDidMount() {
	        document.addEventListener('keydown', this.escFn, false);
	    };
	
	    Overlay.prototype.componentWillUnmount = function componentWillUnmount() {
	        document.removeEventListener('keydown', this.escFn, false);
	    };
	
	    Overlay.prototype.render = function render() {
	        var _props = this.props,
	            visible = _props.visible,
	            closeCallback = _props.closeCallback;
	
	        return visible ? react_dom_1.createPortal(React.createElement("div", { className: "overlay" }, React.createElement("div", { className: "overlay__closebg", onClick: closeCallback }), this.props.children), document.getElementById('___gatsby')) : null;
	    };
	
	    return Overlay;
	}(React.PureComponent);
	
	exports.default = Overlay;

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var PrimaryButton_1 = __webpack_require__(16);
	var SecondaryButton_1 = __webpack_require__(45);
	var Overlay_1 = __webpack_require__(65);
	__webpack_require__(329);
	var TopLevelError = function (_React$Component) {
	    _inherits(TopLevelError, _React$Component);
	
	    function TopLevelError() {
	        _classCallCheck(this, TopLevelError);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.closeCallback = function () {
	            var store = _this.injected.store;
	
	            if (store.topLevelError.hasFix) {
	                store.tryTopLevelErrorFix();
	            }
	        };
	        _this.refreshPage = function () {
	            location.reload();
	        };
	        return _this;
	    }
	
	    TopLevelError.prototype.render = function render() {
	        var store = this.injected.store;
	
	        if (store.topLevelError) {
	            return React.createElement(Overlay_1.default, { visible: Boolean(store.topLevelError), closeCallback: this.closeCallback }, React.createElement("div", { className: "toplevelerror theme--yellow" }, React.createElement("img", { src: __webpack_require__(366), alt: "Sad face emoji" }), React.createElement("h1", null, "Something went wrong!"), React.createElement("p", null, "We've been notified about this error and will fix it as soon as possible."), React.createElement("div", { className: "toplevelerror__message" }, React.createElement("h3", null, "Error Message"), React.createElement("p", null, store.topLevelError.text)), store.topLevelError.hasFix ? React.createElement(PrimaryButton_1.default, { text: "Try to fix it", callback: store.tryTopLevelErrorFix }) : React.createElement(SecondaryButton_1.default, { text: "Refresh Page", callback: this.refreshPage })
	            // <p className="toplevelerror__refresh"><small>Refresh to try again</small></p>
	            ));
	        }
	        return React.createElement("div", null);
	    };
	
	    _createClass(TopLevelError, [{
	        key: "injected",
	        get: function get() {
	            return this.props;
	        }
	    }]);
	
	    return TopLevelError;
	}(React.Component);
	TopLevelError = __decorate([mobx_react_1.inject('store'), mobx_react_1.observer], TopLevelError);
	exports.default = TopLevelError;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.COLORS = ['#F44336', '#E91E63', '#673AB7', '#2196F3', '#8BC34A', '#FFC107', '#FF9800', '#FF5722'];
	exports.CARD_MOVEMENT_DISTANCE = 200;
	exports.CARD_ROTATION_AMOUNT = 15;
	// export const SCRIPT_PATH = 'script.json';
	// Percentage Circle
	exports.MIN_PERCENTAGE = 0;
	exports.MAX_PERCENTAGE = 100;
	// Mailchimp
	exports.mailchimpURL = 'https://wearesupportive.us18.list-manage.com/subscribe/post?u=40067302b02edea4063b16716&amp;id=7e19c9a7b6';

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_devtools_mst_1 = __webpack_require__(320);
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(22);
	var TopLevelError_1 = __webpack_require__(165);
	__webpack_require__(330);
	var player_1 = __webpack_require__(17);
	var root_1 = __webpack_require__(167);
	var script_1 = __webpack_require__(47);
	var rootStore = root_1.RootStore.create({
	    player: player_1.PlayerStore.create(),
	    script: script_1.ScriptStore.create()
	});
	if (false) {
	    mobx_devtools_mst_1.default(rootStore);
	}
	var Layout = function Layout(props) {
	    return React.createElement(mobx_react_1.Provider, { store: rootStore }, React.createElement("div", { className: "app" }, React.createElement(react_helmet_1.default, { defaultTitle: 'Supportive - Guided Audio Conversations for Pairs', titleTemplate: "%s - Supportive" }), React.createElement("div", { className: "beta" }), React.createElement(TopLevelError_1.default, null), props.children(), React.createElement("footer", { className: "footer" }, React.createElement("div", { className: "footer__content" }, React.createElement("span", { className: "tiny_subtext" }, React.createElement("img", { className: "footer__logo", src: __webpack_require__(148), alt: "" }), "\xA9 2018")))));
	};
	exports.default = Layout;

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_state_tree_1 = __webpack_require__(21);
	var constants_1 = __webpack_require__(36);
	var PlayerState;
	(function (PlayerState) {
	    PlayerState["inactive"] = "inactive";
	    PlayerState["loading"] = "loading";
	    PlayerState["loaded"] = "loaded";
	    PlayerState["playing"] = "playing";
	    PlayerState["paused"] = "paused";
	    PlayerState["ended"] = "ended";
	    PlayerState["completed"] = "completed";
	})(PlayerState = exports.PlayerState || (exports.PlayerState = {}));
	exports.PlayerStore = mobx_state_tree_1.types.model('PlayerStore', {
	    cardIndex: 0,
	    eventIndex: 0,
	    playerOneColor: '#000',
	    playerTwoColor: '#000',
	    progressPercentage: 0,
	    state: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.enumeration('PlayerState', Object.keys(PlayerState)), PlayerState.inactive)
	}).actions(function (self) {
	    var actions = {
	        reset: function reset() {
	            self.state = PlayerState.inactive;
	            self.cardIndex = 0;
	            self.eventIndex = 0;
	            self.progressPercentage = 0;
	            self.playerOneColor = '#000';
	            self.playerTwoColor = '#000';
	        },
	        setPlayerState: function setPlayerState(newState) {
	            self.state = newState;
	        },
	        setCardIndex: function setCardIndex(index) {
	            self.cardIndex = index;
	        },
	        setEventIndex: function setEventIndex(index) {
	            self.eventIndex = index;
	        },
	        updateProgressPercentage: function updateProgressPercentage(percentage) {
	            percentage = Math.max(0, percentage);
	            percentage = Math.min(100, percentage);
	            self.progressPercentage = percentage;
	        },
	        loadRandomPlayerColors: function loadRandomPlayerColors() {
	            var color = constants_1.COLORS[Math.floor(Math.random() * constants_1.COLORS.length)];
	            var color2 = constants_1.COLORS[Math.floor(Math.random() * constants_1.COLORS.length)];
	            while (color2 === color) {
	                color2 = constants_1.COLORS[Math.floor(Math.random() * constants_1.COLORS.length)];
	            }
	            self.playerOneColor = color;
	            self.playerTwoColor = color2;
	        }
	    };
	    return actions;
	});

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_state_tree_1 = __webpack_require__(21);
	var ga_1 = __webpack_require__(46);
	var player_1 = __webpack_require__(17);
	var script_1 = __webpack_require__(47);
	exports.TopLevelError = mobx_state_tree_1.types.model('TopLevelError', {
	    hasFix: false,
	    text: mobx_state_tree_1.types.string
	});
	exports.RootStore = mobx_state_tree_1.types.model('RootStore', {
	    player: player_1.PlayerStore,
	    script: script_1.ScriptStore,
	    topLevelError: mobx_state_tree_1.types.maybe(exports.TopLevelError)
	}).views(function (self) {
	    return {
	        get activeCard() {
	            if (!self.script.data) {
	                return null;
	            }
	            if (self.script.data.sequence.length > self.player.cardIndex) {
	                return self.script.data.sequence[self.player.cardIndex];
	            }
	        },
	        get visibleCards() {
	            if (!self.script.data) {
	                return [];
	            }
	            return self.script.data.sequence.slice(self.player.cardIndex);
	        }
	    };
	}).views(function (self) {
	    return {
	        get activeEvent() {
	            if (!self.script.data || !self.activeCard) {
	                return null;
	            }
	            var event = self.activeCard.events[self.player.eventIndex];
	            return event;
	        },
	        get nextEventInCard() {
	            // Check if next event is in current card
	            if (self.activeCard) {
	                var nextEventExists = self.player.eventIndex + 1 < self.activeCard.events.length;
	                if (nextEventExists) {
	                    return self.activeCard.events[self.player.eventIndex + 1];
	                }
	            }
	            return null;
	        },
	        get prevCard() {
	            if (self.script.data) {
	                var prevCardExists = self.player.cardIndex > 0 && self.script.data.sequence[self.player.cardIndex - 1];
	                if (prevCardExists) {
	                    return self.script.data.sequence[self.player.cardIndex - 1];
	                }
	            }
	            return null;
	        },
	        get nextCard() {
	            // Check if next card's event exists
	            if (self.script.data) {
	                var nextCardExists = self.player.cardIndex + 1 < self.script.data.sequence.length;
	                if (nextCardExists) {
	                    return self.script.data.sequence[self.player.cardIndex + 1];
	                }
	            }
	            return null;
	        }
	    };
	}).actions(function (self) {
	    // Store a callback to any thrown errors
	    var topLevelErrorFixCallback = void 0;
	    var actions = {
	        resetModule: function resetModule() {
	            self.script.reset();
	            self.player.reset();
	        },
	        loadModule: function loadModule(script) {
	            self.script.data = script;
	            self.script.state = script_1.ScriptState.loaded;
	        },
	        throwTopLevelError: function throwTopLevelError(error, fixCallback) {
	            if (!error) {
	                throw new Error('Invalid arguments: no error');
	            }
	            if (fixCallback) {
	                topLevelErrorFixCallback = fixCallback;
	            }
	            ga_1.GASendEvent('error', 'throw', error);
	            self.topLevelError = exports.TopLevelError.create({
	                hasFix: fixCallback ? true : false,
	                text: error
	            });
	        },
	        destroyTopLevelError: function destroyTopLevelError() {
	            mobx_state_tree_1.destroy(self.topLevelError);
	        },
	        tryTopLevelErrorFix: function tryTopLevelErrorFix() {
	            return new Promise(function (resolve, reject) {
	                if (!topLevelErrorFixCallback) {
	                    self.throwTopLevelError('RootStore failed to call error fix callback, as it is not defined');
	                    resolve();
	                    return;
	                }
	                var originalError = self.topLevelError.text;
	                topLevelErrorFixCallback().then(function () {
	                    self.destroyTopLevelError();
	                    resolve();
	                }).catch(function (error) {
	                    self.destroyTopLevelError();
	                    self.throwTopLevelError("We tried, but failed to automatically fix this error: " + originalError);
	                    reject();
	                });
	                topLevelErrorFixCallback = null;
	            });
	        },
	        undoCompleteEvent: function undoCompleteEvent() {
	            self.player.state = player_1.PlayerState.ended;
	            self.player.progressPercentage = 0;
	            if (self.prevCard) {
	                self.player.cardIndex -= 1;
	            }
	        },
	        completeEvent: function completeEvent() {
	            self.player.state = player_1.PlayerState.ended;
	            self.player.progressPercentage = 0;
	            ga_1.GASendEvent('module', 'cardend', self.script.data.shortname, self.player.cardIndex);
	            if (self.nextEventInCard) {
	                self.player.eventIndex += 1;
	                return;
	            }
	            if (self.nextCard) {
	                self.player.cardIndex += 1;
	                self.player.eventIndex = 0;
	                return;
	            }
	            // No more events or cards available
	            self.player.cardIndex += 1;
	            self.player.eventIndex = 0;
	            self.player.state = player_1.PlayerState.completed;
	            ga_1.GASendEvent('module', 'completed', self.script.data.shortname);
	        }
	    };
	    return actions;
	});

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_state_tree_1 = __webpack_require__(21);
	exports.SequenceEvent = mobx_state_tree_1.types.model('SequenceAudioEvent', {
	    extraTime: 0,
	    fileName: mobx_state_tree_1.types.string,
	    length: mobx_state_tree_1.types.number,
	    type: mobx_state_tree_1.types.literal('audio')
	});
	var SequenceIcon;
	(function (SequenceIcon) {
	    SequenceIcon["intro"] = "intro";
	    SequenceIcon["meditation"] = "meditation";
	    SequenceIcon["quote"] = "quote";
	    SequenceIcon["silence"] = "silence";
	    SequenceIcon["setup"] = "setup";
	    SequenceIcon["question"] = "question";
	    SequenceIcon["ending"] = "ending";
	    SequenceIcon["mailinglist"] = "mailinglist";
	    SequenceIcon["partner"] = "partner";
	})(SequenceIcon = exports.SequenceIcon || (exports.SequenceIcon = {}));
	exports.SequenceItem = mobx_state_tree_1.types.model('SequenceItem', {
	    events: mobx_state_tree_1.types.array(exports.SequenceEvent),
	    icon: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.enumeration('Icon', Object.keys(SequenceIcon))),
	    image: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
	    partner: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.union(mobx_state_tree_1.types.literal('one'), mobx_state_tree_1.types.literal('two'))),
	    source: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
	    title: mobx_state_tree_1.types.string
	}).views(function (self) {
	    return {
	        get totalLength() {
	            return self.events.reduce(function (sum, event) {
	                return sum + event.length;
	            }, 0);
	        }
	    };
	});
	exports.ModuleDetails = mobx_state_tree_1.types.model('ModuleDetails', {
	    textIntro: mobx_state_tree_1.types.string,
	    textSell: mobx_state_tree_1.types.string,
	    textStart: mobx_state_tree_1.types.string,
	    title: mobx_state_tree_1.types.string
	});
	exports.Script = mobx_state_tree_1.types.model('Module', {
	    details: exports.ModuleDetails,
	    sequence: mobx_state_tree_1.types.array(exports.SequenceItem),
	    shortname: mobx_state_tree_1.types.string
	}).views(function (self) {
	    return {
	        get totalLength() {
	            var total = self.sequence.reduce(function (sum, item) {
	                return sum + item.totalLength;
	            }, 0);
	            return Math.floor(total);
	        },
	        get cardCount() {
	            var filteredCards = self.sequence.filter(function (item) {
	                return !item.partner;
	            });
	            return filteredCards.length;
	        }
	    };
	});
	var ScriptState;
	(function (ScriptState) {
	    ScriptState["inactive"] = "inactive";
	    ScriptState["loading"] = "loading";
	    ScriptState["loaded"] = "loaded";
	    ScriptState["error"] = "error";
	})(ScriptState = exports.ScriptState || (exports.ScriptState = {}));
	exports.ScriptStore = mobx_state_tree_1.types.model('ScriptStore', {
	    data: mobx_state_tree_1.types.maybe(exports.Script),
	    state: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.enumeration('ScriptState', Object.keys(ScriptState)), ScriptState.inactive)
	}).actions(function (self) {
	    return {
	        reset: function reset() {
	            self.data = null;
	            self.state = ScriptState.inactive;
	        }
	    };
	});

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-tsx-e4a5c828dc417d8823ad.js